import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
	{ [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
	{ [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string
	String: string
	Boolean: boolean
	Int: number
	Float: number
	BigDecimal: any
	BigInt: any
	Bytes: any
}

export type AccessControl = {
	__typename?: "AccessControl"
	asAccount: Account
	id: Scalars["ID"]
	roles: Array<AccessControlRole>
}

export type AccessControlRolesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRole_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<AccessControlRole_Filter>
}

export type AccessControlRole = {
	__typename?: "AccessControlRole"
	admin: AccessControlRole
	adminOf: Array<AccessControlRole>
	contract: AccessControl
	id: Scalars["ID"]
	members: Array<AccessControlRoleMember>
	role: Role
	roleAdminChanged: Array<RoleAdminChanged>
	roleGranted: Array<RoleGranted>
	roleRevoked: Array<RoleRevoked>
}

export type AccessControlRoleAdminOfArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRole_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<AccessControlRole_Filter>
}

export type AccessControlRoleMembersArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRoleMember_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<AccessControlRoleMember_Filter>
}

export type AccessControlRoleRoleAdminChangedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleAdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleAdminChanged_Filter>
}

export type AccessControlRoleRoleGrantedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleGranted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleGranted_Filter>
}

export type AccessControlRoleRoleRevokedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleRevoked_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleRevoked_Filter>
}

export type AccessControlRoleMember = {
	__typename?: "AccessControlRoleMember"
	accesscontrolrole: AccessControlRole
	account: Account
	id: Scalars["ID"]
}

export type AccessControlRoleMember_Filter = {
	accesscontrolrole?: InputMaybe<Scalars["String"]>
	accesscontrolrole_contains?: InputMaybe<Scalars["String"]>
	accesscontrolrole_contains_nocase?: InputMaybe<Scalars["String"]>
	accesscontrolrole_ends_with?: InputMaybe<Scalars["String"]>
	accesscontrolrole_ends_with_nocase?: InputMaybe<Scalars["String"]>
	accesscontrolrole_gt?: InputMaybe<Scalars["String"]>
	accesscontrolrole_gte?: InputMaybe<Scalars["String"]>
	accesscontrolrole_in?: InputMaybe<Array<Scalars["String"]>>
	accesscontrolrole_lt?: InputMaybe<Scalars["String"]>
	accesscontrolrole_lte?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not_contains?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not_contains_nocase?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not_ends_with?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not_in?: InputMaybe<Array<Scalars["String"]>>
	accesscontrolrole_not_starts_with?: InputMaybe<Scalars["String"]>
	accesscontrolrole_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	accesscontrolrole_starts_with?: InputMaybe<Scalars["String"]>
	accesscontrolrole_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account?: InputMaybe<Scalars["String"]>
	account_contains?: InputMaybe<Scalars["String"]>
	account_contains_nocase?: InputMaybe<Scalars["String"]>
	account_ends_with?: InputMaybe<Scalars["String"]>
	account_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_gt?: InputMaybe<Scalars["String"]>
	account_gte?: InputMaybe<Scalars["String"]>
	account_in?: InputMaybe<Array<Scalars["String"]>>
	account_lt?: InputMaybe<Scalars["String"]>
	account_lte?: InputMaybe<Scalars["String"]>
	account_not?: InputMaybe<Scalars["String"]>
	account_not_contains?: InputMaybe<Scalars["String"]>
	account_not_contains_nocase?: InputMaybe<Scalars["String"]>
	account_not_ends_with?: InputMaybe<Scalars["String"]>
	account_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_not_in?: InputMaybe<Array<Scalars["String"]>>
	account_not_starts_with?: InputMaybe<Scalars["String"]>
	account_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account_starts_with?: InputMaybe<Scalars["String"]>
	account_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum AccessControlRoleMember_OrderBy {
	Accesscontrolrole = "accesscontrolrole",
	Account = "account",
	Id = "id",
}

export type AccessControlRole_Filter = {
	admin?: InputMaybe<Scalars["String"]>
	admin_contains?: InputMaybe<Scalars["String"]>
	admin_contains_nocase?: InputMaybe<Scalars["String"]>
	admin_ends_with?: InputMaybe<Scalars["String"]>
	admin_ends_with_nocase?: InputMaybe<Scalars["String"]>
	admin_gt?: InputMaybe<Scalars["String"]>
	admin_gte?: InputMaybe<Scalars["String"]>
	admin_in?: InputMaybe<Array<Scalars["String"]>>
	admin_lt?: InputMaybe<Scalars["String"]>
	admin_lte?: InputMaybe<Scalars["String"]>
	admin_not?: InputMaybe<Scalars["String"]>
	admin_not_contains?: InputMaybe<Scalars["String"]>
	admin_not_contains_nocase?: InputMaybe<Scalars["String"]>
	admin_not_ends_with?: InputMaybe<Scalars["String"]>
	admin_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	admin_not_in?: InputMaybe<Array<Scalars["String"]>>
	admin_not_starts_with?: InputMaybe<Scalars["String"]>
	admin_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	admin_starts_with?: InputMaybe<Scalars["String"]>
	admin_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	role?: InputMaybe<Scalars["String"]>
	role_contains?: InputMaybe<Scalars["String"]>
	role_contains_nocase?: InputMaybe<Scalars["String"]>
	role_ends_with?: InputMaybe<Scalars["String"]>
	role_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_gt?: InputMaybe<Scalars["String"]>
	role_gte?: InputMaybe<Scalars["String"]>
	role_in?: InputMaybe<Array<Scalars["String"]>>
	role_lt?: InputMaybe<Scalars["String"]>
	role_lte?: InputMaybe<Scalars["String"]>
	role_not?: InputMaybe<Scalars["String"]>
	role_not_contains?: InputMaybe<Scalars["String"]>
	role_not_contains_nocase?: InputMaybe<Scalars["String"]>
	role_not_ends_with?: InputMaybe<Scalars["String"]>
	role_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_not_in?: InputMaybe<Array<Scalars["String"]>>
	role_not_starts_with?: InputMaybe<Scalars["String"]>
	role_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	role_starts_with?: InputMaybe<Scalars["String"]>
	role_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum AccessControlRole_OrderBy {
	Admin = "admin",
	AdminOf = "adminOf",
	Contract = "contract",
	Id = "id",
	Members = "members",
	Role = "role",
	RoleAdminChanged = "roleAdminChanged",
	RoleGranted = "roleGranted",
	RoleRevoked = "roleRevoked",
}

export type AccessControl_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum AccessControl_OrderBy {
	AsAccount = "asAccount",
	Id = "id",
	Roles = "roles",
}

export type Account = {
	__typename?: "Account"
	ERC20approvalsOwner: Array<Erc20Approval>
	ERC20approvalsSpender: Array<Erc20Approval>
	ERC20balances: Array<Erc20Balance>
	ERC20transferFromEvent: Array<Erc20Transfer>
	ERC20transferToEvent: Array<Erc20Transfer>
	ERC721operatorOperator: Array<Erc721Operator>
	ERC721operatorOwner: Array<Erc721Operator>
	ERC721tokens: Array<Erc721Token>
	ERC721transferFromEvent: Array<Erc721Transfer>
	ERC721transferToEvent: Array<Erc721Transfer>
	ERC1155balances: Array<Erc1155Balance>
	ERC1155operatorOperator: Array<Erc1155Operator>
	ERC1155operatorOwner: Array<Erc1155Operator>
	ERC1155transferFromEvent: Array<Erc1155Transfer>
	ERC1155transferOperatorEvent: Array<Erc1155Transfer>
	ERC1155transferToEvent: Array<Erc1155Transfer>
	ERC1967AdminChanged: Array<Erc1967AdminChanged>
	ERC1967AdminOfChanged: Array<Erc1967AdminChanged>
	ERC1967BeaconOfUpgraded: Array<Erc1967BeaconUpgraded>
	ERC1967BeaconUpgraded: Array<Erc1967BeaconUpgraded>
	ERC1967ImplementationOfUpgraded: Array<Erc1967ImplementationUpgraded>
	ERC1967ImplementationUpgraded: Array<Erc1967ImplementationUpgraded>
	asAccessControl?: Maybe<AccessControl>
	asERC20?: Maybe<Erc20Contract>
	asERC721?: Maybe<Erc721Contract>
	asERC1155?: Maybe<Erc1155Contract>
	asGovernor?: Maybe<Governor>
	asOwnable?: Maybe<Ownable>
	asPausable?: Maybe<Pausable>
	asTimelock?: Maybe<Timelock>
	asVoting?: Maybe<VotingContract>
	delegateChangedEvent: Array<DelegateChanged>
	delegateChangedFromEvent: Array<DelegateChanged>
	delegateChangedToEvent: Array<DelegateChanged>
	delegateVotesChangedEvent: Array<DelegateVotesChanged>
	delegationFrom: Array<VoteDelegation>
	delegationTo: Array<VoteDelegation>
	erc1967Admin?: Maybe<Account>
	erc1967AdminOf: Array<Account>
	erc1967Beacon?: Maybe<Account>
	erc1967BeaconOf: Array<Account>
	erc1967Implementation?: Maybe<Account>
	erc1967ImplementationOf: Array<Account>
	events: Array<Event>
	id: Scalars["ID"]
	membership: Array<AccessControlRoleMember>
	ownerOf: Array<Ownable>
	ownershipTransferred: Array<OwnershipTransferred>
	proposed: Array<Proposal>
	proposedCalls: Array<ProposalCall>
	roleGranted: Array<RoleGranted>
	roleGrantedSender: Array<RoleGranted>
	roleRevoked: Array<RoleRevoked>
	roleRevokedSender: Array<RoleRevoked>
	timelockedCalls: Array<TimelockCall>
	voteWeigth: Array<VoteWeight>
	voted: Array<VoteReceipt>
}

export type AccountErc20approvalsOwnerArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Approval_Filter>
}

export type AccountErc20approvalsSpenderArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Approval_Filter>
}

export type AccountErc20balancesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Balance_Filter>
}

export type AccountErc20transferFromEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type AccountErc20transferToEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type AccountErc721operatorOperatorArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Operator_Filter>
}

export type AccountErc721operatorOwnerArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Operator_Filter>
}

export type AccountErc721tokensArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Token_Filter>
}

export type AccountErc721transferFromEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Transfer_Filter>
}

export type AccountErc721transferToEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Transfer_Filter>
}

export type AccountErc1155balancesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Balance_Filter>
}

export type AccountErc1155operatorOperatorArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Operator_Filter>
}

export type AccountErc1155operatorOwnerArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Operator_Filter>
}

export type AccountErc1155transferFromEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type AccountErc1155transferOperatorEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type AccountErc1155transferToEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type AccountErc1967AdminChangedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967AdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1967AdminChanged_Filter>
}

export type AccountErc1967AdminOfChangedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967AdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1967AdminChanged_Filter>
}

export type AccountErc1967BeaconOfUpgradedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967BeaconUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1967BeaconUpgraded_Filter>
}

export type AccountErc1967BeaconUpgradedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967BeaconUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1967BeaconUpgraded_Filter>
}

export type AccountErc1967ImplementationOfUpgradedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967ImplementationUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1967ImplementationUpgraded_Filter>
}

export type AccountErc1967ImplementationUpgradedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967ImplementationUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1967ImplementationUpgraded_Filter>
}

export type AccountDelegateChangedEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateChanged_Filter>
}

export type AccountDelegateChangedFromEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateChanged_Filter>
}

export type AccountDelegateChangedToEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateChanged_Filter>
}

export type AccountDelegateVotesChangedEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateVotesChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateVotesChanged_Filter>
}

export type AccountDelegationFromArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteDelegation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteDelegation_Filter>
}

export type AccountDelegationToArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteDelegation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteDelegation_Filter>
}

export type AccountErc1967AdminOfArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Account_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Account_Filter>
}

export type AccountErc1967BeaconOfArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Account_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Account_Filter>
}

export type AccountErc1967ImplementationOfArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Account_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Account_Filter>
}

export type AccountEventsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Event_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Event_Filter>
}

export type AccountMembershipArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRoleMember_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<AccessControlRoleMember_Filter>
}

export type AccountOwnerOfArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Ownable_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Ownable_Filter>
}

export type AccountOwnershipTransferredArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<OwnershipTransferred_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<OwnershipTransferred_Filter>
}

export type AccountProposedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Proposal_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Proposal_Filter>
}

export type AccountProposedCallsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalCall_Filter>
}

export type AccountRoleGrantedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleGranted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleGranted_Filter>
}

export type AccountRoleGrantedSenderArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleGranted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleGranted_Filter>
}

export type AccountRoleRevokedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleRevoked_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleRevoked_Filter>
}

export type AccountRoleRevokedSenderArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleRevoked_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<RoleRevoked_Filter>
}

export type AccountTimelockedCallsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockCall_Filter>
}

export type AccountVoteWeigthArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteWeight_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteWeight_Filter>
}

export type AccountVotedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteReceipt_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteReceipt_Filter>
}

export type Account_Filter = {
	asAccessControl?: InputMaybe<Scalars["String"]>
	asAccessControl_contains?: InputMaybe<Scalars["String"]>
	asAccessControl_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccessControl_ends_with?: InputMaybe<Scalars["String"]>
	asAccessControl_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccessControl_gt?: InputMaybe<Scalars["String"]>
	asAccessControl_gte?: InputMaybe<Scalars["String"]>
	asAccessControl_in?: InputMaybe<Array<Scalars["String"]>>
	asAccessControl_lt?: InputMaybe<Scalars["String"]>
	asAccessControl_lte?: InputMaybe<Scalars["String"]>
	asAccessControl_not?: InputMaybe<Scalars["String"]>
	asAccessControl_not_contains?: InputMaybe<Scalars["String"]>
	asAccessControl_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccessControl_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccessControl_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccessControl_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccessControl_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccessControl_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccessControl_starts_with?: InputMaybe<Scalars["String"]>
	asAccessControl_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asERC20?: InputMaybe<Scalars["String"]>
	asERC20_contains?: InputMaybe<Scalars["String"]>
	asERC20_contains_nocase?: InputMaybe<Scalars["String"]>
	asERC20_ends_with?: InputMaybe<Scalars["String"]>
	asERC20_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asERC20_gt?: InputMaybe<Scalars["String"]>
	asERC20_gte?: InputMaybe<Scalars["String"]>
	asERC20_in?: InputMaybe<Array<Scalars["String"]>>
	asERC20_lt?: InputMaybe<Scalars["String"]>
	asERC20_lte?: InputMaybe<Scalars["String"]>
	asERC20_not?: InputMaybe<Scalars["String"]>
	asERC20_not_contains?: InputMaybe<Scalars["String"]>
	asERC20_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asERC20_not_ends_with?: InputMaybe<Scalars["String"]>
	asERC20_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asERC20_not_in?: InputMaybe<Array<Scalars["String"]>>
	asERC20_not_starts_with?: InputMaybe<Scalars["String"]>
	asERC20_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asERC20_starts_with?: InputMaybe<Scalars["String"]>
	asERC20_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asERC721?: InputMaybe<Scalars["String"]>
	asERC721_contains?: InputMaybe<Scalars["String"]>
	asERC721_contains_nocase?: InputMaybe<Scalars["String"]>
	asERC721_ends_with?: InputMaybe<Scalars["String"]>
	asERC721_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asERC721_gt?: InputMaybe<Scalars["String"]>
	asERC721_gte?: InputMaybe<Scalars["String"]>
	asERC721_in?: InputMaybe<Array<Scalars["String"]>>
	asERC721_lt?: InputMaybe<Scalars["String"]>
	asERC721_lte?: InputMaybe<Scalars["String"]>
	asERC721_not?: InputMaybe<Scalars["String"]>
	asERC721_not_contains?: InputMaybe<Scalars["String"]>
	asERC721_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asERC721_not_ends_with?: InputMaybe<Scalars["String"]>
	asERC721_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asERC721_not_in?: InputMaybe<Array<Scalars["String"]>>
	asERC721_not_starts_with?: InputMaybe<Scalars["String"]>
	asERC721_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asERC721_starts_with?: InputMaybe<Scalars["String"]>
	asERC721_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asERC1155?: InputMaybe<Scalars["String"]>
	asERC1155_contains?: InputMaybe<Scalars["String"]>
	asERC1155_contains_nocase?: InputMaybe<Scalars["String"]>
	asERC1155_ends_with?: InputMaybe<Scalars["String"]>
	asERC1155_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asERC1155_gt?: InputMaybe<Scalars["String"]>
	asERC1155_gte?: InputMaybe<Scalars["String"]>
	asERC1155_in?: InputMaybe<Array<Scalars["String"]>>
	asERC1155_lt?: InputMaybe<Scalars["String"]>
	asERC1155_lte?: InputMaybe<Scalars["String"]>
	asERC1155_not?: InputMaybe<Scalars["String"]>
	asERC1155_not_contains?: InputMaybe<Scalars["String"]>
	asERC1155_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asERC1155_not_ends_with?: InputMaybe<Scalars["String"]>
	asERC1155_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asERC1155_not_in?: InputMaybe<Array<Scalars["String"]>>
	asERC1155_not_starts_with?: InputMaybe<Scalars["String"]>
	asERC1155_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asERC1155_starts_with?: InputMaybe<Scalars["String"]>
	asERC1155_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asGovernor?: InputMaybe<Scalars["String"]>
	asGovernor_contains?: InputMaybe<Scalars["String"]>
	asGovernor_contains_nocase?: InputMaybe<Scalars["String"]>
	asGovernor_ends_with?: InputMaybe<Scalars["String"]>
	asGovernor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asGovernor_gt?: InputMaybe<Scalars["String"]>
	asGovernor_gte?: InputMaybe<Scalars["String"]>
	asGovernor_in?: InputMaybe<Array<Scalars["String"]>>
	asGovernor_lt?: InputMaybe<Scalars["String"]>
	asGovernor_lte?: InputMaybe<Scalars["String"]>
	asGovernor_not?: InputMaybe<Scalars["String"]>
	asGovernor_not_contains?: InputMaybe<Scalars["String"]>
	asGovernor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asGovernor_not_ends_with?: InputMaybe<Scalars["String"]>
	asGovernor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asGovernor_not_in?: InputMaybe<Array<Scalars["String"]>>
	asGovernor_not_starts_with?: InputMaybe<Scalars["String"]>
	asGovernor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asGovernor_starts_with?: InputMaybe<Scalars["String"]>
	asGovernor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asOwnable?: InputMaybe<Scalars["String"]>
	asOwnable_contains?: InputMaybe<Scalars["String"]>
	asOwnable_contains_nocase?: InputMaybe<Scalars["String"]>
	asOwnable_ends_with?: InputMaybe<Scalars["String"]>
	asOwnable_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asOwnable_gt?: InputMaybe<Scalars["String"]>
	asOwnable_gte?: InputMaybe<Scalars["String"]>
	asOwnable_in?: InputMaybe<Array<Scalars["String"]>>
	asOwnable_lt?: InputMaybe<Scalars["String"]>
	asOwnable_lte?: InputMaybe<Scalars["String"]>
	asOwnable_not?: InputMaybe<Scalars["String"]>
	asOwnable_not_contains?: InputMaybe<Scalars["String"]>
	asOwnable_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asOwnable_not_ends_with?: InputMaybe<Scalars["String"]>
	asOwnable_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asOwnable_not_in?: InputMaybe<Array<Scalars["String"]>>
	asOwnable_not_starts_with?: InputMaybe<Scalars["String"]>
	asOwnable_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asOwnable_starts_with?: InputMaybe<Scalars["String"]>
	asOwnable_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asPausable?: InputMaybe<Scalars["String"]>
	asPausable_contains?: InputMaybe<Scalars["String"]>
	asPausable_contains_nocase?: InputMaybe<Scalars["String"]>
	asPausable_ends_with?: InputMaybe<Scalars["String"]>
	asPausable_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asPausable_gt?: InputMaybe<Scalars["String"]>
	asPausable_gte?: InputMaybe<Scalars["String"]>
	asPausable_in?: InputMaybe<Array<Scalars["String"]>>
	asPausable_lt?: InputMaybe<Scalars["String"]>
	asPausable_lte?: InputMaybe<Scalars["String"]>
	asPausable_not?: InputMaybe<Scalars["String"]>
	asPausable_not_contains?: InputMaybe<Scalars["String"]>
	asPausable_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asPausable_not_ends_with?: InputMaybe<Scalars["String"]>
	asPausable_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asPausable_not_in?: InputMaybe<Array<Scalars["String"]>>
	asPausable_not_starts_with?: InputMaybe<Scalars["String"]>
	asPausable_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asPausable_starts_with?: InputMaybe<Scalars["String"]>
	asPausable_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asTimelock?: InputMaybe<Scalars["String"]>
	asTimelock_contains?: InputMaybe<Scalars["String"]>
	asTimelock_contains_nocase?: InputMaybe<Scalars["String"]>
	asTimelock_ends_with?: InputMaybe<Scalars["String"]>
	asTimelock_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asTimelock_gt?: InputMaybe<Scalars["String"]>
	asTimelock_gte?: InputMaybe<Scalars["String"]>
	asTimelock_in?: InputMaybe<Array<Scalars["String"]>>
	asTimelock_lt?: InputMaybe<Scalars["String"]>
	asTimelock_lte?: InputMaybe<Scalars["String"]>
	asTimelock_not?: InputMaybe<Scalars["String"]>
	asTimelock_not_contains?: InputMaybe<Scalars["String"]>
	asTimelock_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asTimelock_not_ends_with?: InputMaybe<Scalars["String"]>
	asTimelock_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asTimelock_not_in?: InputMaybe<Array<Scalars["String"]>>
	asTimelock_not_starts_with?: InputMaybe<Scalars["String"]>
	asTimelock_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asTimelock_starts_with?: InputMaybe<Scalars["String"]>
	asTimelock_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asVoting?: InputMaybe<Scalars["String"]>
	asVoting_contains?: InputMaybe<Scalars["String"]>
	asVoting_contains_nocase?: InputMaybe<Scalars["String"]>
	asVoting_ends_with?: InputMaybe<Scalars["String"]>
	asVoting_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asVoting_gt?: InputMaybe<Scalars["String"]>
	asVoting_gte?: InputMaybe<Scalars["String"]>
	asVoting_in?: InputMaybe<Array<Scalars["String"]>>
	asVoting_lt?: InputMaybe<Scalars["String"]>
	asVoting_lte?: InputMaybe<Scalars["String"]>
	asVoting_not?: InputMaybe<Scalars["String"]>
	asVoting_not_contains?: InputMaybe<Scalars["String"]>
	asVoting_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asVoting_not_ends_with?: InputMaybe<Scalars["String"]>
	asVoting_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asVoting_not_in?: InputMaybe<Array<Scalars["String"]>>
	asVoting_not_starts_with?: InputMaybe<Scalars["String"]>
	asVoting_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asVoting_starts_with?: InputMaybe<Scalars["String"]>
	asVoting_starts_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Admin?: InputMaybe<Scalars["String"]>
	erc1967Admin_contains?: InputMaybe<Scalars["String"]>
	erc1967Admin_contains_nocase?: InputMaybe<Scalars["String"]>
	erc1967Admin_ends_with?: InputMaybe<Scalars["String"]>
	erc1967Admin_ends_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Admin_gt?: InputMaybe<Scalars["String"]>
	erc1967Admin_gte?: InputMaybe<Scalars["String"]>
	erc1967Admin_in?: InputMaybe<Array<Scalars["String"]>>
	erc1967Admin_lt?: InputMaybe<Scalars["String"]>
	erc1967Admin_lte?: InputMaybe<Scalars["String"]>
	erc1967Admin_not?: InputMaybe<Scalars["String"]>
	erc1967Admin_not_contains?: InputMaybe<Scalars["String"]>
	erc1967Admin_not_contains_nocase?: InputMaybe<Scalars["String"]>
	erc1967Admin_not_ends_with?: InputMaybe<Scalars["String"]>
	erc1967Admin_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Admin_not_in?: InputMaybe<Array<Scalars["String"]>>
	erc1967Admin_not_starts_with?: InputMaybe<Scalars["String"]>
	erc1967Admin_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Admin_starts_with?: InputMaybe<Scalars["String"]>
	erc1967Admin_starts_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Beacon?: InputMaybe<Scalars["String"]>
	erc1967Beacon_contains?: InputMaybe<Scalars["String"]>
	erc1967Beacon_contains_nocase?: InputMaybe<Scalars["String"]>
	erc1967Beacon_ends_with?: InputMaybe<Scalars["String"]>
	erc1967Beacon_ends_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Beacon_gt?: InputMaybe<Scalars["String"]>
	erc1967Beacon_gte?: InputMaybe<Scalars["String"]>
	erc1967Beacon_in?: InputMaybe<Array<Scalars["String"]>>
	erc1967Beacon_lt?: InputMaybe<Scalars["String"]>
	erc1967Beacon_lte?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not_contains?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not_contains_nocase?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not_ends_with?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not_in?: InputMaybe<Array<Scalars["String"]>>
	erc1967Beacon_not_starts_with?: InputMaybe<Scalars["String"]>
	erc1967Beacon_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Beacon_starts_with?: InputMaybe<Scalars["String"]>
	erc1967Beacon_starts_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Implementation?: InputMaybe<Scalars["String"]>
	erc1967Implementation_contains?: InputMaybe<Scalars["String"]>
	erc1967Implementation_contains_nocase?: InputMaybe<Scalars["String"]>
	erc1967Implementation_ends_with?: InputMaybe<Scalars["String"]>
	erc1967Implementation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Implementation_gt?: InputMaybe<Scalars["String"]>
	erc1967Implementation_gte?: InputMaybe<Scalars["String"]>
	erc1967Implementation_in?: InputMaybe<Array<Scalars["String"]>>
	erc1967Implementation_lt?: InputMaybe<Scalars["String"]>
	erc1967Implementation_lte?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not_contains?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not_ends_with?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not_in?: InputMaybe<Array<Scalars["String"]>>
	erc1967Implementation_not_starts_with?: InputMaybe<Scalars["String"]>
	erc1967Implementation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	erc1967Implementation_starts_with?: InputMaybe<Scalars["String"]>
	erc1967Implementation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Account_OrderBy {
	Erc20approvalsOwner = "ERC20approvalsOwner",
	Erc20approvalsSpender = "ERC20approvalsSpender",
	Erc20balances = "ERC20balances",
	Erc20transferFromEvent = "ERC20transferFromEvent",
	Erc20transferToEvent = "ERC20transferToEvent",
	Erc721operatorOperator = "ERC721operatorOperator",
	Erc721operatorOwner = "ERC721operatorOwner",
	Erc721tokens = "ERC721tokens",
	Erc721transferFromEvent = "ERC721transferFromEvent",
	Erc721transferToEvent = "ERC721transferToEvent",
	Erc1155balances = "ERC1155balances",
	Erc1155operatorOperator = "ERC1155operatorOperator",
	Erc1155operatorOwner = "ERC1155operatorOwner",
	Erc1155transferFromEvent = "ERC1155transferFromEvent",
	Erc1155transferOperatorEvent = "ERC1155transferOperatorEvent",
	Erc1155transferToEvent = "ERC1155transferToEvent",
	Erc1967AdminChanged = "ERC1967AdminChanged",
	Erc1967AdminOfChanged = "ERC1967AdminOfChanged",
	Erc1967BeaconOfUpgraded = "ERC1967BeaconOfUpgraded",
	Erc1967BeaconUpgraded = "ERC1967BeaconUpgraded",
	Erc1967ImplementationOfUpgraded = "ERC1967ImplementationOfUpgraded",
	Erc1967ImplementationUpgraded = "ERC1967ImplementationUpgraded",
	AsAccessControl = "asAccessControl",
	AsErc20 = "asERC20",
	AsErc721 = "asERC721",
	AsErc1155 = "asERC1155",
	AsGovernor = "asGovernor",
	AsOwnable = "asOwnable",
	AsPausable = "asPausable",
	AsTimelock = "asTimelock",
	AsVoting = "asVoting",
	DelegateChangedEvent = "delegateChangedEvent",
	DelegateChangedFromEvent = "delegateChangedFromEvent",
	DelegateChangedToEvent = "delegateChangedToEvent",
	DelegateVotesChangedEvent = "delegateVotesChangedEvent",
	DelegationFrom = "delegationFrom",
	DelegationTo = "delegationTo",
	Erc1967Admin = "erc1967Admin",
	Erc1967AdminOf = "erc1967AdminOf",
	Erc1967Beacon = "erc1967Beacon",
	Erc1967BeaconOf = "erc1967BeaconOf",
	Erc1967Implementation = "erc1967Implementation",
	Erc1967ImplementationOf = "erc1967ImplementationOf",
	Events = "events",
	Id = "id",
	Membership = "membership",
	OwnerOf = "ownerOf",
	OwnershipTransferred = "ownershipTransferred",
	Proposed = "proposed",
	ProposedCalls = "proposedCalls",
	RoleGranted = "roleGranted",
	RoleGrantedSender = "roleGrantedSender",
	RoleRevoked = "roleRevoked",
	RoleRevokedSender = "roleRevokedSender",
	TimelockedCalls = "timelockedCalls",
	VoteWeigth = "voteWeigth",
	Voted = "voted",
}

export type AddDelegate = {
	__typename?: "AddDelegate"
	delegate: Scalars["Bytes"]
	id: Scalars["ID"]
}

export type AddDelegate_Filter = {
	delegate?: InputMaybe<Scalars["Bytes"]>
	delegate_contains?: InputMaybe<Scalars["Bytes"]>
	delegate_in?: InputMaybe<Array<Scalars["Bytes"]>>
	delegate_not?: InputMaybe<Scalars["Bytes"]>
	delegate_not_contains?: InputMaybe<Scalars["Bytes"]>
	delegate_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum AddDelegate_OrderBy {
	Delegate = "delegate",
	Id = "id",
}

export type Approval = {
	__typename?: "Approval"
	id: Scalars["ID"]
	owner: Scalars["Bytes"]
	spender: Scalars["Bytes"]
	value: Scalars["BigInt"]
}

export type Approval_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	owner?: InputMaybe<Scalars["Bytes"]>
	owner_contains?: InputMaybe<Scalars["Bytes"]>
	owner_in?: InputMaybe<Array<Scalars["Bytes"]>>
	owner_not?: InputMaybe<Scalars["Bytes"]>
	owner_not_contains?: InputMaybe<Scalars["Bytes"]>
	owner_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	spender?: InputMaybe<Scalars["Bytes"]>
	spender_contains?: InputMaybe<Scalars["Bytes"]>
	spender_in?: InputMaybe<Array<Scalars["Bytes"]>>
	spender_not?: InputMaybe<Scalars["Bytes"]>
	spender_not_contains?: InputMaybe<Scalars["Bytes"]>
	spender_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	value?: InputMaybe<Scalars["BigInt"]>
	value_gt?: InputMaybe<Scalars["BigInt"]>
	value_gte?: InputMaybe<Scalars["BigInt"]>
	value_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_lt?: InputMaybe<Scalars["BigInt"]>
	value_lte?: InputMaybe<Scalars["BigInt"]>
	value_not?: InputMaybe<Scalars["BigInt"]>
	value_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum Approval_OrderBy {
	Id = "id",
	Owner = "owner",
	Spender = "spender",
	Value = "value",
}

/** The block at which the query should be executed. */
export type Block_Height = {
	/** Value containing a block hash */
	hash?: InputMaybe<Scalars["Bytes"]>
	/** Value containing a block number */
	number?: InputMaybe<Scalars["Int"]>
	/**
	 * Value containing the minimum block number.
	 * In the case of `number_gte`, the query will be executed on the latest block only if
	 * the subgraph has progressed to or past the minimum block number.
	 * Defaults to the latest block when omitted.
	 *
	 */
	number_gte?: InputMaybe<Scalars["Int"]>
}

export type ClaimBlocks = {
	__typename?: "ClaimBlocks"
	depositor: Scalars["Bytes"]
	farmerId: Scalars["BigInt"]
	id: Scalars["ID"]
	numberOfClaimedBlocks: Scalars["BigInt"]
}

export type ClaimBlocks_Filter = {
	depositor?: InputMaybe<Scalars["Bytes"]>
	depositor_contains?: InputMaybe<Scalars["Bytes"]>
	depositor_in?: InputMaybe<Array<Scalars["Bytes"]>>
	depositor_not?: InputMaybe<Scalars["Bytes"]>
	depositor_not_contains?: InputMaybe<Scalars["Bytes"]>
	depositor_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	farmerId?: InputMaybe<Scalars["BigInt"]>
	farmerId_gt?: InputMaybe<Scalars["BigInt"]>
	farmerId_gte?: InputMaybe<Scalars["BigInt"]>
	farmerId_in?: InputMaybe<Array<Scalars["BigInt"]>>
	farmerId_lt?: InputMaybe<Scalars["BigInt"]>
	farmerId_lte?: InputMaybe<Scalars["BigInt"]>
	farmerId_not?: InputMaybe<Scalars["BigInt"]>
	farmerId_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	numberOfClaimedBlocks?: InputMaybe<Scalars["BigInt"]>
	numberOfClaimedBlocks_gt?: InputMaybe<Scalars["BigInt"]>
	numberOfClaimedBlocks_gte?: InputMaybe<Scalars["BigInt"]>
	numberOfClaimedBlocks_in?: InputMaybe<Array<Scalars["BigInt"]>>
	numberOfClaimedBlocks_lt?: InputMaybe<Scalars["BigInt"]>
	numberOfClaimedBlocks_lte?: InputMaybe<Scalars["BigInt"]>
	numberOfClaimedBlocks_not?: InputMaybe<Scalars["BigInt"]>
	numberOfClaimedBlocks_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum ClaimBlocks_OrderBy {
	Depositor = "depositor",
	FarmerId = "farmerId",
	Id = "id",
	NumberOfClaimedBlocks = "numberOfClaimedBlocks",
}

export type DelegateChanged = Event & {
	__typename?: "DelegateChanged"
	contract: VotingContract
	delegation?: Maybe<VoteDelegation>
	delegator: Account
	emitter: Account
	fromDelegate: Account
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	toDelegate: Account
	transaction: Transaction
}

export type DelegateChanged_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegation?: InputMaybe<Scalars["String"]>
	delegation_contains?: InputMaybe<Scalars["String"]>
	delegation_contains_nocase?: InputMaybe<Scalars["String"]>
	delegation_ends_with?: InputMaybe<Scalars["String"]>
	delegation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegation_gt?: InputMaybe<Scalars["String"]>
	delegation_gte?: InputMaybe<Scalars["String"]>
	delegation_in?: InputMaybe<Array<Scalars["String"]>>
	delegation_lt?: InputMaybe<Scalars["String"]>
	delegation_lte?: InputMaybe<Scalars["String"]>
	delegation_not?: InputMaybe<Scalars["String"]>
	delegation_not_contains?: InputMaybe<Scalars["String"]>
	delegation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	delegation_not_ends_with?: InputMaybe<Scalars["String"]>
	delegation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegation_not_in?: InputMaybe<Array<Scalars["String"]>>
	delegation_not_starts_with?: InputMaybe<Scalars["String"]>
	delegation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegation_starts_with?: InputMaybe<Scalars["String"]>
	delegation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegator?: InputMaybe<Scalars["String"]>
	delegator_contains?: InputMaybe<Scalars["String"]>
	delegator_contains_nocase?: InputMaybe<Scalars["String"]>
	delegator_ends_with?: InputMaybe<Scalars["String"]>
	delegator_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegator_gt?: InputMaybe<Scalars["String"]>
	delegator_gte?: InputMaybe<Scalars["String"]>
	delegator_in?: InputMaybe<Array<Scalars["String"]>>
	delegator_lt?: InputMaybe<Scalars["String"]>
	delegator_lte?: InputMaybe<Scalars["String"]>
	delegator_not?: InputMaybe<Scalars["String"]>
	delegator_not_contains?: InputMaybe<Scalars["String"]>
	delegator_not_contains_nocase?: InputMaybe<Scalars["String"]>
	delegator_not_ends_with?: InputMaybe<Scalars["String"]>
	delegator_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegator_not_in?: InputMaybe<Array<Scalars["String"]>>
	delegator_not_starts_with?: InputMaybe<Scalars["String"]>
	delegator_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegator_starts_with?: InputMaybe<Scalars["String"]>
	delegator_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	fromDelegate?: InputMaybe<Scalars["String"]>
	fromDelegate_contains?: InputMaybe<Scalars["String"]>
	fromDelegate_contains_nocase?: InputMaybe<Scalars["String"]>
	fromDelegate_ends_with?: InputMaybe<Scalars["String"]>
	fromDelegate_ends_with_nocase?: InputMaybe<Scalars["String"]>
	fromDelegate_gt?: InputMaybe<Scalars["String"]>
	fromDelegate_gte?: InputMaybe<Scalars["String"]>
	fromDelegate_in?: InputMaybe<Array<Scalars["String"]>>
	fromDelegate_lt?: InputMaybe<Scalars["String"]>
	fromDelegate_lte?: InputMaybe<Scalars["String"]>
	fromDelegate_not?: InputMaybe<Scalars["String"]>
	fromDelegate_not_contains?: InputMaybe<Scalars["String"]>
	fromDelegate_not_contains_nocase?: InputMaybe<Scalars["String"]>
	fromDelegate_not_ends_with?: InputMaybe<Scalars["String"]>
	fromDelegate_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	fromDelegate_not_in?: InputMaybe<Array<Scalars["String"]>>
	fromDelegate_not_starts_with?: InputMaybe<Scalars["String"]>
	fromDelegate_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	fromDelegate_starts_with?: InputMaybe<Scalars["String"]>
	fromDelegate_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	toDelegate?: InputMaybe<Scalars["String"]>
	toDelegate_contains?: InputMaybe<Scalars["String"]>
	toDelegate_contains_nocase?: InputMaybe<Scalars["String"]>
	toDelegate_ends_with?: InputMaybe<Scalars["String"]>
	toDelegate_ends_with_nocase?: InputMaybe<Scalars["String"]>
	toDelegate_gt?: InputMaybe<Scalars["String"]>
	toDelegate_gte?: InputMaybe<Scalars["String"]>
	toDelegate_in?: InputMaybe<Array<Scalars["String"]>>
	toDelegate_lt?: InputMaybe<Scalars["String"]>
	toDelegate_lte?: InputMaybe<Scalars["String"]>
	toDelegate_not?: InputMaybe<Scalars["String"]>
	toDelegate_not_contains?: InputMaybe<Scalars["String"]>
	toDelegate_not_contains_nocase?: InputMaybe<Scalars["String"]>
	toDelegate_not_ends_with?: InputMaybe<Scalars["String"]>
	toDelegate_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	toDelegate_not_in?: InputMaybe<Array<Scalars["String"]>>
	toDelegate_not_starts_with?: InputMaybe<Scalars["String"]>
	toDelegate_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	toDelegate_starts_with?: InputMaybe<Scalars["String"]>
	toDelegate_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum DelegateChanged_OrderBy {
	Contract = "contract",
	Delegation = "delegation",
	Delegator = "delegator",
	Emitter = "emitter",
	FromDelegate = "fromDelegate",
	Id = "id",
	Timestamp = "timestamp",
	ToDelegate = "toDelegate",
	Transaction = "transaction",
}

export type DelegateVotesChanged = Event & {
	__typename?: "DelegateVotesChanged"
	contract: VotingContract
	delegate: Account
	emitter: Account
	id: Scalars["ID"]
	newValue: Scalars["BigInt"]
	oldValue: Scalars["BigInt"]
	timestamp: Scalars["BigInt"]
	transaction: Transaction
	voteWeight?: Maybe<VoteWeight>
}

export type DelegateVotesChanged_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegate?: InputMaybe<Scalars["String"]>
	delegate_contains?: InputMaybe<Scalars["String"]>
	delegate_contains_nocase?: InputMaybe<Scalars["String"]>
	delegate_ends_with?: InputMaybe<Scalars["String"]>
	delegate_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegate_gt?: InputMaybe<Scalars["String"]>
	delegate_gte?: InputMaybe<Scalars["String"]>
	delegate_in?: InputMaybe<Array<Scalars["String"]>>
	delegate_lt?: InputMaybe<Scalars["String"]>
	delegate_lte?: InputMaybe<Scalars["String"]>
	delegate_not?: InputMaybe<Scalars["String"]>
	delegate_not_contains?: InputMaybe<Scalars["String"]>
	delegate_not_contains_nocase?: InputMaybe<Scalars["String"]>
	delegate_not_ends_with?: InputMaybe<Scalars["String"]>
	delegate_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegate_not_in?: InputMaybe<Array<Scalars["String"]>>
	delegate_not_starts_with?: InputMaybe<Scalars["String"]>
	delegate_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegate_starts_with?: InputMaybe<Scalars["String"]>
	delegate_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	newValue?: InputMaybe<Scalars["BigInt"]>
	newValue_gt?: InputMaybe<Scalars["BigInt"]>
	newValue_gte?: InputMaybe<Scalars["BigInt"]>
	newValue_in?: InputMaybe<Array<Scalars["BigInt"]>>
	newValue_lt?: InputMaybe<Scalars["BigInt"]>
	newValue_lte?: InputMaybe<Scalars["BigInt"]>
	newValue_not?: InputMaybe<Scalars["BigInt"]>
	newValue_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	oldValue?: InputMaybe<Scalars["BigInt"]>
	oldValue_gt?: InputMaybe<Scalars["BigInt"]>
	oldValue_gte?: InputMaybe<Scalars["BigInt"]>
	oldValue_in?: InputMaybe<Array<Scalars["BigInt"]>>
	oldValue_lt?: InputMaybe<Scalars["BigInt"]>
	oldValue_lte?: InputMaybe<Scalars["BigInt"]>
	oldValue_not?: InputMaybe<Scalars["BigInt"]>
	oldValue_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
	voteWeight?: InputMaybe<Scalars["String"]>
	voteWeight_contains?: InputMaybe<Scalars["String"]>
	voteWeight_contains_nocase?: InputMaybe<Scalars["String"]>
	voteWeight_ends_with?: InputMaybe<Scalars["String"]>
	voteWeight_ends_with_nocase?: InputMaybe<Scalars["String"]>
	voteWeight_gt?: InputMaybe<Scalars["String"]>
	voteWeight_gte?: InputMaybe<Scalars["String"]>
	voteWeight_in?: InputMaybe<Array<Scalars["String"]>>
	voteWeight_lt?: InputMaybe<Scalars["String"]>
	voteWeight_lte?: InputMaybe<Scalars["String"]>
	voteWeight_not?: InputMaybe<Scalars["String"]>
	voteWeight_not_contains?: InputMaybe<Scalars["String"]>
	voteWeight_not_contains_nocase?: InputMaybe<Scalars["String"]>
	voteWeight_not_ends_with?: InputMaybe<Scalars["String"]>
	voteWeight_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	voteWeight_not_in?: InputMaybe<Array<Scalars["String"]>>
	voteWeight_not_starts_with?: InputMaybe<Scalars["String"]>
	voteWeight_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	voteWeight_starts_with?: InputMaybe<Scalars["String"]>
	voteWeight_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum DelegateVotesChanged_OrderBy {
	Contract = "contract",
	Delegate = "delegate",
	Emitter = "emitter",
	Id = "id",
	NewValue = "newValue",
	OldValue = "oldValue",
	Timestamp = "timestamp",
	Transaction = "transaction",
	VoteWeight = "voteWeight",
}

export type Erc20Approval = {
	__typename?: "ERC20Approval"
	contract: Erc20Contract
	id: Scalars["ID"]
	owner: Account
	spender: Account
	value: Scalars["BigDecimal"]
	valueExact: Scalars["BigInt"]
}

export type Erc20Approval_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	owner?: InputMaybe<Scalars["String"]>
	owner_contains?: InputMaybe<Scalars["String"]>
	owner_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_ends_with?: InputMaybe<Scalars["String"]>
	owner_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_gt?: InputMaybe<Scalars["String"]>
	owner_gte?: InputMaybe<Scalars["String"]>
	owner_in?: InputMaybe<Array<Scalars["String"]>>
	owner_lt?: InputMaybe<Scalars["String"]>
	owner_lte?: InputMaybe<Scalars["String"]>
	owner_not?: InputMaybe<Scalars["String"]>
	owner_not_contains?: InputMaybe<Scalars["String"]>
	owner_not_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_not_ends_with?: InputMaybe<Scalars["String"]>
	owner_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_not_in?: InputMaybe<Array<Scalars["String"]>>
	owner_not_starts_with?: InputMaybe<Scalars["String"]>
	owner_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner_starts_with?: InputMaybe<Scalars["String"]>
	owner_starts_with_nocase?: InputMaybe<Scalars["String"]>
	spender?: InputMaybe<Scalars["String"]>
	spender_contains?: InputMaybe<Scalars["String"]>
	spender_contains_nocase?: InputMaybe<Scalars["String"]>
	spender_ends_with?: InputMaybe<Scalars["String"]>
	spender_ends_with_nocase?: InputMaybe<Scalars["String"]>
	spender_gt?: InputMaybe<Scalars["String"]>
	spender_gte?: InputMaybe<Scalars["String"]>
	spender_in?: InputMaybe<Array<Scalars["String"]>>
	spender_lt?: InputMaybe<Scalars["String"]>
	spender_lte?: InputMaybe<Scalars["String"]>
	spender_not?: InputMaybe<Scalars["String"]>
	spender_not_contains?: InputMaybe<Scalars["String"]>
	spender_not_contains_nocase?: InputMaybe<Scalars["String"]>
	spender_not_ends_with?: InputMaybe<Scalars["String"]>
	spender_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	spender_not_in?: InputMaybe<Array<Scalars["String"]>>
	spender_not_starts_with?: InputMaybe<Scalars["String"]>
	spender_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	spender_starts_with?: InputMaybe<Scalars["String"]>
	spender_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value?: InputMaybe<Scalars["BigDecimal"]>
	valueExact?: InputMaybe<Scalars["BigInt"]>
	valueExact_gt?: InputMaybe<Scalars["BigInt"]>
	valueExact_gte?: InputMaybe<Scalars["BigInt"]>
	valueExact_in?: InputMaybe<Array<Scalars["BigInt"]>>
	valueExact_lt?: InputMaybe<Scalars["BigInt"]>
	valueExact_lte?: InputMaybe<Scalars["BigInt"]>
	valueExact_not?: InputMaybe<Scalars["BigInt"]>
	valueExact_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum Erc20Approval_OrderBy {
	Contract = "contract",
	Id = "id",
	Owner = "owner",
	Spender = "spender",
	Value = "value",
	ValueExact = "valueExact",
}

export type Erc20Balance = {
	__typename?: "ERC20Balance"
	account?: Maybe<Account>
	contract: Erc20Contract
	id: Scalars["ID"]
	transferFromEvent: Array<Erc20Transfer>
	transferToEvent: Array<Erc20Transfer>
	value: Scalars["BigDecimal"]
	valueExact: Scalars["BigInt"]
}

export type Erc20BalanceTransferFromEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type Erc20BalanceTransferToEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type Erc20Balance_Filter = {
	account?: InputMaybe<Scalars["String"]>
	account_contains?: InputMaybe<Scalars["String"]>
	account_contains_nocase?: InputMaybe<Scalars["String"]>
	account_ends_with?: InputMaybe<Scalars["String"]>
	account_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_gt?: InputMaybe<Scalars["String"]>
	account_gte?: InputMaybe<Scalars["String"]>
	account_in?: InputMaybe<Array<Scalars["String"]>>
	account_lt?: InputMaybe<Scalars["String"]>
	account_lte?: InputMaybe<Scalars["String"]>
	account_not?: InputMaybe<Scalars["String"]>
	account_not_contains?: InputMaybe<Scalars["String"]>
	account_not_contains_nocase?: InputMaybe<Scalars["String"]>
	account_not_ends_with?: InputMaybe<Scalars["String"]>
	account_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_not_in?: InputMaybe<Array<Scalars["String"]>>
	account_not_starts_with?: InputMaybe<Scalars["String"]>
	account_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account_starts_with?: InputMaybe<Scalars["String"]>
	account_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	value?: InputMaybe<Scalars["BigDecimal"]>
	valueExact?: InputMaybe<Scalars["BigInt"]>
	valueExact_gt?: InputMaybe<Scalars["BigInt"]>
	valueExact_gte?: InputMaybe<Scalars["BigInt"]>
	valueExact_in?: InputMaybe<Array<Scalars["BigInt"]>>
	valueExact_lt?: InputMaybe<Scalars["BigInt"]>
	valueExact_lte?: InputMaybe<Scalars["BigInt"]>
	valueExact_not?: InputMaybe<Scalars["BigInt"]>
	valueExact_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum Erc20Balance_OrderBy {
	Account = "account",
	Contract = "contract",
	Id = "id",
	TransferFromEvent = "transferFromEvent",
	TransferToEvent = "transferToEvent",
	Value = "value",
	ValueExact = "valueExact",
}

export type Erc20Contract = {
	__typename?: "ERC20Contract"
	approvals: Array<Erc20Approval>
	asAccount: Account
	balances: Array<Erc20Balance>
	decimals: Scalars["Int"]
	id: Scalars["ID"]
	name?: Maybe<Scalars["String"]>
	symbol?: Maybe<Scalars["String"]>
	totalSupply: Erc20Balance
	transfers: Array<Erc20Transfer>
}

export type Erc20ContractApprovalsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Approval_Filter>
}

export type Erc20ContractBalancesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Balance_Filter>
}

export type Erc20ContractTransfersArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type Erc20Contract_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	decimals?: InputMaybe<Scalars["Int"]>
	decimals_gt?: InputMaybe<Scalars["Int"]>
	decimals_gte?: InputMaybe<Scalars["Int"]>
	decimals_in?: InputMaybe<Array<Scalars["Int"]>>
	decimals_lt?: InputMaybe<Scalars["Int"]>
	decimals_lte?: InputMaybe<Scalars["Int"]>
	decimals_not?: InputMaybe<Scalars["Int"]>
	decimals_not_in?: InputMaybe<Array<Scalars["Int"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	name?: InputMaybe<Scalars["String"]>
	name_contains?: InputMaybe<Scalars["String"]>
	name_contains_nocase?: InputMaybe<Scalars["String"]>
	name_ends_with?: InputMaybe<Scalars["String"]>
	name_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_gt?: InputMaybe<Scalars["String"]>
	name_gte?: InputMaybe<Scalars["String"]>
	name_in?: InputMaybe<Array<Scalars["String"]>>
	name_lt?: InputMaybe<Scalars["String"]>
	name_lte?: InputMaybe<Scalars["String"]>
	name_not?: InputMaybe<Scalars["String"]>
	name_not_contains?: InputMaybe<Scalars["String"]>
	name_not_contains_nocase?: InputMaybe<Scalars["String"]>
	name_not_ends_with?: InputMaybe<Scalars["String"]>
	name_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_not_in?: InputMaybe<Array<Scalars["String"]>>
	name_not_starts_with?: InputMaybe<Scalars["String"]>
	name_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	name_starts_with?: InputMaybe<Scalars["String"]>
	name_starts_with_nocase?: InputMaybe<Scalars["String"]>
	symbol?: InputMaybe<Scalars["String"]>
	symbol_contains?: InputMaybe<Scalars["String"]>
	symbol_contains_nocase?: InputMaybe<Scalars["String"]>
	symbol_ends_with?: InputMaybe<Scalars["String"]>
	symbol_ends_with_nocase?: InputMaybe<Scalars["String"]>
	symbol_gt?: InputMaybe<Scalars["String"]>
	symbol_gte?: InputMaybe<Scalars["String"]>
	symbol_in?: InputMaybe<Array<Scalars["String"]>>
	symbol_lt?: InputMaybe<Scalars["String"]>
	symbol_lte?: InputMaybe<Scalars["String"]>
	symbol_not?: InputMaybe<Scalars["String"]>
	symbol_not_contains?: InputMaybe<Scalars["String"]>
	symbol_not_contains_nocase?: InputMaybe<Scalars["String"]>
	symbol_not_ends_with?: InputMaybe<Scalars["String"]>
	symbol_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	symbol_not_in?: InputMaybe<Array<Scalars["String"]>>
	symbol_not_starts_with?: InputMaybe<Scalars["String"]>
	symbol_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	symbol_starts_with?: InputMaybe<Scalars["String"]>
	symbol_starts_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply?: InputMaybe<Scalars["String"]>
	totalSupply_contains?: InputMaybe<Scalars["String"]>
	totalSupply_contains_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_ends_with?: InputMaybe<Scalars["String"]>
	totalSupply_ends_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_gt?: InputMaybe<Scalars["String"]>
	totalSupply_gte?: InputMaybe<Scalars["String"]>
	totalSupply_in?: InputMaybe<Array<Scalars["String"]>>
	totalSupply_lt?: InputMaybe<Scalars["String"]>
	totalSupply_lte?: InputMaybe<Scalars["String"]>
	totalSupply_not?: InputMaybe<Scalars["String"]>
	totalSupply_not_contains?: InputMaybe<Scalars["String"]>
	totalSupply_not_contains_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_not_ends_with?: InputMaybe<Scalars["String"]>
	totalSupply_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_not_in?: InputMaybe<Array<Scalars["String"]>>
	totalSupply_not_starts_with?: InputMaybe<Scalars["String"]>
	totalSupply_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_starts_with?: InputMaybe<Scalars["String"]>
	totalSupply_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc20Contract_OrderBy {
	Approvals = "approvals",
	AsAccount = "asAccount",
	Balances = "balances",
	Decimals = "decimals",
	Id = "id",
	Name = "name",
	Symbol = "symbol",
	TotalSupply = "totalSupply",
	Transfers = "transfers",
}

export type Erc20Transfer = Event & {
	__typename?: "ERC20Transfer"
	contract: Erc20Contract
	emitter: Account
	from?: Maybe<Account>
	fromBalance?: Maybe<Erc20Balance>
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	to?: Maybe<Account>
	toBalance?: Maybe<Erc20Balance>
	transaction: Transaction
	value: Scalars["BigDecimal"]
	valueExact: Scalars["BigInt"]
}

export type Erc20Transfer_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from?: InputMaybe<Scalars["String"]>
	fromBalance?: InputMaybe<Scalars["String"]>
	fromBalance_contains?: InputMaybe<Scalars["String"]>
	fromBalance_contains_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_ends_with?: InputMaybe<Scalars["String"]>
	fromBalance_ends_with_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_gt?: InputMaybe<Scalars["String"]>
	fromBalance_gte?: InputMaybe<Scalars["String"]>
	fromBalance_in?: InputMaybe<Array<Scalars["String"]>>
	fromBalance_lt?: InputMaybe<Scalars["String"]>
	fromBalance_lte?: InputMaybe<Scalars["String"]>
	fromBalance_not?: InputMaybe<Scalars["String"]>
	fromBalance_not_contains?: InputMaybe<Scalars["String"]>
	fromBalance_not_contains_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_not_ends_with?: InputMaybe<Scalars["String"]>
	fromBalance_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_not_in?: InputMaybe<Array<Scalars["String"]>>
	fromBalance_not_starts_with?: InputMaybe<Scalars["String"]>
	fromBalance_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_starts_with?: InputMaybe<Scalars["String"]>
	fromBalance_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from_contains?: InputMaybe<Scalars["String"]>
	from_contains_nocase?: InputMaybe<Scalars["String"]>
	from_ends_with?: InputMaybe<Scalars["String"]>
	from_ends_with_nocase?: InputMaybe<Scalars["String"]>
	from_gt?: InputMaybe<Scalars["String"]>
	from_gte?: InputMaybe<Scalars["String"]>
	from_in?: InputMaybe<Array<Scalars["String"]>>
	from_lt?: InputMaybe<Scalars["String"]>
	from_lte?: InputMaybe<Scalars["String"]>
	from_not?: InputMaybe<Scalars["String"]>
	from_not_contains?: InputMaybe<Scalars["String"]>
	from_not_contains_nocase?: InputMaybe<Scalars["String"]>
	from_not_ends_with?: InputMaybe<Scalars["String"]>
	from_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	from_not_in?: InputMaybe<Array<Scalars["String"]>>
	from_not_starts_with?: InputMaybe<Scalars["String"]>
	from_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from_starts_with?: InputMaybe<Scalars["String"]>
	from_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	to?: InputMaybe<Scalars["String"]>
	toBalance?: InputMaybe<Scalars["String"]>
	toBalance_contains?: InputMaybe<Scalars["String"]>
	toBalance_contains_nocase?: InputMaybe<Scalars["String"]>
	toBalance_ends_with?: InputMaybe<Scalars["String"]>
	toBalance_ends_with_nocase?: InputMaybe<Scalars["String"]>
	toBalance_gt?: InputMaybe<Scalars["String"]>
	toBalance_gte?: InputMaybe<Scalars["String"]>
	toBalance_in?: InputMaybe<Array<Scalars["String"]>>
	toBalance_lt?: InputMaybe<Scalars["String"]>
	toBalance_lte?: InputMaybe<Scalars["String"]>
	toBalance_not?: InputMaybe<Scalars["String"]>
	toBalance_not_contains?: InputMaybe<Scalars["String"]>
	toBalance_not_contains_nocase?: InputMaybe<Scalars["String"]>
	toBalance_not_ends_with?: InputMaybe<Scalars["String"]>
	toBalance_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	toBalance_not_in?: InputMaybe<Array<Scalars["String"]>>
	toBalance_not_starts_with?: InputMaybe<Scalars["String"]>
	toBalance_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	toBalance_starts_with?: InputMaybe<Scalars["String"]>
	toBalance_starts_with_nocase?: InputMaybe<Scalars["String"]>
	to_contains?: InputMaybe<Scalars["String"]>
	to_contains_nocase?: InputMaybe<Scalars["String"]>
	to_ends_with?: InputMaybe<Scalars["String"]>
	to_ends_with_nocase?: InputMaybe<Scalars["String"]>
	to_gt?: InputMaybe<Scalars["String"]>
	to_gte?: InputMaybe<Scalars["String"]>
	to_in?: InputMaybe<Array<Scalars["String"]>>
	to_lt?: InputMaybe<Scalars["String"]>
	to_lte?: InputMaybe<Scalars["String"]>
	to_not?: InputMaybe<Scalars["String"]>
	to_not_contains?: InputMaybe<Scalars["String"]>
	to_not_contains_nocase?: InputMaybe<Scalars["String"]>
	to_not_ends_with?: InputMaybe<Scalars["String"]>
	to_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	to_not_in?: InputMaybe<Array<Scalars["String"]>>
	to_not_starts_with?: InputMaybe<Scalars["String"]>
	to_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	to_starts_with?: InputMaybe<Scalars["String"]>
	to_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value?: InputMaybe<Scalars["BigDecimal"]>
	valueExact?: InputMaybe<Scalars["BigInt"]>
	valueExact_gt?: InputMaybe<Scalars["BigInt"]>
	valueExact_gte?: InputMaybe<Scalars["BigInt"]>
	valueExact_in?: InputMaybe<Array<Scalars["BigInt"]>>
	valueExact_lt?: InputMaybe<Scalars["BigInt"]>
	valueExact_lte?: InputMaybe<Scalars["BigInt"]>
	valueExact_not?: InputMaybe<Scalars["BigInt"]>
	valueExact_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum Erc20Transfer_OrderBy {
	Contract = "contract",
	Emitter = "emitter",
	From = "from",
	FromBalance = "fromBalance",
	Id = "id",
	Timestamp = "timestamp",
	To = "to",
	ToBalance = "toBalance",
	Transaction = "transaction",
	Value = "value",
	ValueExact = "valueExact",
}

export type Erc721Contract = {
	__typename?: "ERC721Contract"
	asAccount: Account
	id: Scalars["ID"]
	name?: Maybe<Scalars["String"]>
	operators: Array<Erc721Operator>
	supportsMetadata?: Maybe<Scalars["Boolean"]>
	symbol?: Maybe<Scalars["String"]>
	tokens: Array<Erc721Token>
	transfers: Array<Erc721Transfer>
}

export type Erc721ContractOperatorsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Operator_Filter>
}

export type Erc721ContractTokensArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Token_Filter>
}

export type Erc721ContractTransfersArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Transfer_Filter>
}

export type Erc721Contract_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	name?: InputMaybe<Scalars["String"]>
	name_contains?: InputMaybe<Scalars["String"]>
	name_contains_nocase?: InputMaybe<Scalars["String"]>
	name_ends_with?: InputMaybe<Scalars["String"]>
	name_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_gt?: InputMaybe<Scalars["String"]>
	name_gte?: InputMaybe<Scalars["String"]>
	name_in?: InputMaybe<Array<Scalars["String"]>>
	name_lt?: InputMaybe<Scalars["String"]>
	name_lte?: InputMaybe<Scalars["String"]>
	name_not?: InputMaybe<Scalars["String"]>
	name_not_contains?: InputMaybe<Scalars["String"]>
	name_not_contains_nocase?: InputMaybe<Scalars["String"]>
	name_not_ends_with?: InputMaybe<Scalars["String"]>
	name_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_not_in?: InputMaybe<Array<Scalars["String"]>>
	name_not_starts_with?: InputMaybe<Scalars["String"]>
	name_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	name_starts_with?: InputMaybe<Scalars["String"]>
	name_starts_with_nocase?: InputMaybe<Scalars["String"]>
	supportsMetadata?: InputMaybe<Scalars["Boolean"]>
	supportsMetadata_in?: InputMaybe<Array<Scalars["Boolean"]>>
	supportsMetadata_not?: InputMaybe<Scalars["Boolean"]>
	supportsMetadata_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	symbol?: InputMaybe<Scalars["String"]>
	symbol_contains?: InputMaybe<Scalars["String"]>
	symbol_contains_nocase?: InputMaybe<Scalars["String"]>
	symbol_ends_with?: InputMaybe<Scalars["String"]>
	symbol_ends_with_nocase?: InputMaybe<Scalars["String"]>
	symbol_gt?: InputMaybe<Scalars["String"]>
	symbol_gte?: InputMaybe<Scalars["String"]>
	symbol_in?: InputMaybe<Array<Scalars["String"]>>
	symbol_lt?: InputMaybe<Scalars["String"]>
	symbol_lte?: InputMaybe<Scalars["String"]>
	symbol_not?: InputMaybe<Scalars["String"]>
	symbol_not_contains?: InputMaybe<Scalars["String"]>
	symbol_not_contains_nocase?: InputMaybe<Scalars["String"]>
	symbol_not_ends_with?: InputMaybe<Scalars["String"]>
	symbol_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	symbol_not_in?: InputMaybe<Array<Scalars["String"]>>
	symbol_not_starts_with?: InputMaybe<Scalars["String"]>
	symbol_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	symbol_starts_with?: InputMaybe<Scalars["String"]>
	symbol_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc721Contract_OrderBy {
	AsAccount = "asAccount",
	Id = "id",
	Name = "name",
	Operators = "operators",
	SupportsMetadata = "supportsMetadata",
	Symbol = "symbol",
	Tokens = "tokens",
	Transfers = "transfers",
}

export type Erc721Operator = {
	__typename?: "ERC721Operator"
	approved: Scalars["Boolean"]
	contract: Erc721Contract
	id: Scalars["ID"]
	operator: Account
	owner: Account
}

export type Erc721Operator_Filter = {
	approved?: InputMaybe<Scalars["Boolean"]>
	approved_in?: InputMaybe<Array<Scalars["Boolean"]>>
	approved_not?: InputMaybe<Scalars["Boolean"]>
	approved_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	operator?: InputMaybe<Scalars["String"]>
	operator_contains?: InputMaybe<Scalars["String"]>
	operator_contains_nocase?: InputMaybe<Scalars["String"]>
	operator_ends_with?: InputMaybe<Scalars["String"]>
	operator_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operator_gt?: InputMaybe<Scalars["String"]>
	operator_gte?: InputMaybe<Scalars["String"]>
	operator_in?: InputMaybe<Array<Scalars["String"]>>
	operator_lt?: InputMaybe<Scalars["String"]>
	operator_lte?: InputMaybe<Scalars["String"]>
	operator_not?: InputMaybe<Scalars["String"]>
	operator_not_contains?: InputMaybe<Scalars["String"]>
	operator_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operator_not_ends_with?: InputMaybe<Scalars["String"]>
	operator_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operator_not_in?: InputMaybe<Array<Scalars["String"]>>
	operator_not_starts_with?: InputMaybe<Scalars["String"]>
	operator_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operator_starts_with?: InputMaybe<Scalars["String"]>
	operator_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner?: InputMaybe<Scalars["String"]>
	owner_contains?: InputMaybe<Scalars["String"]>
	owner_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_ends_with?: InputMaybe<Scalars["String"]>
	owner_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_gt?: InputMaybe<Scalars["String"]>
	owner_gte?: InputMaybe<Scalars["String"]>
	owner_in?: InputMaybe<Array<Scalars["String"]>>
	owner_lt?: InputMaybe<Scalars["String"]>
	owner_lte?: InputMaybe<Scalars["String"]>
	owner_not?: InputMaybe<Scalars["String"]>
	owner_not_contains?: InputMaybe<Scalars["String"]>
	owner_not_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_not_ends_with?: InputMaybe<Scalars["String"]>
	owner_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_not_in?: InputMaybe<Array<Scalars["String"]>>
	owner_not_starts_with?: InputMaybe<Scalars["String"]>
	owner_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner_starts_with?: InputMaybe<Scalars["String"]>
	owner_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc721Operator_OrderBy {
	Approved = "approved",
	Contract = "contract",
	Id = "id",
	Operator = "operator",
	Owner = "owner",
}

export type Erc721Token = {
	__typename?: "ERC721Token"
	approval: Account
	contract: Erc721Contract
	id: Scalars["ID"]
	identifier: Scalars["BigInt"]
	owner: Account
	transfers: Array<Erc721Transfer>
	uri?: Maybe<Scalars["String"]>
}

export type Erc721TokenTransfersArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc721Transfer_Filter>
}

export type Erc721Token_Filter = {
	approval?: InputMaybe<Scalars["String"]>
	approval_contains?: InputMaybe<Scalars["String"]>
	approval_contains_nocase?: InputMaybe<Scalars["String"]>
	approval_ends_with?: InputMaybe<Scalars["String"]>
	approval_ends_with_nocase?: InputMaybe<Scalars["String"]>
	approval_gt?: InputMaybe<Scalars["String"]>
	approval_gte?: InputMaybe<Scalars["String"]>
	approval_in?: InputMaybe<Array<Scalars["String"]>>
	approval_lt?: InputMaybe<Scalars["String"]>
	approval_lte?: InputMaybe<Scalars["String"]>
	approval_not?: InputMaybe<Scalars["String"]>
	approval_not_contains?: InputMaybe<Scalars["String"]>
	approval_not_contains_nocase?: InputMaybe<Scalars["String"]>
	approval_not_ends_with?: InputMaybe<Scalars["String"]>
	approval_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	approval_not_in?: InputMaybe<Array<Scalars["String"]>>
	approval_not_starts_with?: InputMaybe<Scalars["String"]>
	approval_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	approval_starts_with?: InputMaybe<Scalars["String"]>
	approval_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	identifier?: InputMaybe<Scalars["BigInt"]>
	identifier_gt?: InputMaybe<Scalars["BigInt"]>
	identifier_gte?: InputMaybe<Scalars["BigInt"]>
	identifier_in?: InputMaybe<Array<Scalars["BigInt"]>>
	identifier_lt?: InputMaybe<Scalars["BigInt"]>
	identifier_lte?: InputMaybe<Scalars["BigInt"]>
	identifier_not?: InputMaybe<Scalars["BigInt"]>
	identifier_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	owner?: InputMaybe<Scalars["String"]>
	owner_contains?: InputMaybe<Scalars["String"]>
	owner_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_ends_with?: InputMaybe<Scalars["String"]>
	owner_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_gt?: InputMaybe<Scalars["String"]>
	owner_gte?: InputMaybe<Scalars["String"]>
	owner_in?: InputMaybe<Array<Scalars["String"]>>
	owner_lt?: InputMaybe<Scalars["String"]>
	owner_lte?: InputMaybe<Scalars["String"]>
	owner_not?: InputMaybe<Scalars["String"]>
	owner_not_contains?: InputMaybe<Scalars["String"]>
	owner_not_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_not_ends_with?: InputMaybe<Scalars["String"]>
	owner_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_not_in?: InputMaybe<Array<Scalars["String"]>>
	owner_not_starts_with?: InputMaybe<Scalars["String"]>
	owner_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner_starts_with?: InputMaybe<Scalars["String"]>
	owner_starts_with_nocase?: InputMaybe<Scalars["String"]>
	uri?: InputMaybe<Scalars["String"]>
	uri_contains?: InputMaybe<Scalars["String"]>
	uri_contains_nocase?: InputMaybe<Scalars["String"]>
	uri_ends_with?: InputMaybe<Scalars["String"]>
	uri_ends_with_nocase?: InputMaybe<Scalars["String"]>
	uri_gt?: InputMaybe<Scalars["String"]>
	uri_gte?: InputMaybe<Scalars["String"]>
	uri_in?: InputMaybe<Array<Scalars["String"]>>
	uri_lt?: InputMaybe<Scalars["String"]>
	uri_lte?: InputMaybe<Scalars["String"]>
	uri_not?: InputMaybe<Scalars["String"]>
	uri_not_contains?: InputMaybe<Scalars["String"]>
	uri_not_contains_nocase?: InputMaybe<Scalars["String"]>
	uri_not_ends_with?: InputMaybe<Scalars["String"]>
	uri_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	uri_not_in?: InputMaybe<Array<Scalars["String"]>>
	uri_not_starts_with?: InputMaybe<Scalars["String"]>
	uri_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	uri_starts_with?: InputMaybe<Scalars["String"]>
	uri_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc721Token_OrderBy {
	Approval = "approval",
	Contract = "contract",
	Id = "id",
	Identifier = "identifier",
	Owner = "owner",
	Transfers = "transfers",
	Uri = "uri",
}

export type Erc721Transfer = Event & {
	__typename?: "ERC721Transfer"
	contract: Erc721Contract
	emitter: Account
	from: Account
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	to: Account
	token: Erc721Token
	transaction: Transaction
}

export type Erc721Transfer_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from?: InputMaybe<Scalars["String"]>
	from_contains?: InputMaybe<Scalars["String"]>
	from_contains_nocase?: InputMaybe<Scalars["String"]>
	from_ends_with?: InputMaybe<Scalars["String"]>
	from_ends_with_nocase?: InputMaybe<Scalars["String"]>
	from_gt?: InputMaybe<Scalars["String"]>
	from_gte?: InputMaybe<Scalars["String"]>
	from_in?: InputMaybe<Array<Scalars["String"]>>
	from_lt?: InputMaybe<Scalars["String"]>
	from_lte?: InputMaybe<Scalars["String"]>
	from_not?: InputMaybe<Scalars["String"]>
	from_not_contains?: InputMaybe<Scalars["String"]>
	from_not_contains_nocase?: InputMaybe<Scalars["String"]>
	from_not_ends_with?: InputMaybe<Scalars["String"]>
	from_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	from_not_in?: InputMaybe<Array<Scalars["String"]>>
	from_not_starts_with?: InputMaybe<Scalars["String"]>
	from_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from_starts_with?: InputMaybe<Scalars["String"]>
	from_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	to?: InputMaybe<Scalars["String"]>
	to_contains?: InputMaybe<Scalars["String"]>
	to_contains_nocase?: InputMaybe<Scalars["String"]>
	to_ends_with?: InputMaybe<Scalars["String"]>
	to_ends_with_nocase?: InputMaybe<Scalars["String"]>
	to_gt?: InputMaybe<Scalars["String"]>
	to_gte?: InputMaybe<Scalars["String"]>
	to_in?: InputMaybe<Array<Scalars["String"]>>
	to_lt?: InputMaybe<Scalars["String"]>
	to_lte?: InputMaybe<Scalars["String"]>
	to_not?: InputMaybe<Scalars["String"]>
	to_not_contains?: InputMaybe<Scalars["String"]>
	to_not_contains_nocase?: InputMaybe<Scalars["String"]>
	to_not_ends_with?: InputMaybe<Scalars["String"]>
	to_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	to_not_in?: InputMaybe<Array<Scalars["String"]>>
	to_not_starts_with?: InputMaybe<Scalars["String"]>
	to_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	to_starts_with?: InputMaybe<Scalars["String"]>
	to_starts_with_nocase?: InputMaybe<Scalars["String"]>
	token?: InputMaybe<Scalars["String"]>
	token_contains?: InputMaybe<Scalars["String"]>
	token_contains_nocase?: InputMaybe<Scalars["String"]>
	token_ends_with?: InputMaybe<Scalars["String"]>
	token_ends_with_nocase?: InputMaybe<Scalars["String"]>
	token_gt?: InputMaybe<Scalars["String"]>
	token_gte?: InputMaybe<Scalars["String"]>
	token_in?: InputMaybe<Array<Scalars["String"]>>
	token_lt?: InputMaybe<Scalars["String"]>
	token_lte?: InputMaybe<Scalars["String"]>
	token_not?: InputMaybe<Scalars["String"]>
	token_not_contains?: InputMaybe<Scalars["String"]>
	token_not_contains_nocase?: InputMaybe<Scalars["String"]>
	token_not_ends_with?: InputMaybe<Scalars["String"]>
	token_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	token_not_in?: InputMaybe<Array<Scalars["String"]>>
	token_not_starts_with?: InputMaybe<Scalars["String"]>
	token_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	token_starts_with?: InputMaybe<Scalars["String"]>
	token_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc721Transfer_OrderBy {
	Contract = "contract",
	Emitter = "emitter",
	From = "from",
	Id = "id",
	Timestamp = "timestamp",
	To = "to",
	Token = "token",
	Transaction = "transaction",
}

export type Erc1155Balance = {
	__typename?: "ERC1155Balance"
	account?: Maybe<Account>
	contract: Erc1155Contract
	id: Scalars["ID"]
	token: Erc1155Token
	transferFromEvent: Array<Erc1155Transfer>
	transferToEvent: Array<Erc1155Transfer>
	value: Scalars["BigDecimal"]
	valueExact: Scalars["BigInt"]
}

export type Erc1155BalanceTransferFromEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type Erc1155BalanceTransferToEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type Erc1155Balance_Filter = {
	account?: InputMaybe<Scalars["String"]>
	account_contains?: InputMaybe<Scalars["String"]>
	account_contains_nocase?: InputMaybe<Scalars["String"]>
	account_ends_with?: InputMaybe<Scalars["String"]>
	account_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_gt?: InputMaybe<Scalars["String"]>
	account_gte?: InputMaybe<Scalars["String"]>
	account_in?: InputMaybe<Array<Scalars["String"]>>
	account_lt?: InputMaybe<Scalars["String"]>
	account_lte?: InputMaybe<Scalars["String"]>
	account_not?: InputMaybe<Scalars["String"]>
	account_not_contains?: InputMaybe<Scalars["String"]>
	account_not_contains_nocase?: InputMaybe<Scalars["String"]>
	account_not_ends_with?: InputMaybe<Scalars["String"]>
	account_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_not_in?: InputMaybe<Array<Scalars["String"]>>
	account_not_starts_with?: InputMaybe<Scalars["String"]>
	account_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account_starts_with?: InputMaybe<Scalars["String"]>
	account_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	token?: InputMaybe<Scalars["String"]>
	token_contains?: InputMaybe<Scalars["String"]>
	token_contains_nocase?: InputMaybe<Scalars["String"]>
	token_ends_with?: InputMaybe<Scalars["String"]>
	token_ends_with_nocase?: InputMaybe<Scalars["String"]>
	token_gt?: InputMaybe<Scalars["String"]>
	token_gte?: InputMaybe<Scalars["String"]>
	token_in?: InputMaybe<Array<Scalars["String"]>>
	token_lt?: InputMaybe<Scalars["String"]>
	token_lte?: InputMaybe<Scalars["String"]>
	token_not?: InputMaybe<Scalars["String"]>
	token_not_contains?: InputMaybe<Scalars["String"]>
	token_not_contains_nocase?: InputMaybe<Scalars["String"]>
	token_not_ends_with?: InputMaybe<Scalars["String"]>
	token_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	token_not_in?: InputMaybe<Array<Scalars["String"]>>
	token_not_starts_with?: InputMaybe<Scalars["String"]>
	token_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	token_starts_with?: InputMaybe<Scalars["String"]>
	token_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value?: InputMaybe<Scalars["BigDecimal"]>
	valueExact?: InputMaybe<Scalars["BigInt"]>
	valueExact_gt?: InputMaybe<Scalars["BigInt"]>
	valueExact_gte?: InputMaybe<Scalars["BigInt"]>
	valueExact_in?: InputMaybe<Array<Scalars["BigInt"]>>
	valueExact_lt?: InputMaybe<Scalars["BigInt"]>
	valueExact_lte?: InputMaybe<Scalars["BigInt"]>
	valueExact_not?: InputMaybe<Scalars["BigInt"]>
	valueExact_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum Erc1155Balance_OrderBy {
	Account = "account",
	Contract = "contract",
	Id = "id",
	Token = "token",
	TransferFromEvent = "transferFromEvent",
	TransferToEvent = "transferToEvent",
	Value = "value",
	ValueExact = "valueExact",
}

export type Erc1155Contract = {
	__typename?: "ERC1155Contract"
	asAccount: Account
	balances: Array<Erc1155Balance>
	id: Scalars["ID"]
	operators: Array<Erc1155Operator>
	tokens: Array<Erc1155Token>
	transfers: Array<Erc1155Transfer>
}

export type Erc1155ContractBalancesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Balance_Filter>
}

export type Erc1155ContractOperatorsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Operator_Filter>
}

export type Erc1155ContractTokensArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Token_Filter>
}

export type Erc1155ContractTransfersArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type Erc1155Contract_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Erc1155Contract_OrderBy {
	AsAccount = "asAccount",
	Balances = "balances",
	Id = "id",
	Operators = "operators",
	Tokens = "tokens",
	Transfers = "transfers",
}

export type Erc1155Operator = {
	__typename?: "ERC1155Operator"
	approved: Scalars["Boolean"]
	contract: Erc1155Contract
	id: Scalars["ID"]
	operator: Account
	owner: Account
}

export type Erc1155Operator_Filter = {
	approved?: InputMaybe<Scalars["Boolean"]>
	approved_in?: InputMaybe<Array<Scalars["Boolean"]>>
	approved_not?: InputMaybe<Scalars["Boolean"]>
	approved_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	operator?: InputMaybe<Scalars["String"]>
	operator_contains?: InputMaybe<Scalars["String"]>
	operator_contains_nocase?: InputMaybe<Scalars["String"]>
	operator_ends_with?: InputMaybe<Scalars["String"]>
	operator_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operator_gt?: InputMaybe<Scalars["String"]>
	operator_gte?: InputMaybe<Scalars["String"]>
	operator_in?: InputMaybe<Array<Scalars["String"]>>
	operator_lt?: InputMaybe<Scalars["String"]>
	operator_lte?: InputMaybe<Scalars["String"]>
	operator_not?: InputMaybe<Scalars["String"]>
	operator_not_contains?: InputMaybe<Scalars["String"]>
	operator_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operator_not_ends_with?: InputMaybe<Scalars["String"]>
	operator_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operator_not_in?: InputMaybe<Array<Scalars["String"]>>
	operator_not_starts_with?: InputMaybe<Scalars["String"]>
	operator_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operator_starts_with?: InputMaybe<Scalars["String"]>
	operator_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner?: InputMaybe<Scalars["String"]>
	owner_contains?: InputMaybe<Scalars["String"]>
	owner_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_ends_with?: InputMaybe<Scalars["String"]>
	owner_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_gt?: InputMaybe<Scalars["String"]>
	owner_gte?: InputMaybe<Scalars["String"]>
	owner_in?: InputMaybe<Array<Scalars["String"]>>
	owner_lt?: InputMaybe<Scalars["String"]>
	owner_lte?: InputMaybe<Scalars["String"]>
	owner_not?: InputMaybe<Scalars["String"]>
	owner_not_contains?: InputMaybe<Scalars["String"]>
	owner_not_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_not_ends_with?: InputMaybe<Scalars["String"]>
	owner_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_not_in?: InputMaybe<Array<Scalars["String"]>>
	owner_not_starts_with?: InputMaybe<Scalars["String"]>
	owner_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner_starts_with?: InputMaybe<Scalars["String"]>
	owner_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc1155Operator_OrderBy {
	Approved = "approved",
	Contract = "contract",
	Id = "id",
	Operator = "operator",
	Owner = "owner",
}

export type Erc1155Token = {
	__typename?: "ERC1155Token"
	balances: Array<Erc1155Balance>
	contract: Erc1155Contract
	id: Scalars["ID"]
	identifier: Scalars["BigInt"]
	totalSupply: Erc1155Balance
	transfers: Array<Erc1155Transfer>
	uri?: Maybe<Scalars["String"]>
}

export type Erc1155TokenBalancesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Balance_Filter>
}

export type Erc1155TokenTransfersArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type Erc1155Token_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	identifier?: InputMaybe<Scalars["BigInt"]>
	identifier_gt?: InputMaybe<Scalars["BigInt"]>
	identifier_gte?: InputMaybe<Scalars["BigInt"]>
	identifier_in?: InputMaybe<Array<Scalars["BigInt"]>>
	identifier_lt?: InputMaybe<Scalars["BigInt"]>
	identifier_lte?: InputMaybe<Scalars["BigInt"]>
	identifier_not?: InputMaybe<Scalars["BigInt"]>
	identifier_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	totalSupply?: InputMaybe<Scalars["String"]>
	totalSupply_contains?: InputMaybe<Scalars["String"]>
	totalSupply_contains_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_ends_with?: InputMaybe<Scalars["String"]>
	totalSupply_ends_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_gt?: InputMaybe<Scalars["String"]>
	totalSupply_gte?: InputMaybe<Scalars["String"]>
	totalSupply_in?: InputMaybe<Array<Scalars["String"]>>
	totalSupply_lt?: InputMaybe<Scalars["String"]>
	totalSupply_lte?: InputMaybe<Scalars["String"]>
	totalSupply_not?: InputMaybe<Scalars["String"]>
	totalSupply_not_contains?: InputMaybe<Scalars["String"]>
	totalSupply_not_contains_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_not_ends_with?: InputMaybe<Scalars["String"]>
	totalSupply_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_not_in?: InputMaybe<Array<Scalars["String"]>>
	totalSupply_not_starts_with?: InputMaybe<Scalars["String"]>
	totalSupply_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	totalSupply_starts_with?: InputMaybe<Scalars["String"]>
	totalSupply_starts_with_nocase?: InputMaybe<Scalars["String"]>
	uri?: InputMaybe<Scalars["String"]>
	uri_contains?: InputMaybe<Scalars["String"]>
	uri_contains_nocase?: InputMaybe<Scalars["String"]>
	uri_ends_with?: InputMaybe<Scalars["String"]>
	uri_ends_with_nocase?: InputMaybe<Scalars["String"]>
	uri_gt?: InputMaybe<Scalars["String"]>
	uri_gte?: InputMaybe<Scalars["String"]>
	uri_in?: InputMaybe<Array<Scalars["String"]>>
	uri_lt?: InputMaybe<Scalars["String"]>
	uri_lte?: InputMaybe<Scalars["String"]>
	uri_not?: InputMaybe<Scalars["String"]>
	uri_not_contains?: InputMaybe<Scalars["String"]>
	uri_not_contains_nocase?: InputMaybe<Scalars["String"]>
	uri_not_ends_with?: InputMaybe<Scalars["String"]>
	uri_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	uri_not_in?: InputMaybe<Array<Scalars["String"]>>
	uri_not_starts_with?: InputMaybe<Scalars["String"]>
	uri_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	uri_starts_with?: InputMaybe<Scalars["String"]>
	uri_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc1155Token_OrderBy {
	Balances = "balances",
	Contract = "contract",
	Id = "id",
	Identifier = "identifier",
	TotalSupply = "totalSupply",
	Transfers = "transfers",
	Uri = "uri",
}

export type Erc1155Transfer = Event & {
	__typename?: "ERC1155Transfer"
	contract: Erc1155Contract
	emitter: Account
	from?: Maybe<Account>
	fromBalance?: Maybe<Erc1155Balance>
	id: Scalars["ID"]
	operator: Account
	timestamp: Scalars["BigInt"]
	to?: Maybe<Account>
	toBalance?: Maybe<Erc1155Balance>
	token: Erc1155Token
	transaction: Transaction
	value: Scalars["BigDecimal"]
	valueExact: Scalars["BigInt"]
}

export type Erc1155Transfer_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from?: InputMaybe<Scalars["String"]>
	fromBalance?: InputMaybe<Scalars["String"]>
	fromBalance_contains?: InputMaybe<Scalars["String"]>
	fromBalance_contains_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_ends_with?: InputMaybe<Scalars["String"]>
	fromBalance_ends_with_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_gt?: InputMaybe<Scalars["String"]>
	fromBalance_gte?: InputMaybe<Scalars["String"]>
	fromBalance_in?: InputMaybe<Array<Scalars["String"]>>
	fromBalance_lt?: InputMaybe<Scalars["String"]>
	fromBalance_lte?: InputMaybe<Scalars["String"]>
	fromBalance_not?: InputMaybe<Scalars["String"]>
	fromBalance_not_contains?: InputMaybe<Scalars["String"]>
	fromBalance_not_contains_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_not_ends_with?: InputMaybe<Scalars["String"]>
	fromBalance_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_not_in?: InputMaybe<Array<Scalars["String"]>>
	fromBalance_not_starts_with?: InputMaybe<Scalars["String"]>
	fromBalance_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	fromBalance_starts_with?: InputMaybe<Scalars["String"]>
	fromBalance_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from_contains?: InputMaybe<Scalars["String"]>
	from_contains_nocase?: InputMaybe<Scalars["String"]>
	from_ends_with?: InputMaybe<Scalars["String"]>
	from_ends_with_nocase?: InputMaybe<Scalars["String"]>
	from_gt?: InputMaybe<Scalars["String"]>
	from_gte?: InputMaybe<Scalars["String"]>
	from_in?: InputMaybe<Array<Scalars["String"]>>
	from_lt?: InputMaybe<Scalars["String"]>
	from_lte?: InputMaybe<Scalars["String"]>
	from_not?: InputMaybe<Scalars["String"]>
	from_not_contains?: InputMaybe<Scalars["String"]>
	from_not_contains_nocase?: InputMaybe<Scalars["String"]>
	from_not_ends_with?: InputMaybe<Scalars["String"]>
	from_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	from_not_in?: InputMaybe<Array<Scalars["String"]>>
	from_not_starts_with?: InputMaybe<Scalars["String"]>
	from_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	from_starts_with?: InputMaybe<Scalars["String"]>
	from_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	operator?: InputMaybe<Scalars["String"]>
	operator_contains?: InputMaybe<Scalars["String"]>
	operator_contains_nocase?: InputMaybe<Scalars["String"]>
	operator_ends_with?: InputMaybe<Scalars["String"]>
	operator_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operator_gt?: InputMaybe<Scalars["String"]>
	operator_gte?: InputMaybe<Scalars["String"]>
	operator_in?: InputMaybe<Array<Scalars["String"]>>
	operator_lt?: InputMaybe<Scalars["String"]>
	operator_lte?: InputMaybe<Scalars["String"]>
	operator_not?: InputMaybe<Scalars["String"]>
	operator_not_contains?: InputMaybe<Scalars["String"]>
	operator_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operator_not_ends_with?: InputMaybe<Scalars["String"]>
	operator_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operator_not_in?: InputMaybe<Array<Scalars["String"]>>
	operator_not_starts_with?: InputMaybe<Scalars["String"]>
	operator_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operator_starts_with?: InputMaybe<Scalars["String"]>
	operator_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	to?: InputMaybe<Scalars["String"]>
	toBalance?: InputMaybe<Scalars["String"]>
	toBalance_contains?: InputMaybe<Scalars["String"]>
	toBalance_contains_nocase?: InputMaybe<Scalars["String"]>
	toBalance_ends_with?: InputMaybe<Scalars["String"]>
	toBalance_ends_with_nocase?: InputMaybe<Scalars["String"]>
	toBalance_gt?: InputMaybe<Scalars["String"]>
	toBalance_gte?: InputMaybe<Scalars["String"]>
	toBalance_in?: InputMaybe<Array<Scalars["String"]>>
	toBalance_lt?: InputMaybe<Scalars["String"]>
	toBalance_lte?: InputMaybe<Scalars["String"]>
	toBalance_not?: InputMaybe<Scalars["String"]>
	toBalance_not_contains?: InputMaybe<Scalars["String"]>
	toBalance_not_contains_nocase?: InputMaybe<Scalars["String"]>
	toBalance_not_ends_with?: InputMaybe<Scalars["String"]>
	toBalance_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	toBalance_not_in?: InputMaybe<Array<Scalars["String"]>>
	toBalance_not_starts_with?: InputMaybe<Scalars["String"]>
	toBalance_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	toBalance_starts_with?: InputMaybe<Scalars["String"]>
	toBalance_starts_with_nocase?: InputMaybe<Scalars["String"]>
	to_contains?: InputMaybe<Scalars["String"]>
	to_contains_nocase?: InputMaybe<Scalars["String"]>
	to_ends_with?: InputMaybe<Scalars["String"]>
	to_ends_with_nocase?: InputMaybe<Scalars["String"]>
	to_gt?: InputMaybe<Scalars["String"]>
	to_gte?: InputMaybe<Scalars["String"]>
	to_in?: InputMaybe<Array<Scalars["String"]>>
	to_lt?: InputMaybe<Scalars["String"]>
	to_lte?: InputMaybe<Scalars["String"]>
	to_not?: InputMaybe<Scalars["String"]>
	to_not_contains?: InputMaybe<Scalars["String"]>
	to_not_contains_nocase?: InputMaybe<Scalars["String"]>
	to_not_ends_with?: InputMaybe<Scalars["String"]>
	to_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	to_not_in?: InputMaybe<Array<Scalars["String"]>>
	to_not_starts_with?: InputMaybe<Scalars["String"]>
	to_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	to_starts_with?: InputMaybe<Scalars["String"]>
	to_starts_with_nocase?: InputMaybe<Scalars["String"]>
	token?: InputMaybe<Scalars["String"]>
	token_contains?: InputMaybe<Scalars["String"]>
	token_contains_nocase?: InputMaybe<Scalars["String"]>
	token_ends_with?: InputMaybe<Scalars["String"]>
	token_ends_with_nocase?: InputMaybe<Scalars["String"]>
	token_gt?: InputMaybe<Scalars["String"]>
	token_gte?: InputMaybe<Scalars["String"]>
	token_in?: InputMaybe<Array<Scalars["String"]>>
	token_lt?: InputMaybe<Scalars["String"]>
	token_lte?: InputMaybe<Scalars["String"]>
	token_not?: InputMaybe<Scalars["String"]>
	token_not_contains?: InputMaybe<Scalars["String"]>
	token_not_contains_nocase?: InputMaybe<Scalars["String"]>
	token_not_ends_with?: InputMaybe<Scalars["String"]>
	token_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	token_not_in?: InputMaybe<Array<Scalars["String"]>>
	token_not_starts_with?: InputMaybe<Scalars["String"]>
	token_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	token_starts_with?: InputMaybe<Scalars["String"]>
	token_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value?: InputMaybe<Scalars["BigDecimal"]>
	valueExact?: InputMaybe<Scalars["BigInt"]>
	valueExact_gt?: InputMaybe<Scalars["BigInt"]>
	valueExact_gte?: InputMaybe<Scalars["BigInt"]>
	valueExact_in?: InputMaybe<Array<Scalars["BigInt"]>>
	valueExact_lt?: InputMaybe<Scalars["BigInt"]>
	valueExact_lte?: InputMaybe<Scalars["BigInt"]>
	valueExact_not?: InputMaybe<Scalars["BigInt"]>
	valueExact_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum Erc1155Transfer_OrderBy {
	Contract = "contract",
	Emitter = "emitter",
	From = "from",
	FromBalance = "fromBalance",
	Id = "id",
	Operator = "operator",
	Timestamp = "timestamp",
	To = "to",
	ToBalance = "toBalance",
	Token = "token",
	Transaction = "transaction",
	Value = "value",
	ValueExact = "valueExact",
}

export type Erc1967AdminChanged = Event & {
	__typename?: "ERC1967AdminChanged"
	admin: Account
	emitter: Account
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type Erc1967AdminChanged_Filter = {
	admin?: InputMaybe<Scalars["String"]>
	admin_contains?: InputMaybe<Scalars["String"]>
	admin_contains_nocase?: InputMaybe<Scalars["String"]>
	admin_ends_with?: InputMaybe<Scalars["String"]>
	admin_ends_with_nocase?: InputMaybe<Scalars["String"]>
	admin_gt?: InputMaybe<Scalars["String"]>
	admin_gte?: InputMaybe<Scalars["String"]>
	admin_in?: InputMaybe<Array<Scalars["String"]>>
	admin_lt?: InputMaybe<Scalars["String"]>
	admin_lte?: InputMaybe<Scalars["String"]>
	admin_not?: InputMaybe<Scalars["String"]>
	admin_not_contains?: InputMaybe<Scalars["String"]>
	admin_not_contains_nocase?: InputMaybe<Scalars["String"]>
	admin_not_ends_with?: InputMaybe<Scalars["String"]>
	admin_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	admin_not_in?: InputMaybe<Array<Scalars["String"]>>
	admin_not_starts_with?: InputMaybe<Scalars["String"]>
	admin_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	admin_starts_with?: InputMaybe<Scalars["String"]>
	admin_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc1967AdminChanged_OrderBy {
	Admin = "admin",
	Emitter = "emitter",
	Id = "id",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Erc1967BeaconUpgraded = Event & {
	__typename?: "ERC1967BeaconUpgraded"
	beacon: Account
	emitter: Account
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type Erc1967BeaconUpgraded_Filter = {
	beacon?: InputMaybe<Scalars["String"]>
	beacon_contains?: InputMaybe<Scalars["String"]>
	beacon_contains_nocase?: InputMaybe<Scalars["String"]>
	beacon_ends_with?: InputMaybe<Scalars["String"]>
	beacon_ends_with_nocase?: InputMaybe<Scalars["String"]>
	beacon_gt?: InputMaybe<Scalars["String"]>
	beacon_gte?: InputMaybe<Scalars["String"]>
	beacon_in?: InputMaybe<Array<Scalars["String"]>>
	beacon_lt?: InputMaybe<Scalars["String"]>
	beacon_lte?: InputMaybe<Scalars["String"]>
	beacon_not?: InputMaybe<Scalars["String"]>
	beacon_not_contains?: InputMaybe<Scalars["String"]>
	beacon_not_contains_nocase?: InputMaybe<Scalars["String"]>
	beacon_not_ends_with?: InputMaybe<Scalars["String"]>
	beacon_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	beacon_not_in?: InputMaybe<Array<Scalars["String"]>>
	beacon_not_starts_with?: InputMaybe<Scalars["String"]>
	beacon_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	beacon_starts_with?: InputMaybe<Scalars["String"]>
	beacon_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc1967BeaconUpgraded_OrderBy {
	Beacon = "beacon",
	Emitter = "emitter",
	Id = "id",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Erc1967ImplementationUpgraded = Event & {
	__typename?: "ERC1967ImplementationUpgraded"
	emitter: Account
	id: Scalars["ID"]
	implementation: Account
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type Erc1967ImplementationUpgraded_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	implementation?: InputMaybe<Scalars["String"]>
	implementation_contains?: InputMaybe<Scalars["String"]>
	implementation_contains_nocase?: InputMaybe<Scalars["String"]>
	implementation_ends_with?: InputMaybe<Scalars["String"]>
	implementation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	implementation_gt?: InputMaybe<Scalars["String"]>
	implementation_gte?: InputMaybe<Scalars["String"]>
	implementation_in?: InputMaybe<Array<Scalars["String"]>>
	implementation_lt?: InputMaybe<Scalars["String"]>
	implementation_lte?: InputMaybe<Scalars["String"]>
	implementation_not?: InputMaybe<Scalars["String"]>
	implementation_not_contains?: InputMaybe<Scalars["String"]>
	implementation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	implementation_not_ends_with?: InputMaybe<Scalars["String"]>
	implementation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	implementation_not_in?: InputMaybe<Array<Scalars["String"]>>
	implementation_not_starts_with?: InputMaybe<Scalars["String"]>
	implementation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	implementation_starts_with?: InputMaybe<Scalars["String"]>
	implementation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Erc1967ImplementationUpgraded_OrderBy {
	Emitter = "emitter",
	Id = "id",
	Implementation = "implementation",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Event = {
	emitter: Account
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type Event_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Event_OrderBy {
	Emitter = "emitter",
	Id = "id",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Farmer = {
	__typename?: "Farmer"
	description: Scalars["String"]
	id: Scalars["ID"]
	internalId: Scalars["ID"]
	ipfsHash: Scalars["String"]
	isSpecial: Scalars["Boolean"]
	mintType: MintType
	name: Scalars["String"]
	stakingState: StakingState
	xp: Scalars["BigInt"]
}

export enum FarmerContract {
	EnergyFarmer = "EnergyFarmer",
	HonestFarmerClubV1 = "HonestFarmerClubV1",
	HonestFarmerClubV2 = "HonestFarmerClubV2",
	MetaFarmer = "MetaFarmer",
	MigrationTractor = "MigrationTractor",
	OnchainArtworkFarmer = "OnchainArtworkFarmer",
	RevealFarmer = "RevealFarmer",
	WhitelistFarmer = "WhitelistFarmer",
}

export type Farmer_Filter = {
	description?: InputMaybe<Scalars["String"]>
	description_contains?: InputMaybe<Scalars["String"]>
	description_contains_nocase?: InputMaybe<Scalars["String"]>
	description_ends_with?: InputMaybe<Scalars["String"]>
	description_ends_with_nocase?: InputMaybe<Scalars["String"]>
	description_gt?: InputMaybe<Scalars["String"]>
	description_gte?: InputMaybe<Scalars["String"]>
	description_in?: InputMaybe<Array<Scalars["String"]>>
	description_lt?: InputMaybe<Scalars["String"]>
	description_lte?: InputMaybe<Scalars["String"]>
	description_not?: InputMaybe<Scalars["String"]>
	description_not_contains?: InputMaybe<Scalars["String"]>
	description_not_contains_nocase?: InputMaybe<Scalars["String"]>
	description_not_ends_with?: InputMaybe<Scalars["String"]>
	description_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	description_not_in?: InputMaybe<Array<Scalars["String"]>>
	description_not_starts_with?: InputMaybe<Scalars["String"]>
	description_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	description_starts_with?: InputMaybe<Scalars["String"]>
	description_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	internalId?: InputMaybe<Scalars["ID"]>
	internalId_gt?: InputMaybe<Scalars["ID"]>
	internalId_gte?: InputMaybe<Scalars["ID"]>
	internalId_in?: InputMaybe<Array<Scalars["ID"]>>
	internalId_lt?: InputMaybe<Scalars["ID"]>
	internalId_lte?: InputMaybe<Scalars["ID"]>
	internalId_not?: InputMaybe<Scalars["ID"]>
	internalId_not_in?: InputMaybe<Array<Scalars["ID"]>>
	ipfsHash?: InputMaybe<Scalars["String"]>
	ipfsHash_contains?: InputMaybe<Scalars["String"]>
	ipfsHash_contains_nocase?: InputMaybe<Scalars["String"]>
	ipfsHash_ends_with?: InputMaybe<Scalars["String"]>
	ipfsHash_ends_with_nocase?: InputMaybe<Scalars["String"]>
	ipfsHash_gt?: InputMaybe<Scalars["String"]>
	ipfsHash_gte?: InputMaybe<Scalars["String"]>
	ipfsHash_in?: InputMaybe<Array<Scalars["String"]>>
	ipfsHash_lt?: InputMaybe<Scalars["String"]>
	ipfsHash_lte?: InputMaybe<Scalars["String"]>
	ipfsHash_not?: InputMaybe<Scalars["String"]>
	ipfsHash_not_contains?: InputMaybe<Scalars["String"]>
	ipfsHash_not_contains_nocase?: InputMaybe<Scalars["String"]>
	ipfsHash_not_ends_with?: InputMaybe<Scalars["String"]>
	ipfsHash_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	ipfsHash_not_in?: InputMaybe<Array<Scalars["String"]>>
	ipfsHash_not_starts_with?: InputMaybe<Scalars["String"]>
	ipfsHash_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	ipfsHash_starts_with?: InputMaybe<Scalars["String"]>
	ipfsHash_starts_with_nocase?: InputMaybe<Scalars["String"]>
	isSpecial?: InputMaybe<Scalars["Boolean"]>
	isSpecial_in?: InputMaybe<Array<Scalars["Boolean"]>>
	isSpecial_not?: InputMaybe<Scalars["Boolean"]>
	isSpecial_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	mintType?: InputMaybe<MintType>
	mintType_in?: InputMaybe<Array<MintType>>
	mintType_not?: InputMaybe<MintType>
	mintType_not_in?: InputMaybe<Array<MintType>>
	name?: InputMaybe<Scalars["String"]>
	name_contains?: InputMaybe<Scalars["String"]>
	name_contains_nocase?: InputMaybe<Scalars["String"]>
	name_ends_with?: InputMaybe<Scalars["String"]>
	name_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_gt?: InputMaybe<Scalars["String"]>
	name_gte?: InputMaybe<Scalars["String"]>
	name_in?: InputMaybe<Array<Scalars["String"]>>
	name_lt?: InputMaybe<Scalars["String"]>
	name_lte?: InputMaybe<Scalars["String"]>
	name_not?: InputMaybe<Scalars["String"]>
	name_not_contains?: InputMaybe<Scalars["String"]>
	name_not_contains_nocase?: InputMaybe<Scalars["String"]>
	name_not_ends_with?: InputMaybe<Scalars["String"]>
	name_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_not_in?: InputMaybe<Array<Scalars["String"]>>
	name_not_starts_with?: InputMaybe<Scalars["String"]>
	name_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	name_starts_with?: InputMaybe<Scalars["String"]>
	name_starts_with_nocase?: InputMaybe<Scalars["String"]>
	stakingState?: InputMaybe<StakingState>
	stakingState_in?: InputMaybe<Array<StakingState>>
	stakingState_not?: InputMaybe<StakingState>
	stakingState_not_in?: InputMaybe<Array<StakingState>>
	xp?: InputMaybe<Scalars["BigInt"]>
	xp_gt?: InputMaybe<Scalars["BigInt"]>
	xp_gte?: InputMaybe<Scalars["BigInt"]>
	xp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	xp_lt?: InputMaybe<Scalars["BigInt"]>
	xp_lte?: InputMaybe<Scalars["BigInt"]>
	xp_not?: InputMaybe<Scalars["BigInt"]>
	xp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum Farmer_OrderBy {
	Description = "description",
	Id = "id",
	InternalId = "internalId",
	IpfsHash = "ipfsHash",
	IsSpecial = "isSpecial",
	MintType = "mintType",
	Name = "name",
	StakingState = "stakingState",
	Xp = "xp",
}

export type Governor = {
	__typename?: "Governor"
	asAccount: Account
	id: Scalars["ID"]
	proposalCanceled: Array<ProposalCanceled>
	proposalCreated: Array<ProposalCreated>
	proposalExecuted: Array<ProposalExecuted>
	proposalQueued: Array<ProposalQueued>
	proposals: Array<Proposal>
	votecast: Array<VoteCast>
}

export type GovernorProposalCanceledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCanceled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalCanceled_Filter>
}

export type GovernorProposalCreatedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCreated_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalCreated_Filter>
}

export type GovernorProposalExecutedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalExecuted_Filter>
}

export type GovernorProposalQueuedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalQueued_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalQueued_Filter>
}

export type GovernorProposalsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Proposal_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Proposal_Filter>
}

export type GovernorVotecastArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteCast_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteCast_Filter>
}

export type Governor_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Governor_OrderBy {
	AsAccount = "asAccount",
	Id = "id",
	ProposalCanceled = "proposalCanceled",
	ProposalCreated = "proposalCreated",
	ProposalExecuted = "proposalExecuted",
	ProposalQueued = "proposalQueued",
	Proposals = "proposals",
	Votecast = "votecast",
}

export type MintAsDelegate = {
	__typename?: "MintAsDelegate"
	amount: Scalars["BigInt"]
	delegate: Scalars["Bytes"]
	id: Scalars["ID"]
	reason: Scalars["String"]
	recipient: Scalars["Bytes"]
}

export type MintAsDelegate_Filter = {
	amount?: InputMaybe<Scalars["BigInt"]>
	amount_gt?: InputMaybe<Scalars["BigInt"]>
	amount_gte?: InputMaybe<Scalars["BigInt"]>
	amount_in?: InputMaybe<Array<Scalars["BigInt"]>>
	amount_lt?: InputMaybe<Scalars["BigInt"]>
	amount_lte?: InputMaybe<Scalars["BigInt"]>
	amount_not?: InputMaybe<Scalars["BigInt"]>
	amount_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	delegate?: InputMaybe<Scalars["Bytes"]>
	delegate_contains?: InputMaybe<Scalars["Bytes"]>
	delegate_in?: InputMaybe<Array<Scalars["Bytes"]>>
	delegate_not?: InputMaybe<Scalars["Bytes"]>
	delegate_not_contains?: InputMaybe<Scalars["Bytes"]>
	delegate_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	reason?: InputMaybe<Scalars["String"]>
	reason_contains?: InputMaybe<Scalars["String"]>
	reason_contains_nocase?: InputMaybe<Scalars["String"]>
	reason_ends_with?: InputMaybe<Scalars["String"]>
	reason_ends_with_nocase?: InputMaybe<Scalars["String"]>
	reason_gt?: InputMaybe<Scalars["String"]>
	reason_gte?: InputMaybe<Scalars["String"]>
	reason_in?: InputMaybe<Array<Scalars["String"]>>
	reason_lt?: InputMaybe<Scalars["String"]>
	reason_lte?: InputMaybe<Scalars["String"]>
	reason_not?: InputMaybe<Scalars["String"]>
	reason_not_contains?: InputMaybe<Scalars["String"]>
	reason_not_contains_nocase?: InputMaybe<Scalars["String"]>
	reason_not_ends_with?: InputMaybe<Scalars["String"]>
	reason_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	reason_not_in?: InputMaybe<Array<Scalars["String"]>>
	reason_not_starts_with?: InputMaybe<Scalars["String"]>
	reason_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	reason_starts_with?: InputMaybe<Scalars["String"]>
	reason_starts_with_nocase?: InputMaybe<Scalars["String"]>
	recipient?: InputMaybe<Scalars["Bytes"]>
	recipient_contains?: InputMaybe<Scalars["Bytes"]>
	recipient_in?: InputMaybe<Array<Scalars["Bytes"]>>
	recipient_not?: InputMaybe<Scalars["Bytes"]>
	recipient_not_contains?: InputMaybe<Scalars["Bytes"]>
	recipient_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
}

export enum MintAsDelegate_OrderBy {
	Amount = "amount",
	Delegate = "delegate",
	Id = "id",
	Reason = "reason",
	Recipient = "recipient",
}

export type MintReward = {
	__typename?: "MintReward"
	amount: Scalars["BigInt"]
	id: Scalars["ID"]
	recipient: Scalars["Bytes"]
	rewardType: Scalars["Int"]
}

export type MintReward_Filter = {
	amount?: InputMaybe<Scalars["BigInt"]>
	amount_gt?: InputMaybe<Scalars["BigInt"]>
	amount_gte?: InputMaybe<Scalars["BigInt"]>
	amount_in?: InputMaybe<Array<Scalars["BigInt"]>>
	amount_lt?: InputMaybe<Scalars["BigInt"]>
	amount_lte?: InputMaybe<Scalars["BigInt"]>
	amount_not?: InputMaybe<Scalars["BigInt"]>
	amount_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	recipient?: InputMaybe<Scalars["Bytes"]>
	recipient_contains?: InputMaybe<Scalars["Bytes"]>
	recipient_in?: InputMaybe<Array<Scalars["Bytes"]>>
	recipient_not?: InputMaybe<Scalars["Bytes"]>
	recipient_not_contains?: InputMaybe<Scalars["Bytes"]>
	recipient_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	rewardType?: InputMaybe<Scalars["Int"]>
	rewardType_gt?: InputMaybe<Scalars["Int"]>
	rewardType_gte?: InputMaybe<Scalars["Int"]>
	rewardType_in?: InputMaybe<Array<Scalars["Int"]>>
	rewardType_lt?: InputMaybe<Scalars["Int"]>
	rewardType_lte?: InputMaybe<Scalars["Int"]>
	rewardType_not?: InputMaybe<Scalars["Int"]>
	rewardType_not_in?: InputMaybe<Array<Scalars["Int"]>>
}

export enum MintReward_OrderBy {
	Amount = "amount",
	Id = "id",
	Recipient = "recipient",
	RewardType = "rewardType",
}

export enum MintType {
	Free = "FREE",
	Public = "PUBLIC",
	Whitelist = "WHITELIST",
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
	Asc = "asc",
	Desc = "desc",
}

export type Ownable = {
	__typename?: "Ownable"
	asAccount: Account
	id: Scalars["ID"]
	owner: Account
	ownershipTransferred: Array<OwnershipTransferred>
}

export type OwnableOwnershipTransferredArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<OwnershipTransferred_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<OwnershipTransferred_Filter>
}

export type Ownable_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	owner?: InputMaybe<Scalars["String"]>
	owner_contains?: InputMaybe<Scalars["String"]>
	owner_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_ends_with?: InputMaybe<Scalars["String"]>
	owner_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_gt?: InputMaybe<Scalars["String"]>
	owner_gte?: InputMaybe<Scalars["String"]>
	owner_in?: InputMaybe<Array<Scalars["String"]>>
	owner_lt?: InputMaybe<Scalars["String"]>
	owner_lte?: InputMaybe<Scalars["String"]>
	owner_not?: InputMaybe<Scalars["String"]>
	owner_not_contains?: InputMaybe<Scalars["String"]>
	owner_not_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_not_ends_with?: InputMaybe<Scalars["String"]>
	owner_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_not_in?: InputMaybe<Array<Scalars["String"]>>
	owner_not_starts_with?: InputMaybe<Scalars["String"]>
	owner_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner_starts_with?: InputMaybe<Scalars["String"]>
	owner_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Ownable_OrderBy {
	AsAccount = "asAccount",
	Id = "id",
	Owner = "owner",
	OwnershipTransferred = "ownershipTransferred",
}

export type OwnershipTransferred = Event & {
	__typename?: "OwnershipTransferred"
	contract: Ownable
	emitter: Account
	id: Scalars["ID"]
	owner: Account
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type OwnershipTransferred_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	owner?: InputMaybe<Scalars["String"]>
	owner_contains?: InputMaybe<Scalars["String"]>
	owner_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_ends_with?: InputMaybe<Scalars["String"]>
	owner_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_gt?: InputMaybe<Scalars["String"]>
	owner_gte?: InputMaybe<Scalars["String"]>
	owner_in?: InputMaybe<Array<Scalars["String"]>>
	owner_lt?: InputMaybe<Scalars["String"]>
	owner_lte?: InputMaybe<Scalars["String"]>
	owner_not?: InputMaybe<Scalars["String"]>
	owner_not_contains?: InputMaybe<Scalars["String"]>
	owner_not_contains_nocase?: InputMaybe<Scalars["String"]>
	owner_not_ends_with?: InputMaybe<Scalars["String"]>
	owner_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	owner_not_in?: InputMaybe<Array<Scalars["String"]>>
	owner_not_starts_with?: InputMaybe<Scalars["String"]>
	owner_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	owner_starts_with?: InputMaybe<Scalars["String"]>
	owner_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum OwnershipTransferred_OrderBy {
	Contract = "contract",
	Emitter = "emitter",
	Id = "id",
	Owner = "owner",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Pausable = {
	__typename?: "Pausable"
	asAccount: Account
	id: Scalars["ID"]
	isPaused: Scalars["Boolean"]
	paused: Array<Paused>
}

export type PausablePausedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Paused_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Paused_Filter>
}

export type Pausable_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	isPaused?: InputMaybe<Scalars["Boolean"]>
	isPaused_in?: InputMaybe<Array<Scalars["Boolean"]>>
	isPaused_not?: InputMaybe<Scalars["Boolean"]>
	isPaused_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
}

export enum Pausable_OrderBy {
	AsAccount = "asAccount",
	Id = "id",
	IsPaused = "isPaused",
	Paused = "paused",
}

export type Paused = Event & {
	__typename?: "Paused"
	contract: Pausable
	emitter: Account
	id: Scalars["ID"]
	isPaused: Scalars["Boolean"]
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type Paused_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	isPaused?: InputMaybe<Scalars["Boolean"]>
	isPaused_in?: InputMaybe<Array<Scalars["Boolean"]>>
	isPaused_not?: InputMaybe<Scalars["Boolean"]>
	isPaused_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Paused_OrderBy {
	Contract = "contract",
	Emitter = "emitter",
	Id = "id",
	IsPaused = "isPaused",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Proposal = {
	__typename?: "Proposal"
	calls: Array<ProposalCall>
	canceled: Scalars["Boolean"]
	description: Scalars["String"]
	endBlock: Scalars["BigInt"]
	eta?: Maybe<Scalars["BigInt"]>
	executed: Scalars["Boolean"]
	governor: Governor
	id: Scalars["ID"]
	proposalCanceled: Array<ProposalCanceled>
	proposalCreated: Array<ProposalCreated>
	proposalExecuted: Array<ProposalExecuted>
	proposalId: Scalars["BigInt"]
	proposalQueued: Array<ProposalQueued>
	proposer: Account
	queued: Scalars["Boolean"]
	receipts: Array<VoteReceipt>
	startBlock: Scalars["BigInt"]
	supports: Array<ProposalSupport>
	votecast: Array<VoteCast>
}

export type ProposalCallsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalCall_Filter>
}

export type ProposalProposalCanceledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCanceled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalCanceled_Filter>
}

export type ProposalProposalCreatedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCreated_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalCreated_Filter>
}

export type ProposalProposalExecutedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalExecuted_Filter>
}

export type ProposalProposalQueuedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalQueued_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalQueued_Filter>
}

export type ProposalReceiptsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteReceipt_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteReceipt_Filter>
}

export type ProposalSupportsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalSupport_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<ProposalSupport_Filter>
}

export type ProposalVotecastArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteCast_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteCast_Filter>
}

export type ProposalCall = {
	__typename?: "ProposalCall"
	calldata: Scalars["Bytes"]
	id: Scalars["ID"]
	index: Scalars["Int"]
	proposal: Proposal
	signature: Scalars["String"]
	target: Account
	value: Scalars["BigDecimal"]
}

export type ProposalCall_Filter = {
	calldata?: InputMaybe<Scalars["Bytes"]>
	calldata_contains?: InputMaybe<Scalars["Bytes"]>
	calldata_in?: InputMaybe<Array<Scalars["Bytes"]>>
	calldata_not?: InputMaybe<Scalars["Bytes"]>
	calldata_not_contains?: InputMaybe<Scalars["Bytes"]>
	calldata_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	index?: InputMaybe<Scalars["Int"]>
	index_gt?: InputMaybe<Scalars["Int"]>
	index_gte?: InputMaybe<Scalars["Int"]>
	index_in?: InputMaybe<Array<Scalars["Int"]>>
	index_lt?: InputMaybe<Scalars["Int"]>
	index_lte?: InputMaybe<Scalars["Int"]>
	index_not?: InputMaybe<Scalars["Int"]>
	index_not_in?: InputMaybe<Array<Scalars["Int"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	signature?: InputMaybe<Scalars["String"]>
	signature_contains?: InputMaybe<Scalars["String"]>
	signature_contains_nocase?: InputMaybe<Scalars["String"]>
	signature_ends_with?: InputMaybe<Scalars["String"]>
	signature_ends_with_nocase?: InputMaybe<Scalars["String"]>
	signature_gt?: InputMaybe<Scalars["String"]>
	signature_gte?: InputMaybe<Scalars["String"]>
	signature_in?: InputMaybe<Array<Scalars["String"]>>
	signature_lt?: InputMaybe<Scalars["String"]>
	signature_lte?: InputMaybe<Scalars["String"]>
	signature_not?: InputMaybe<Scalars["String"]>
	signature_not_contains?: InputMaybe<Scalars["String"]>
	signature_not_contains_nocase?: InputMaybe<Scalars["String"]>
	signature_not_ends_with?: InputMaybe<Scalars["String"]>
	signature_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	signature_not_in?: InputMaybe<Array<Scalars["String"]>>
	signature_not_starts_with?: InputMaybe<Scalars["String"]>
	signature_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	signature_starts_with?: InputMaybe<Scalars["String"]>
	signature_starts_with_nocase?: InputMaybe<Scalars["String"]>
	target?: InputMaybe<Scalars["String"]>
	target_contains?: InputMaybe<Scalars["String"]>
	target_contains_nocase?: InputMaybe<Scalars["String"]>
	target_ends_with?: InputMaybe<Scalars["String"]>
	target_ends_with_nocase?: InputMaybe<Scalars["String"]>
	target_gt?: InputMaybe<Scalars["String"]>
	target_gte?: InputMaybe<Scalars["String"]>
	target_in?: InputMaybe<Array<Scalars["String"]>>
	target_lt?: InputMaybe<Scalars["String"]>
	target_lte?: InputMaybe<Scalars["String"]>
	target_not?: InputMaybe<Scalars["String"]>
	target_not_contains?: InputMaybe<Scalars["String"]>
	target_not_contains_nocase?: InputMaybe<Scalars["String"]>
	target_not_ends_with?: InputMaybe<Scalars["String"]>
	target_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	target_not_in?: InputMaybe<Array<Scalars["String"]>>
	target_not_starts_with?: InputMaybe<Scalars["String"]>
	target_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	target_starts_with?: InputMaybe<Scalars["String"]>
	target_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value?: InputMaybe<Scalars["BigDecimal"]>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum ProposalCall_OrderBy {
	Calldata = "calldata",
	Id = "id",
	Index = "index",
	Proposal = "proposal",
	Signature = "signature",
	Target = "target",
	Value = "value",
}

export type ProposalCanceled = Event & {
	__typename?: "ProposalCanceled"
	emitter: Account
	governor: Governor
	id: Scalars["ID"]
	proposal: Proposal
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type ProposalCanceled_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor?: InputMaybe<Scalars["String"]>
	governor_contains?: InputMaybe<Scalars["String"]>
	governor_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_ends_with?: InputMaybe<Scalars["String"]>
	governor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_gt?: InputMaybe<Scalars["String"]>
	governor_gte?: InputMaybe<Scalars["String"]>
	governor_in?: InputMaybe<Array<Scalars["String"]>>
	governor_lt?: InputMaybe<Scalars["String"]>
	governor_lte?: InputMaybe<Scalars["String"]>
	governor_not?: InputMaybe<Scalars["String"]>
	governor_not_contains?: InputMaybe<Scalars["String"]>
	governor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_not_ends_with?: InputMaybe<Scalars["String"]>
	governor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_not_in?: InputMaybe<Array<Scalars["String"]>>
	governor_not_starts_with?: InputMaybe<Scalars["String"]>
	governor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor_starts_with?: InputMaybe<Scalars["String"]>
	governor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum ProposalCanceled_OrderBy {
	Emitter = "emitter",
	Governor = "governor",
	Id = "id",
	Proposal = "proposal",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type ProposalCreated = Event & {
	__typename?: "ProposalCreated"
	emitter: Account
	governor: Governor
	id: Scalars["ID"]
	proposal: Proposal
	proposer: Account
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type ProposalCreated_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor?: InputMaybe<Scalars["String"]>
	governor_contains?: InputMaybe<Scalars["String"]>
	governor_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_ends_with?: InputMaybe<Scalars["String"]>
	governor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_gt?: InputMaybe<Scalars["String"]>
	governor_gte?: InputMaybe<Scalars["String"]>
	governor_in?: InputMaybe<Array<Scalars["String"]>>
	governor_lt?: InputMaybe<Scalars["String"]>
	governor_lte?: InputMaybe<Scalars["String"]>
	governor_not?: InputMaybe<Scalars["String"]>
	governor_not_contains?: InputMaybe<Scalars["String"]>
	governor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_not_ends_with?: InputMaybe<Scalars["String"]>
	governor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_not_in?: InputMaybe<Array<Scalars["String"]>>
	governor_not_starts_with?: InputMaybe<Scalars["String"]>
	governor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor_starts_with?: InputMaybe<Scalars["String"]>
	governor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposer?: InputMaybe<Scalars["String"]>
	proposer_contains?: InputMaybe<Scalars["String"]>
	proposer_contains_nocase?: InputMaybe<Scalars["String"]>
	proposer_ends_with?: InputMaybe<Scalars["String"]>
	proposer_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposer_gt?: InputMaybe<Scalars["String"]>
	proposer_gte?: InputMaybe<Scalars["String"]>
	proposer_in?: InputMaybe<Array<Scalars["String"]>>
	proposer_lt?: InputMaybe<Scalars["String"]>
	proposer_lte?: InputMaybe<Scalars["String"]>
	proposer_not?: InputMaybe<Scalars["String"]>
	proposer_not_contains?: InputMaybe<Scalars["String"]>
	proposer_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposer_not_ends_with?: InputMaybe<Scalars["String"]>
	proposer_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposer_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposer_not_starts_with?: InputMaybe<Scalars["String"]>
	proposer_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposer_starts_with?: InputMaybe<Scalars["String"]>
	proposer_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum ProposalCreated_OrderBy {
	Emitter = "emitter",
	Governor = "governor",
	Id = "id",
	Proposal = "proposal",
	Proposer = "proposer",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type ProposalExecuted = Event & {
	__typename?: "ProposalExecuted"
	emitter: Account
	governor: Governor
	id: Scalars["ID"]
	proposal: Proposal
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type ProposalExecuted_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor?: InputMaybe<Scalars["String"]>
	governor_contains?: InputMaybe<Scalars["String"]>
	governor_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_ends_with?: InputMaybe<Scalars["String"]>
	governor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_gt?: InputMaybe<Scalars["String"]>
	governor_gte?: InputMaybe<Scalars["String"]>
	governor_in?: InputMaybe<Array<Scalars["String"]>>
	governor_lt?: InputMaybe<Scalars["String"]>
	governor_lte?: InputMaybe<Scalars["String"]>
	governor_not?: InputMaybe<Scalars["String"]>
	governor_not_contains?: InputMaybe<Scalars["String"]>
	governor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_not_ends_with?: InputMaybe<Scalars["String"]>
	governor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_not_in?: InputMaybe<Array<Scalars["String"]>>
	governor_not_starts_with?: InputMaybe<Scalars["String"]>
	governor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor_starts_with?: InputMaybe<Scalars["String"]>
	governor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum ProposalExecuted_OrderBy {
	Emitter = "emitter",
	Governor = "governor",
	Id = "id",
	Proposal = "proposal",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type ProposalQueued = Event & {
	__typename?: "ProposalQueued"
	emitter: Account
	eta: Scalars["BigInt"]
	governor: Governor
	id: Scalars["ID"]
	proposal: Proposal
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type ProposalQueued_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	eta?: InputMaybe<Scalars["BigInt"]>
	eta_gt?: InputMaybe<Scalars["BigInt"]>
	eta_gte?: InputMaybe<Scalars["BigInt"]>
	eta_in?: InputMaybe<Array<Scalars["BigInt"]>>
	eta_lt?: InputMaybe<Scalars["BigInt"]>
	eta_lte?: InputMaybe<Scalars["BigInt"]>
	eta_not?: InputMaybe<Scalars["BigInt"]>
	eta_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	governor?: InputMaybe<Scalars["String"]>
	governor_contains?: InputMaybe<Scalars["String"]>
	governor_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_ends_with?: InputMaybe<Scalars["String"]>
	governor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_gt?: InputMaybe<Scalars["String"]>
	governor_gte?: InputMaybe<Scalars["String"]>
	governor_in?: InputMaybe<Array<Scalars["String"]>>
	governor_lt?: InputMaybe<Scalars["String"]>
	governor_lte?: InputMaybe<Scalars["String"]>
	governor_not?: InputMaybe<Scalars["String"]>
	governor_not_contains?: InputMaybe<Scalars["String"]>
	governor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_not_ends_with?: InputMaybe<Scalars["String"]>
	governor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_not_in?: InputMaybe<Array<Scalars["String"]>>
	governor_not_starts_with?: InputMaybe<Scalars["String"]>
	governor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor_starts_with?: InputMaybe<Scalars["String"]>
	governor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum ProposalQueued_OrderBy {
	Emitter = "emitter",
	Eta = "eta",
	Governor = "governor",
	Id = "id",
	Proposal = "proposal",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type ProposalSupport = {
	__typename?: "ProposalSupport"
	id: Scalars["ID"]
	proposal: Proposal
	support: Scalars["Int"]
	votes: Array<VoteReceipt>
}

export type ProposalSupportVotesArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteReceipt_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteReceipt_Filter>
}

export type ProposalSupport_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	support?: InputMaybe<Scalars["Int"]>
	support_gt?: InputMaybe<Scalars["Int"]>
	support_gte?: InputMaybe<Scalars["Int"]>
	support_in?: InputMaybe<Array<Scalars["Int"]>>
	support_lt?: InputMaybe<Scalars["Int"]>
	support_lte?: InputMaybe<Scalars["Int"]>
	support_not?: InputMaybe<Scalars["Int"]>
	support_not_in?: InputMaybe<Array<Scalars["Int"]>>
}

export enum ProposalSupport_OrderBy {
	Id = "id",
	Proposal = "proposal",
	Support = "support",
	Votes = "votes",
}

export type Proposal_Filter = {
	canceled?: InputMaybe<Scalars["Boolean"]>
	canceled_in?: InputMaybe<Array<Scalars["Boolean"]>>
	canceled_not?: InputMaybe<Scalars["Boolean"]>
	canceled_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	description?: InputMaybe<Scalars["String"]>
	description_contains?: InputMaybe<Scalars["String"]>
	description_contains_nocase?: InputMaybe<Scalars["String"]>
	description_ends_with?: InputMaybe<Scalars["String"]>
	description_ends_with_nocase?: InputMaybe<Scalars["String"]>
	description_gt?: InputMaybe<Scalars["String"]>
	description_gte?: InputMaybe<Scalars["String"]>
	description_in?: InputMaybe<Array<Scalars["String"]>>
	description_lt?: InputMaybe<Scalars["String"]>
	description_lte?: InputMaybe<Scalars["String"]>
	description_not?: InputMaybe<Scalars["String"]>
	description_not_contains?: InputMaybe<Scalars["String"]>
	description_not_contains_nocase?: InputMaybe<Scalars["String"]>
	description_not_ends_with?: InputMaybe<Scalars["String"]>
	description_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	description_not_in?: InputMaybe<Array<Scalars["String"]>>
	description_not_starts_with?: InputMaybe<Scalars["String"]>
	description_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	description_starts_with?: InputMaybe<Scalars["String"]>
	description_starts_with_nocase?: InputMaybe<Scalars["String"]>
	endBlock?: InputMaybe<Scalars["BigInt"]>
	endBlock_gt?: InputMaybe<Scalars["BigInt"]>
	endBlock_gte?: InputMaybe<Scalars["BigInt"]>
	endBlock_in?: InputMaybe<Array<Scalars["BigInt"]>>
	endBlock_lt?: InputMaybe<Scalars["BigInt"]>
	endBlock_lte?: InputMaybe<Scalars["BigInt"]>
	endBlock_not?: InputMaybe<Scalars["BigInt"]>
	endBlock_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	eta?: InputMaybe<Scalars["BigInt"]>
	eta_gt?: InputMaybe<Scalars["BigInt"]>
	eta_gte?: InputMaybe<Scalars["BigInt"]>
	eta_in?: InputMaybe<Array<Scalars["BigInt"]>>
	eta_lt?: InputMaybe<Scalars["BigInt"]>
	eta_lte?: InputMaybe<Scalars["BigInt"]>
	eta_not?: InputMaybe<Scalars["BigInt"]>
	eta_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	executed?: InputMaybe<Scalars["Boolean"]>
	executed_in?: InputMaybe<Array<Scalars["Boolean"]>>
	executed_not?: InputMaybe<Scalars["Boolean"]>
	executed_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	governor?: InputMaybe<Scalars["String"]>
	governor_contains?: InputMaybe<Scalars["String"]>
	governor_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_ends_with?: InputMaybe<Scalars["String"]>
	governor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_gt?: InputMaybe<Scalars["String"]>
	governor_gte?: InputMaybe<Scalars["String"]>
	governor_in?: InputMaybe<Array<Scalars["String"]>>
	governor_lt?: InputMaybe<Scalars["String"]>
	governor_lte?: InputMaybe<Scalars["String"]>
	governor_not?: InputMaybe<Scalars["String"]>
	governor_not_contains?: InputMaybe<Scalars["String"]>
	governor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_not_ends_with?: InputMaybe<Scalars["String"]>
	governor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_not_in?: InputMaybe<Array<Scalars["String"]>>
	governor_not_starts_with?: InputMaybe<Scalars["String"]>
	governor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor_starts_with?: InputMaybe<Scalars["String"]>
	governor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposalId?: InputMaybe<Scalars["BigInt"]>
	proposalId_gt?: InputMaybe<Scalars["BigInt"]>
	proposalId_gte?: InputMaybe<Scalars["BigInt"]>
	proposalId_in?: InputMaybe<Array<Scalars["BigInt"]>>
	proposalId_lt?: InputMaybe<Scalars["BigInt"]>
	proposalId_lte?: InputMaybe<Scalars["BigInt"]>
	proposalId_not?: InputMaybe<Scalars["BigInt"]>
	proposalId_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	proposer?: InputMaybe<Scalars["String"]>
	proposer_contains?: InputMaybe<Scalars["String"]>
	proposer_contains_nocase?: InputMaybe<Scalars["String"]>
	proposer_ends_with?: InputMaybe<Scalars["String"]>
	proposer_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposer_gt?: InputMaybe<Scalars["String"]>
	proposer_gte?: InputMaybe<Scalars["String"]>
	proposer_in?: InputMaybe<Array<Scalars["String"]>>
	proposer_lt?: InputMaybe<Scalars["String"]>
	proposer_lte?: InputMaybe<Scalars["String"]>
	proposer_not?: InputMaybe<Scalars["String"]>
	proposer_not_contains?: InputMaybe<Scalars["String"]>
	proposer_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposer_not_ends_with?: InputMaybe<Scalars["String"]>
	proposer_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposer_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposer_not_starts_with?: InputMaybe<Scalars["String"]>
	proposer_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposer_starts_with?: InputMaybe<Scalars["String"]>
	proposer_starts_with_nocase?: InputMaybe<Scalars["String"]>
	queued?: InputMaybe<Scalars["Boolean"]>
	queued_in?: InputMaybe<Array<Scalars["Boolean"]>>
	queued_not?: InputMaybe<Scalars["Boolean"]>
	queued_not_in?: InputMaybe<Array<Scalars["Boolean"]>>
	startBlock?: InputMaybe<Scalars["BigInt"]>
	startBlock_gt?: InputMaybe<Scalars["BigInt"]>
	startBlock_gte?: InputMaybe<Scalars["BigInt"]>
	startBlock_in?: InputMaybe<Array<Scalars["BigInt"]>>
	startBlock_lt?: InputMaybe<Scalars["BigInt"]>
	startBlock_lte?: InputMaybe<Scalars["BigInt"]>
	startBlock_not?: InputMaybe<Scalars["BigInt"]>
	startBlock_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum Proposal_OrderBy {
	Calls = "calls",
	Canceled = "canceled",
	Description = "description",
	EndBlock = "endBlock",
	Eta = "eta",
	Executed = "executed",
	Governor = "governor",
	Id = "id",
	ProposalCanceled = "proposalCanceled",
	ProposalCreated = "proposalCreated",
	ProposalExecuted = "proposalExecuted",
	ProposalId = "proposalId",
	ProposalQueued = "proposalQueued",
	Proposer = "proposer",
	Queued = "queued",
	Receipts = "receipts",
	StartBlock = "startBlock",
	Supports = "supports",
	Votecast = "votecast",
}

export type Query = {
	__typename?: "Query"
	/** Access to subgraph metadata */
	_meta?: Maybe<_Meta_>
	accessControl?: Maybe<AccessControl>
	accessControlRole?: Maybe<AccessControlRole>
	accessControlRoleMember?: Maybe<AccessControlRoleMember>
	accessControlRoleMembers: Array<AccessControlRoleMember>
	accessControlRoles: Array<AccessControlRole>
	accessControls: Array<AccessControl>
	account?: Maybe<Account>
	accounts: Array<Account>
	addDelegate?: Maybe<AddDelegate>
	addDelegates: Array<AddDelegate>
	approval?: Maybe<Approval>
	approvals: Array<Approval>
	claimBlocks: Array<ClaimBlocks>
	delegateChanged?: Maybe<DelegateChanged>
	delegateChangeds: Array<DelegateChanged>
	delegateVotesChanged?: Maybe<DelegateVotesChanged>
	delegateVotesChangeds: Array<DelegateVotesChanged>
	erc20Approval?: Maybe<Erc20Approval>
	erc20Approvals: Array<Erc20Approval>
	erc20Balance?: Maybe<Erc20Balance>
	erc20Balances: Array<Erc20Balance>
	erc20Contract?: Maybe<Erc20Contract>
	erc20Contracts: Array<Erc20Contract>
	erc20Transfer?: Maybe<Erc20Transfer>
	erc20Transfers: Array<Erc20Transfer>
	erc721Contract?: Maybe<Erc721Contract>
	erc721Contracts: Array<Erc721Contract>
	erc721Operator?: Maybe<Erc721Operator>
	erc721Operators: Array<Erc721Operator>
	erc721Token?: Maybe<Erc721Token>
	erc721Tokens: Array<Erc721Token>
	erc721Transfer?: Maybe<Erc721Transfer>
	erc721Transfers: Array<Erc721Transfer>
	erc1155Balance?: Maybe<Erc1155Balance>
	erc1155Balances: Array<Erc1155Balance>
	erc1155Contract?: Maybe<Erc1155Contract>
	erc1155Contracts: Array<Erc1155Contract>
	erc1155Operator?: Maybe<Erc1155Operator>
	erc1155Operators: Array<Erc1155Operator>
	erc1155Token?: Maybe<Erc1155Token>
	erc1155Tokens: Array<Erc1155Token>
	erc1155Transfer?: Maybe<Erc1155Transfer>
	erc1155Transfers: Array<Erc1155Transfer>
	erc1967AdminChanged?: Maybe<Erc1967AdminChanged>
	erc1967AdminChangeds: Array<Erc1967AdminChanged>
	erc1967BeaconUpgraded?: Maybe<Erc1967BeaconUpgraded>
	erc1967BeaconUpgradeds: Array<Erc1967BeaconUpgraded>
	erc1967ImplementationUpgraded?: Maybe<Erc1967ImplementationUpgraded>
	erc1967ImplementationUpgradeds: Array<Erc1967ImplementationUpgraded>
	event?: Maybe<Event>
	events: Array<Event>
	farmer?: Maybe<Farmer>
	farmers: Array<Farmer>
	governor?: Maybe<Governor>
	governors: Array<Governor>
	mintAsDelegate?: Maybe<MintAsDelegate>
	mintAsDelegates: Array<MintAsDelegate>
	mintReward?: Maybe<MintReward>
	mintRewards: Array<MintReward>
	ownable?: Maybe<Ownable>
	ownables: Array<Ownable>
	ownershipTransferred?: Maybe<OwnershipTransferred>
	ownershipTransferreds: Array<OwnershipTransferred>
	pausable?: Maybe<Pausable>
	pausables: Array<Pausable>
	paused?: Maybe<Paused>
	pauseds: Array<Paused>
	proposal?: Maybe<Proposal>
	proposalCall?: Maybe<ProposalCall>
	proposalCalls: Array<ProposalCall>
	proposalCanceled?: Maybe<ProposalCanceled>
	proposalCanceleds: Array<ProposalCanceled>
	proposalCreated?: Maybe<ProposalCreated>
	proposalCreateds: Array<ProposalCreated>
	proposalExecuted?: Maybe<ProposalExecuted>
	proposalExecuteds: Array<ProposalExecuted>
	proposalQueued?: Maybe<ProposalQueued>
	proposalQueueds: Array<ProposalQueued>
	proposalSupport?: Maybe<ProposalSupport>
	proposalSupports: Array<ProposalSupport>
	proposals: Array<Proposal>
	removeDelegate?: Maybe<RemoveDelegate>
	removeDelegates: Array<RemoveDelegate>
	role?: Maybe<Role>
	roleAdminChanged?: Maybe<RoleAdminChanged>
	roleAdminChangeds: Array<RoleAdminChanged>
	roleGranted?: Maybe<RoleGranted>
	roleGranteds: Array<RoleGranted>
	roleRevoked?: Maybe<RoleRevoked>
	roleRevokeds: Array<RoleRevoked>
	roles: Array<Role>
	skill?: Maybe<Skill>
	skillCategories: Array<SkillCategory>
	skillCategory?: Maybe<SkillCategory>
	skills: Array<Skill>
	stakeFarmer?: Maybe<StakeFarmer>
	stakeFarmers: Array<StakeFarmer>
	timelock?: Maybe<Timelock>
	timelockCall?: Maybe<TimelockCall>
	timelockCalls: Array<TimelockCall>
	timelockMinDelayChange?: Maybe<TimelockMinDelayChange>
	timelockMinDelayChanges: Array<TimelockMinDelayChange>
	timelockOperation?: Maybe<TimelockOperation>
	timelockOperationCancelled?: Maybe<TimelockOperationCancelled>
	timelockOperationCancelleds: Array<TimelockOperationCancelled>
	timelockOperationExecuted?: Maybe<TimelockOperationExecuted>
	timelockOperationExecuteds: Array<TimelockOperationExecuted>
	timelockOperationScheduled?: Maybe<TimelockOperationScheduled>
	timelockOperationScheduleds: Array<TimelockOperationScheduled>
	timelockOperations: Array<TimelockOperation>
	timelocks: Array<Timelock>
	trait?: Maybe<Trait>
	traitCategories: Array<TraitCategory>
	traitCategory?: Maybe<TraitCategory>
	traits: Array<Trait>
	transaction?: Maybe<Transaction>
	transactions: Array<Transaction>
	transfer?: Maybe<Transfer>
	transfers: Array<Transfer>
	unpaused?: Maybe<Unpaused>
	unpauseds: Array<Unpaused>
	voteCast?: Maybe<VoteCast>
	voteCasts: Array<VoteCast>
	voteDelegation?: Maybe<VoteDelegation>
	voteDelegations: Array<VoteDelegation>
	voteReceipt?: Maybe<VoteReceipt>
	voteReceipts: Array<VoteReceipt>
	voteWeight?: Maybe<VoteWeight>
	voteWeights: Array<VoteWeight>
	votingContract?: Maybe<VotingContract>
	votingContracts: Array<VotingContract>
	withdrawFarmer?: Maybe<WithdrawFarmer>
	withdrawFarmers: Array<WithdrawFarmer>
}

export type Query_MetaArgs = {
	block?: InputMaybe<Block_Height>
}

export type QueryAccessControlArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryAccessControlRoleArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryAccessControlRoleMemberArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryAccessControlRoleMembersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRoleMember_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AccessControlRoleMember_Filter>
}

export type QueryAccessControlRolesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRole_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AccessControlRole_Filter>
}

export type QueryAccessControlsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControl_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AccessControl_Filter>
}

export type QueryAccountArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryAccountsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Account_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Account_Filter>
}

export type QueryAddDelegateArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryAddDelegatesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AddDelegate_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AddDelegate_Filter>
}

export type QueryApprovalArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryApprovalsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Approval_Filter>
}

export type QueryClaimBlocksArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ClaimBlocks_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ClaimBlocks_Filter>
}

export type QueryDelegateChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryDelegateChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<DelegateChanged_Filter>
}

export type QueryDelegateVotesChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryDelegateVotesChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateVotesChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<DelegateVotesChanged_Filter>
}

export type QueryErc20ApprovalArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc20ApprovalsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Approval_Filter>
}

export type QueryErc20BalanceArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc20BalancesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Balance_Filter>
}

export type QueryErc20ContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc20ContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Contract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Contract_Filter>
}

export type QueryErc20TransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc20TransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type QueryErc721ContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc721ContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Contract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Contract_Filter>
}

export type QueryErc721OperatorArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc721OperatorsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Operator_Filter>
}

export type QueryErc721TokenArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc721TokensArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Token_Filter>
}

export type QueryErc721TransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc721TransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Transfer_Filter>
}

export type QueryErc1155BalanceArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1155BalancesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Balance_Filter>
}

export type QueryErc1155ContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1155ContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Contract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Contract_Filter>
}

export type QueryErc1155OperatorArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1155OperatorsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Operator_Filter>
}

export type QueryErc1155TokenArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1155TokensArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Token_Filter>
}

export type QueryErc1155TransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1155TransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type QueryErc1967AdminChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1967AdminChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967AdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1967AdminChanged_Filter>
}

export type QueryErc1967BeaconUpgradedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1967BeaconUpgradedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967BeaconUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1967BeaconUpgraded_Filter>
}

export type QueryErc1967ImplementationUpgradedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryErc1967ImplementationUpgradedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967ImplementationUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1967ImplementationUpgraded_Filter>
}

export type QueryEventArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryEventsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Event_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Event_Filter>
}

export type QueryFarmerArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryFarmersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Farmer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Farmer_Filter>
}

export type QueryGovernorArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryGovernorsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Governor_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Governor_Filter>
}

export type QueryMintAsDelegateArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryMintAsDelegatesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<MintAsDelegate_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<MintAsDelegate_Filter>
}

export type QueryMintRewardArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryMintRewardsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<MintReward_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<MintReward_Filter>
}

export type QueryOwnableArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryOwnablesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Ownable_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Ownable_Filter>
}

export type QueryOwnershipTransferredArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryOwnershipTransferredsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<OwnershipTransferred_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<OwnershipTransferred_Filter>
}

export type QueryPausableArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryPausablesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Pausable_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Pausable_Filter>
}

export type QueryPausedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryPausedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Paused_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Paused_Filter>
}

export type QueryProposalArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalCallArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalCallsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalCall_Filter>
}

export type QueryProposalCanceledArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalCanceledsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCanceled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalCanceled_Filter>
}

export type QueryProposalCreatedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalCreatedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCreated_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalCreated_Filter>
}

export type QueryProposalExecutedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalExecutedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalExecuted_Filter>
}

export type QueryProposalQueuedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalQueuedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalQueued_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalQueued_Filter>
}

export type QueryProposalSupportArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProposalSupportsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalSupport_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalSupport_Filter>
}

export type QueryProposalsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Proposal_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Proposal_Filter>
}

export type QueryRemoveDelegateArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryRemoveDelegatesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RemoveDelegate_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RemoveDelegate_Filter>
}

export type QueryRoleArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryRoleAdminChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryRoleAdminChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleAdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RoleAdminChanged_Filter>
}

export type QueryRoleGrantedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryRoleGrantedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleGranted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RoleGranted_Filter>
}

export type QueryRoleRevokedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryRoleRevokedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleRevoked_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RoleRevoked_Filter>
}

export type QueryRolesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Role_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Role_Filter>
}

export type QuerySkillArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QuerySkillCategoriesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<SkillCategory_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<SkillCategory_Filter>
}

export type QuerySkillCategoryArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QuerySkillsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Skill_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Skill_Filter>
}

export type QueryStakeFarmerArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryStakeFarmersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<StakeFarmer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<StakeFarmer_Filter>
}

export type QueryTimelockArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockCallArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockCallsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockCall_Filter>
}

export type QueryTimelockMinDelayChangeArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockMinDelayChangesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockMinDelayChange_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockMinDelayChange_Filter>
}

export type QueryTimelockOperationArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockOperationCancelledArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockOperationCancelledsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationCancelled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperationCancelled_Filter>
}

export type QueryTimelockOperationExecutedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockOperationExecutedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperationExecuted_Filter>
}

export type QueryTimelockOperationScheduledArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTimelockOperationScheduledsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationScheduled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperationScheduled_Filter>
}

export type QueryTimelockOperationsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperation_Filter>
}

export type QueryTimelocksArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Timelock_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Timelock_Filter>
}

export type QueryTraitArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTraitCategoriesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TraitCategory_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TraitCategory_Filter>
}

export type QueryTraitCategoryArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTraitsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Trait_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Trait_Filter>
}

export type QueryTransactionArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTransactionsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Transaction_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Transaction_Filter>
}

export type QueryTransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Transfer_Filter>
}

export type QueryUnpausedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryUnpausedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Unpaused_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Unpaused_Filter>
}

export type QueryVoteCastArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryVoteCastsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteCast_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteCast_Filter>
}

export type QueryVoteDelegationArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryVoteDelegationsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteDelegation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteDelegation_Filter>
}

export type QueryVoteReceiptArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryVoteReceiptsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteReceipt_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteReceipt_Filter>
}

export type QueryVoteWeightArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryVoteWeightsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteWeight_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteWeight_Filter>
}

export type QueryVotingContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryVotingContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VotingContract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VotingContract_Filter>
}

export type QueryWithdrawFarmerArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type QueryWithdrawFarmersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<WithdrawFarmer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<WithdrawFarmer_Filter>
}

export type RemoveDelegate = {
	__typename?: "RemoveDelegate"
	delegate: Scalars["Bytes"]
	id: Scalars["ID"]
}

export type RemoveDelegate_Filter = {
	delegate?: InputMaybe<Scalars["Bytes"]>
	delegate_contains?: InputMaybe<Scalars["Bytes"]>
	delegate_in?: InputMaybe<Array<Scalars["Bytes"]>>
	delegate_not?: InputMaybe<Scalars["Bytes"]>
	delegate_not_contains?: InputMaybe<Scalars["Bytes"]>
	delegate_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum RemoveDelegate_OrderBy {
	Delegate = "delegate",
	Id = "id",
}

export enum RevealType {
	PostMigration = "PostMigration",
	PreMigration = "PreMigration",
}

export type Role = {
	__typename?: "Role"
	id: Scalars["ID"]
	roleOf: Array<AccessControlRole>
}

export type RoleRoleOfArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRole_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<AccessControlRole_Filter>
}

export type RoleAdminChanged = Event & {
	__typename?: "RoleAdminChanged"
	emitter: Account
	id: Scalars["ID"]
	newAdminRole: AccessControlRole
	previousAdminRole: AccessControlRole
	role: AccessControlRole
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type RoleAdminChanged_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	newAdminRole?: InputMaybe<Scalars["String"]>
	newAdminRole_contains?: InputMaybe<Scalars["String"]>
	newAdminRole_contains_nocase?: InputMaybe<Scalars["String"]>
	newAdminRole_ends_with?: InputMaybe<Scalars["String"]>
	newAdminRole_ends_with_nocase?: InputMaybe<Scalars["String"]>
	newAdminRole_gt?: InputMaybe<Scalars["String"]>
	newAdminRole_gte?: InputMaybe<Scalars["String"]>
	newAdminRole_in?: InputMaybe<Array<Scalars["String"]>>
	newAdminRole_lt?: InputMaybe<Scalars["String"]>
	newAdminRole_lte?: InputMaybe<Scalars["String"]>
	newAdminRole_not?: InputMaybe<Scalars["String"]>
	newAdminRole_not_contains?: InputMaybe<Scalars["String"]>
	newAdminRole_not_contains_nocase?: InputMaybe<Scalars["String"]>
	newAdminRole_not_ends_with?: InputMaybe<Scalars["String"]>
	newAdminRole_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	newAdminRole_not_in?: InputMaybe<Array<Scalars["String"]>>
	newAdminRole_not_starts_with?: InputMaybe<Scalars["String"]>
	newAdminRole_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	newAdminRole_starts_with?: InputMaybe<Scalars["String"]>
	newAdminRole_starts_with_nocase?: InputMaybe<Scalars["String"]>
	previousAdminRole?: InputMaybe<Scalars["String"]>
	previousAdminRole_contains?: InputMaybe<Scalars["String"]>
	previousAdminRole_contains_nocase?: InputMaybe<Scalars["String"]>
	previousAdminRole_ends_with?: InputMaybe<Scalars["String"]>
	previousAdminRole_ends_with_nocase?: InputMaybe<Scalars["String"]>
	previousAdminRole_gt?: InputMaybe<Scalars["String"]>
	previousAdminRole_gte?: InputMaybe<Scalars["String"]>
	previousAdminRole_in?: InputMaybe<Array<Scalars["String"]>>
	previousAdminRole_lt?: InputMaybe<Scalars["String"]>
	previousAdminRole_lte?: InputMaybe<Scalars["String"]>
	previousAdminRole_not?: InputMaybe<Scalars["String"]>
	previousAdminRole_not_contains?: InputMaybe<Scalars["String"]>
	previousAdminRole_not_contains_nocase?: InputMaybe<Scalars["String"]>
	previousAdminRole_not_ends_with?: InputMaybe<Scalars["String"]>
	previousAdminRole_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	previousAdminRole_not_in?: InputMaybe<Array<Scalars["String"]>>
	previousAdminRole_not_starts_with?: InputMaybe<Scalars["String"]>
	previousAdminRole_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	previousAdminRole_starts_with?: InputMaybe<Scalars["String"]>
	previousAdminRole_starts_with_nocase?: InputMaybe<Scalars["String"]>
	role?: InputMaybe<Scalars["String"]>
	role_contains?: InputMaybe<Scalars["String"]>
	role_contains_nocase?: InputMaybe<Scalars["String"]>
	role_ends_with?: InputMaybe<Scalars["String"]>
	role_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_gt?: InputMaybe<Scalars["String"]>
	role_gte?: InputMaybe<Scalars["String"]>
	role_in?: InputMaybe<Array<Scalars["String"]>>
	role_lt?: InputMaybe<Scalars["String"]>
	role_lte?: InputMaybe<Scalars["String"]>
	role_not?: InputMaybe<Scalars["String"]>
	role_not_contains?: InputMaybe<Scalars["String"]>
	role_not_contains_nocase?: InputMaybe<Scalars["String"]>
	role_not_ends_with?: InputMaybe<Scalars["String"]>
	role_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_not_in?: InputMaybe<Array<Scalars["String"]>>
	role_not_starts_with?: InputMaybe<Scalars["String"]>
	role_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	role_starts_with?: InputMaybe<Scalars["String"]>
	role_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum RoleAdminChanged_OrderBy {
	Emitter = "emitter",
	Id = "id",
	NewAdminRole = "newAdminRole",
	PreviousAdminRole = "previousAdminRole",
	Role = "role",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type RoleGranted = Event & {
	__typename?: "RoleGranted"
	account: Account
	emitter: Account
	id: Scalars["ID"]
	role: AccessControlRole
	sender: Account
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type RoleGranted_Filter = {
	account?: InputMaybe<Scalars["String"]>
	account_contains?: InputMaybe<Scalars["String"]>
	account_contains_nocase?: InputMaybe<Scalars["String"]>
	account_ends_with?: InputMaybe<Scalars["String"]>
	account_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_gt?: InputMaybe<Scalars["String"]>
	account_gte?: InputMaybe<Scalars["String"]>
	account_in?: InputMaybe<Array<Scalars["String"]>>
	account_lt?: InputMaybe<Scalars["String"]>
	account_lte?: InputMaybe<Scalars["String"]>
	account_not?: InputMaybe<Scalars["String"]>
	account_not_contains?: InputMaybe<Scalars["String"]>
	account_not_contains_nocase?: InputMaybe<Scalars["String"]>
	account_not_ends_with?: InputMaybe<Scalars["String"]>
	account_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_not_in?: InputMaybe<Array<Scalars["String"]>>
	account_not_starts_with?: InputMaybe<Scalars["String"]>
	account_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account_starts_with?: InputMaybe<Scalars["String"]>
	account_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	role?: InputMaybe<Scalars["String"]>
	role_contains?: InputMaybe<Scalars["String"]>
	role_contains_nocase?: InputMaybe<Scalars["String"]>
	role_ends_with?: InputMaybe<Scalars["String"]>
	role_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_gt?: InputMaybe<Scalars["String"]>
	role_gte?: InputMaybe<Scalars["String"]>
	role_in?: InputMaybe<Array<Scalars["String"]>>
	role_lt?: InputMaybe<Scalars["String"]>
	role_lte?: InputMaybe<Scalars["String"]>
	role_not?: InputMaybe<Scalars["String"]>
	role_not_contains?: InputMaybe<Scalars["String"]>
	role_not_contains_nocase?: InputMaybe<Scalars["String"]>
	role_not_ends_with?: InputMaybe<Scalars["String"]>
	role_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_not_in?: InputMaybe<Array<Scalars["String"]>>
	role_not_starts_with?: InputMaybe<Scalars["String"]>
	role_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	role_starts_with?: InputMaybe<Scalars["String"]>
	role_starts_with_nocase?: InputMaybe<Scalars["String"]>
	sender?: InputMaybe<Scalars["String"]>
	sender_contains?: InputMaybe<Scalars["String"]>
	sender_contains_nocase?: InputMaybe<Scalars["String"]>
	sender_ends_with?: InputMaybe<Scalars["String"]>
	sender_ends_with_nocase?: InputMaybe<Scalars["String"]>
	sender_gt?: InputMaybe<Scalars["String"]>
	sender_gte?: InputMaybe<Scalars["String"]>
	sender_in?: InputMaybe<Array<Scalars["String"]>>
	sender_lt?: InputMaybe<Scalars["String"]>
	sender_lte?: InputMaybe<Scalars["String"]>
	sender_not?: InputMaybe<Scalars["String"]>
	sender_not_contains?: InputMaybe<Scalars["String"]>
	sender_not_contains_nocase?: InputMaybe<Scalars["String"]>
	sender_not_ends_with?: InputMaybe<Scalars["String"]>
	sender_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	sender_not_in?: InputMaybe<Array<Scalars["String"]>>
	sender_not_starts_with?: InputMaybe<Scalars["String"]>
	sender_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	sender_starts_with?: InputMaybe<Scalars["String"]>
	sender_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum RoleGranted_OrderBy {
	Account = "account",
	Emitter = "emitter",
	Id = "id",
	Role = "role",
	Sender = "sender",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type RoleRevoked = Event & {
	__typename?: "RoleRevoked"
	account: Account
	emitter: Account
	id: Scalars["ID"]
	role: AccessControlRole
	sender: Account
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type RoleRevoked_Filter = {
	account?: InputMaybe<Scalars["String"]>
	account_contains?: InputMaybe<Scalars["String"]>
	account_contains_nocase?: InputMaybe<Scalars["String"]>
	account_ends_with?: InputMaybe<Scalars["String"]>
	account_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_gt?: InputMaybe<Scalars["String"]>
	account_gte?: InputMaybe<Scalars["String"]>
	account_in?: InputMaybe<Array<Scalars["String"]>>
	account_lt?: InputMaybe<Scalars["String"]>
	account_lte?: InputMaybe<Scalars["String"]>
	account_not?: InputMaybe<Scalars["String"]>
	account_not_contains?: InputMaybe<Scalars["String"]>
	account_not_contains_nocase?: InputMaybe<Scalars["String"]>
	account_not_ends_with?: InputMaybe<Scalars["String"]>
	account_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_not_in?: InputMaybe<Array<Scalars["String"]>>
	account_not_starts_with?: InputMaybe<Scalars["String"]>
	account_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account_starts_with?: InputMaybe<Scalars["String"]>
	account_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	role?: InputMaybe<Scalars["String"]>
	role_contains?: InputMaybe<Scalars["String"]>
	role_contains_nocase?: InputMaybe<Scalars["String"]>
	role_ends_with?: InputMaybe<Scalars["String"]>
	role_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_gt?: InputMaybe<Scalars["String"]>
	role_gte?: InputMaybe<Scalars["String"]>
	role_in?: InputMaybe<Array<Scalars["String"]>>
	role_lt?: InputMaybe<Scalars["String"]>
	role_lte?: InputMaybe<Scalars["String"]>
	role_not?: InputMaybe<Scalars["String"]>
	role_not_contains?: InputMaybe<Scalars["String"]>
	role_not_contains_nocase?: InputMaybe<Scalars["String"]>
	role_not_ends_with?: InputMaybe<Scalars["String"]>
	role_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	role_not_in?: InputMaybe<Array<Scalars["String"]>>
	role_not_starts_with?: InputMaybe<Scalars["String"]>
	role_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	role_starts_with?: InputMaybe<Scalars["String"]>
	role_starts_with_nocase?: InputMaybe<Scalars["String"]>
	sender?: InputMaybe<Scalars["String"]>
	sender_contains?: InputMaybe<Scalars["String"]>
	sender_contains_nocase?: InputMaybe<Scalars["String"]>
	sender_ends_with?: InputMaybe<Scalars["String"]>
	sender_ends_with_nocase?: InputMaybe<Scalars["String"]>
	sender_gt?: InputMaybe<Scalars["String"]>
	sender_gte?: InputMaybe<Scalars["String"]>
	sender_in?: InputMaybe<Array<Scalars["String"]>>
	sender_lt?: InputMaybe<Scalars["String"]>
	sender_lte?: InputMaybe<Scalars["String"]>
	sender_not?: InputMaybe<Scalars["String"]>
	sender_not_contains?: InputMaybe<Scalars["String"]>
	sender_not_contains_nocase?: InputMaybe<Scalars["String"]>
	sender_not_ends_with?: InputMaybe<Scalars["String"]>
	sender_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	sender_not_in?: InputMaybe<Array<Scalars["String"]>>
	sender_not_starts_with?: InputMaybe<Scalars["String"]>
	sender_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	sender_starts_with?: InputMaybe<Scalars["String"]>
	sender_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum RoleRevoked_OrderBy {
	Account = "account",
	Emitter = "emitter",
	Id = "id",
	Role = "role",
	Sender = "sender",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type Role_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Role_OrderBy {
	Id = "id",
	RoleOf = "roleOf",
}

export type Skill = {
	__typename?: "Skill"
	id: Scalars["ID"]
	level: Scalars["BigInt"]
	skillCategory: Scalars["ID"]
}

export type SkillCategory = {
	__typename?: "SkillCategory"
	id: Scalars["ID"]
	name: Scalars["String"]
}

export type SkillCategory_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	name?: InputMaybe<Scalars["String"]>
	name_contains?: InputMaybe<Scalars["String"]>
	name_contains_nocase?: InputMaybe<Scalars["String"]>
	name_ends_with?: InputMaybe<Scalars["String"]>
	name_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_gt?: InputMaybe<Scalars["String"]>
	name_gte?: InputMaybe<Scalars["String"]>
	name_in?: InputMaybe<Array<Scalars["String"]>>
	name_lt?: InputMaybe<Scalars["String"]>
	name_lte?: InputMaybe<Scalars["String"]>
	name_not?: InputMaybe<Scalars["String"]>
	name_not_contains?: InputMaybe<Scalars["String"]>
	name_not_contains_nocase?: InputMaybe<Scalars["String"]>
	name_not_ends_with?: InputMaybe<Scalars["String"]>
	name_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_not_in?: InputMaybe<Array<Scalars["String"]>>
	name_not_starts_with?: InputMaybe<Scalars["String"]>
	name_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	name_starts_with?: InputMaybe<Scalars["String"]>
	name_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum SkillCategory_OrderBy {
	Id = "id",
	Name = "name",
}

export enum SkillId {
	Agility = "Agility",
	Degen = "Degen",
	Fitness = "Fitness",
	Honesty = "Honesty",
	Patience = "Patience",
	Strategy = "Strategy",
}

export type Skill_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	level?: InputMaybe<Scalars["BigInt"]>
	level_gt?: InputMaybe<Scalars["BigInt"]>
	level_gte?: InputMaybe<Scalars["BigInt"]>
	level_in?: InputMaybe<Array<Scalars["BigInt"]>>
	level_lt?: InputMaybe<Scalars["BigInt"]>
	level_lte?: InputMaybe<Scalars["BigInt"]>
	level_not?: InputMaybe<Scalars["BigInt"]>
	level_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	skillCategory?: InputMaybe<Scalars["ID"]>
	skillCategory_gt?: InputMaybe<Scalars["ID"]>
	skillCategory_gte?: InputMaybe<Scalars["ID"]>
	skillCategory_in?: InputMaybe<Array<Scalars["ID"]>>
	skillCategory_lt?: InputMaybe<Scalars["ID"]>
	skillCategory_lte?: InputMaybe<Scalars["ID"]>
	skillCategory_not?: InputMaybe<Scalars["ID"]>
	skillCategory_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Skill_OrderBy {
	Id = "id",
	Level = "level",
	SkillCategory = "skillCategory",
}

export type StakeFarmer = {
	__typename?: "StakeFarmer"
	depositor: Scalars["Bytes"]
	farmerId: Scalars["BigInt"]
	id: Scalars["ID"]
	lockingDurationDays: Scalars["BigInt"]
}

export type StakeFarmer_Filter = {
	depositor?: InputMaybe<Scalars["Bytes"]>
	depositor_contains?: InputMaybe<Scalars["Bytes"]>
	depositor_in?: InputMaybe<Array<Scalars["Bytes"]>>
	depositor_not?: InputMaybe<Scalars["Bytes"]>
	depositor_not_contains?: InputMaybe<Scalars["Bytes"]>
	depositor_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	farmerId?: InputMaybe<Scalars["BigInt"]>
	farmerId_gt?: InputMaybe<Scalars["BigInt"]>
	farmerId_gte?: InputMaybe<Scalars["BigInt"]>
	farmerId_in?: InputMaybe<Array<Scalars["BigInt"]>>
	farmerId_lt?: InputMaybe<Scalars["BigInt"]>
	farmerId_lte?: InputMaybe<Scalars["BigInt"]>
	farmerId_not?: InputMaybe<Scalars["BigInt"]>
	farmerId_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	lockingDurationDays?: InputMaybe<Scalars["BigInt"]>
	lockingDurationDays_gt?: InputMaybe<Scalars["BigInt"]>
	lockingDurationDays_gte?: InputMaybe<Scalars["BigInt"]>
	lockingDurationDays_in?: InputMaybe<Array<Scalars["BigInt"]>>
	lockingDurationDays_lt?: InputMaybe<Scalars["BigInt"]>
	lockingDurationDays_lte?: InputMaybe<Scalars["BigInt"]>
	lockingDurationDays_not?: InputMaybe<Scalars["BigInt"]>
	lockingDurationDays_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum StakeFarmer_OrderBy {
	Depositor = "depositor",
	FarmerId = "farmerId",
	Id = "id",
	LockingDurationDays = "lockingDurationDays",
}

export enum StakingState {
	Locked = "Locked",
	Staked = "Staked",
	UnStaked = "UnStaked",
}

export type Subscription = {
	__typename?: "Subscription"
	/** Access to subgraph metadata */
	_meta?: Maybe<_Meta_>
	accessControl?: Maybe<AccessControl>
	accessControlRole?: Maybe<AccessControlRole>
	accessControlRoleMember?: Maybe<AccessControlRoleMember>
	accessControlRoleMembers: Array<AccessControlRoleMember>
	accessControlRoles: Array<AccessControlRole>
	accessControls: Array<AccessControl>
	account?: Maybe<Account>
	accounts: Array<Account>
	addDelegate?: Maybe<AddDelegate>
	addDelegates: Array<AddDelegate>
	approval?: Maybe<Approval>
	approvals: Array<Approval>
	claimBlocks: Array<ClaimBlocks>
	delegateChanged?: Maybe<DelegateChanged>
	delegateChangeds: Array<DelegateChanged>
	delegateVotesChanged?: Maybe<DelegateVotesChanged>
	delegateVotesChangeds: Array<DelegateVotesChanged>
	erc20Approval?: Maybe<Erc20Approval>
	erc20Approvals: Array<Erc20Approval>
	erc20Balance?: Maybe<Erc20Balance>
	erc20Balances: Array<Erc20Balance>
	erc20Contract?: Maybe<Erc20Contract>
	erc20Contracts: Array<Erc20Contract>
	erc20Transfer?: Maybe<Erc20Transfer>
	erc20Transfers: Array<Erc20Transfer>
	erc721Contract?: Maybe<Erc721Contract>
	erc721Contracts: Array<Erc721Contract>
	erc721Operator?: Maybe<Erc721Operator>
	erc721Operators: Array<Erc721Operator>
	erc721Token?: Maybe<Erc721Token>
	erc721Tokens: Array<Erc721Token>
	erc721Transfer?: Maybe<Erc721Transfer>
	erc721Transfers: Array<Erc721Transfer>
	erc1155Balance?: Maybe<Erc1155Balance>
	erc1155Balances: Array<Erc1155Balance>
	erc1155Contract?: Maybe<Erc1155Contract>
	erc1155Contracts: Array<Erc1155Contract>
	erc1155Operator?: Maybe<Erc1155Operator>
	erc1155Operators: Array<Erc1155Operator>
	erc1155Token?: Maybe<Erc1155Token>
	erc1155Tokens: Array<Erc1155Token>
	erc1155Transfer?: Maybe<Erc1155Transfer>
	erc1155Transfers: Array<Erc1155Transfer>
	erc1967AdminChanged?: Maybe<Erc1967AdminChanged>
	erc1967AdminChangeds: Array<Erc1967AdminChanged>
	erc1967BeaconUpgraded?: Maybe<Erc1967BeaconUpgraded>
	erc1967BeaconUpgradeds: Array<Erc1967BeaconUpgraded>
	erc1967ImplementationUpgraded?: Maybe<Erc1967ImplementationUpgraded>
	erc1967ImplementationUpgradeds: Array<Erc1967ImplementationUpgraded>
	event?: Maybe<Event>
	events: Array<Event>
	farmer?: Maybe<Farmer>
	farmers: Array<Farmer>
	governor?: Maybe<Governor>
	governors: Array<Governor>
	mintAsDelegate?: Maybe<MintAsDelegate>
	mintAsDelegates: Array<MintAsDelegate>
	mintReward?: Maybe<MintReward>
	mintRewards: Array<MintReward>
	ownable?: Maybe<Ownable>
	ownables: Array<Ownable>
	ownershipTransferred?: Maybe<OwnershipTransferred>
	ownershipTransferreds: Array<OwnershipTransferred>
	pausable?: Maybe<Pausable>
	pausables: Array<Pausable>
	paused?: Maybe<Paused>
	pauseds: Array<Paused>
	proposal?: Maybe<Proposal>
	proposalCall?: Maybe<ProposalCall>
	proposalCalls: Array<ProposalCall>
	proposalCanceled?: Maybe<ProposalCanceled>
	proposalCanceleds: Array<ProposalCanceled>
	proposalCreated?: Maybe<ProposalCreated>
	proposalCreateds: Array<ProposalCreated>
	proposalExecuted?: Maybe<ProposalExecuted>
	proposalExecuteds: Array<ProposalExecuted>
	proposalQueued?: Maybe<ProposalQueued>
	proposalQueueds: Array<ProposalQueued>
	proposalSupport?: Maybe<ProposalSupport>
	proposalSupports: Array<ProposalSupport>
	proposals: Array<Proposal>
	removeDelegate?: Maybe<RemoveDelegate>
	removeDelegates: Array<RemoveDelegate>
	role?: Maybe<Role>
	roleAdminChanged?: Maybe<RoleAdminChanged>
	roleAdminChangeds: Array<RoleAdminChanged>
	roleGranted?: Maybe<RoleGranted>
	roleGranteds: Array<RoleGranted>
	roleRevoked?: Maybe<RoleRevoked>
	roleRevokeds: Array<RoleRevoked>
	roles: Array<Role>
	skill?: Maybe<Skill>
	skillCategories: Array<SkillCategory>
	skillCategory?: Maybe<SkillCategory>
	skills: Array<Skill>
	stakeFarmer?: Maybe<StakeFarmer>
	stakeFarmers: Array<StakeFarmer>
	timelock?: Maybe<Timelock>
	timelockCall?: Maybe<TimelockCall>
	timelockCalls: Array<TimelockCall>
	timelockMinDelayChange?: Maybe<TimelockMinDelayChange>
	timelockMinDelayChanges: Array<TimelockMinDelayChange>
	timelockOperation?: Maybe<TimelockOperation>
	timelockOperationCancelled?: Maybe<TimelockOperationCancelled>
	timelockOperationCancelleds: Array<TimelockOperationCancelled>
	timelockOperationExecuted?: Maybe<TimelockOperationExecuted>
	timelockOperationExecuteds: Array<TimelockOperationExecuted>
	timelockOperationScheduled?: Maybe<TimelockOperationScheduled>
	timelockOperationScheduleds: Array<TimelockOperationScheduled>
	timelockOperations: Array<TimelockOperation>
	timelocks: Array<Timelock>
	trait?: Maybe<Trait>
	traitCategories: Array<TraitCategory>
	traitCategory?: Maybe<TraitCategory>
	traits: Array<Trait>
	transaction?: Maybe<Transaction>
	transactions: Array<Transaction>
	transfer?: Maybe<Transfer>
	transfers: Array<Transfer>
	unpaused?: Maybe<Unpaused>
	unpauseds: Array<Unpaused>
	voteCast?: Maybe<VoteCast>
	voteCasts: Array<VoteCast>
	voteDelegation?: Maybe<VoteDelegation>
	voteDelegations: Array<VoteDelegation>
	voteReceipt?: Maybe<VoteReceipt>
	voteReceipts: Array<VoteReceipt>
	voteWeight?: Maybe<VoteWeight>
	voteWeights: Array<VoteWeight>
	votingContract?: Maybe<VotingContract>
	votingContracts: Array<VotingContract>
	withdrawFarmer?: Maybe<WithdrawFarmer>
	withdrawFarmers: Array<WithdrawFarmer>
}

export type Subscription_MetaArgs = {
	block?: InputMaybe<Block_Height>
}

export type SubscriptionAccessControlArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionAccessControlRoleArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionAccessControlRoleMemberArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionAccessControlRoleMembersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRoleMember_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AccessControlRoleMember_Filter>
}

export type SubscriptionAccessControlRolesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControlRole_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AccessControlRole_Filter>
}

export type SubscriptionAccessControlsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AccessControl_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AccessControl_Filter>
}

export type SubscriptionAccountArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionAccountsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Account_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Account_Filter>
}

export type SubscriptionAddDelegateArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionAddDelegatesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<AddDelegate_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<AddDelegate_Filter>
}

export type SubscriptionApprovalArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionApprovalsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Approval_Filter>
}

export type SubscriptionClaimBlocksArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ClaimBlocks_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ClaimBlocks_Filter>
}

export type SubscriptionDelegateChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionDelegateChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<DelegateChanged_Filter>
}

export type SubscriptionDelegateVotesChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionDelegateVotesChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateVotesChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<DelegateVotesChanged_Filter>
}

export type SubscriptionErc20ApprovalArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc20ApprovalsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Approval_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Approval_Filter>
}

export type SubscriptionErc20BalanceArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc20BalancesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Balance_Filter>
}

export type SubscriptionErc20ContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc20ContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Contract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Contract_Filter>
}

export type SubscriptionErc20TransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc20TransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc20Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc20Transfer_Filter>
}

export type SubscriptionErc721ContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc721ContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Contract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Contract_Filter>
}

export type SubscriptionErc721OperatorArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc721OperatorsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Operator_Filter>
}

export type SubscriptionErc721TokenArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc721TokensArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Token_Filter>
}

export type SubscriptionErc721TransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc721TransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc721Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc721Transfer_Filter>
}

export type SubscriptionErc1155BalanceArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1155BalancesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Balance_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Balance_Filter>
}

export type SubscriptionErc1155ContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1155ContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Contract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Contract_Filter>
}

export type SubscriptionErc1155OperatorArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1155OperatorsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Operator_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Operator_Filter>
}

export type SubscriptionErc1155TokenArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1155TokensArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Token_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Token_Filter>
}

export type SubscriptionErc1155TransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1155TransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1155Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1155Transfer_Filter>
}

export type SubscriptionErc1967AdminChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1967AdminChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967AdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1967AdminChanged_Filter>
}

export type SubscriptionErc1967BeaconUpgradedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1967BeaconUpgradedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967BeaconUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1967BeaconUpgraded_Filter>
}

export type SubscriptionErc1967ImplementationUpgradedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionErc1967ImplementationUpgradedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Erc1967ImplementationUpgraded_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Erc1967ImplementationUpgraded_Filter>
}

export type SubscriptionEventArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionEventsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Event_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Event_Filter>
}

export type SubscriptionFarmerArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionFarmersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Farmer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Farmer_Filter>
}

export type SubscriptionGovernorArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionGovernorsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Governor_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Governor_Filter>
}

export type SubscriptionMintAsDelegateArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionMintAsDelegatesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<MintAsDelegate_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<MintAsDelegate_Filter>
}

export type SubscriptionMintRewardArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionMintRewardsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<MintReward_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<MintReward_Filter>
}

export type SubscriptionOwnableArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionOwnablesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Ownable_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Ownable_Filter>
}

export type SubscriptionOwnershipTransferredArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionOwnershipTransferredsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<OwnershipTransferred_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<OwnershipTransferred_Filter>
}

export type SubscriptionPausableArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionPausablesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Pausable_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Pausable_Filter>
}

export type SubscriptionPausedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionPausedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Paused_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Paused_Filter>
}

export type SubscriptionProposalArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalCallArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalCallsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalCall_Filter>
}

export type SubscriptionProposalCanceledArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalCanceledsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCanceled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalCanceled_Filter>
}

export type SubscriptionProposalCreatedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalCreatedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalCreated_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalCreated_Filter>
}

export type SubscriptionProposalExecutedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalExecutedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalExecuted_Filter>
}

export type SubscriptionProposalQueuedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalQueuedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalQueued_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalQueued_Filter>
}

export type SubscriptionProposalSupportArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProposalSupportsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<ProposalSupport_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<ProposalSupport_Filter>
}

export type SubscriptionProposalsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Proposal_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Proposal_Filter>
}

export type SubscriptionRemoveDelegateArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionRemoveDelegatesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RemoveDelegate_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RemoveDelegate_Filter>
}

export type SubscriptionRoleArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionRoleAdminChangedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionRoleAdminChangedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleAdminChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RoleAdminChanged_Filter>
}

export type SubscriptionRoleGrantedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionRoleGrantedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleGranted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RoleGranted_Filter>
}

export type SubscriptionRoleRevokedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionRoleRevokedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<RoleRevoked_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<RoleRevoked_Filter>
}

export type SubscriptionRolesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Role_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Role_Filter>
}

export type SubscriptionSkillArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionSkillCategoriesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<SkillCategory_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<SkillCategory_Filter>
}

export type SubscriptionSkillCategoryArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionSkillsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Skill_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Skill_Filter>
}

export type SubscriptionStakeFarmerArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionStakeFarmersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<StakeFarmer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<StakeFarmer_Filter>
}

export type SubscriptionTimelockArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockCallArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockCallsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockCall_Filter>
}

export type SubscriptionTimelockMinDelayChangeArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockMinDelayChangesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockMinDelayChange_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockMinDelayChange_Filter>
}

export type SubscriptionTimelockOperationArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockOperationCancelledArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockOperationCancelledsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationCancelled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperationCancelled_Filter>
}

export type SubscriptionTimelockOperationExecutedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockOperationExecutedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperationExecuted_Filter>
}

export type SubscriptionTimelockOperationScheduledArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTimelockOperationScheduledsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationScheduled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperationScheduled_Filter>
}

export type SubscriptionTimelockOperationsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TimelockOperation_Filter>
}

export type SubscriptionTimelocksArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Timelock_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Timelock_Filter>
}

export type SubscriptionTraitArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTraitCategoriesArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TraitCategory_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<TraitCategory_Filter>
}

export type SubscriptionTraitCategoryArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTraitsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Trait_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Trait_Filter>
}

export type SubscriptionTransactionArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTransactionsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Transaction_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Transaction_Filter>
}

export type SubscriptionTransferArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTransfersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Transfer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Transfer_Filter>
}

export type SubscriptionUnpausedArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionUnpausedsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Unpaused_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<Unpaused_Filter>
}

export type SubscriptionVoteCastArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionVoteCastsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteCast_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteCast_Filter>
}

export type SubscriptionVoteDelegationArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionVoteDelegationsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteDelegation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteDelegation_Filter>
}

export type SubscriptionVoteReceiptArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionVoteReceiptsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteReceipt_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteReceipt_Filter>
}

export type SubscriptionVoteWeightArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionVoteWeightsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteWeight_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VoteWeight_Filter>
}

export type SubscriptionVotingContractArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionVotingContractsArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VotingContract_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<VotingContract_Filter>
}

export type SubscriptionWithdrawFarmerArgs = {
	block?: InputMaybe<Block_Height>
	id: Scalars["ID"]
	subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionWithdrawFarmersArgs = {
	block?: InputMaybe<Block_Height>
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<WithdrawFarmer_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	subgraphError?: _SubgraphErrorPolicy_
	where?: InputMaybe<WithdrawFarmer_Filter>
}

export type Timelock = {
	__typename?: "Timelock"
	asAccount: Account
	cancelled: Array<TimelockOperationCancelled>
	executed: Array<TimelockOperationExecuted>
	id: Scalars["ID"]
	mindelaychange: Array<TimelockMinDelayChange>
	operations: Array<TimelockOperation>
	scheduled: Array<TimelockOperationScheduled>
}

export type TimelockCancelledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationCancelled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationCancelled_Filter>
}

export type TimelockExecutedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationExecuted_Filter>
}

export type TimelockMindelaychangeArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockMinDelayChange_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockMinDelayChange_Filter>
}

export type TimelockOperationsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperation_Filter>
}

export type TimelockScheduledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationScheduled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationScheduled_Filter>
}

export type TimelockCall = {
	__typename?: "TimelockCall"
	data: Scalars["Bytes"]
	executed: Array<TimelockOperationExecuted>
	id: Scalars["ID"]
	index: Scalars["BigInt"]
	operation: TimelockOperation
	scheduled: Array<TimelockOperationScheduled>
	target: Account
	value: Scalars["BigDecimal"]
}

export type TimelockCallExecutedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationExecuted_Filter>
}

export type TimelockCallScheduledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationScheduled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationScheduled_Filter>
}

export type TimelockCall_Filter = {
	data?: InputMaybe<Scalars["Bytes"]>
	data_contains?: InputMaybe<Scalars["Bytes"]>
	data_in?: InputMaybe<Array<Scalars["Bytes"]>>
	data_not?: InputMaybe<Scalars["Bytes"]>
	data_not_contains?: InputMaybe<Scalars["Bytes"]>
	data_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	index?: InputMaybe<Scalars["BigInt"]>
	index_gt?: InputMaybe<Scalars["BigInt"]>
	index_gte?: InputMaybe<Scalars["BigInt"]>
	index_in?: InputMaybe<Array<Scalars["BigInt"]>>
	index_lt?: InputMaybe<Scalars["BigInt"]>
	index_lte?: InputMaybe<Scalars["BigInt"]>
	index_not?: InputMaybe<Scalars["BigInt"]>
	index_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	operation?: InputMaybe<Scalars["String"]>
	operation_contains?: InputMaybe<Scalars["String"]>
	operation_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_ends_with?: InputMaybe<Scalars["String"]>
	operation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_gt?: InputMaybe<Scalars["String"]>
	operation_gte?: InputMaybe<Scalars["String"]>
	operation_in?: InputMaybe<Array<Scalars["String"]>>
	operation_lt?: InputMaybe<Scalars["String"]>
	operation_lte?: InputMaybe<Scalars["String"]>
	operation_not?: InputMaybe<Scalars["String"]>
	operation_not_contains?: InputMaybe<Scalars["String"]>
	operation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_not_ends_with?: InputMaybe<Scalars["String"]>
	operation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_not_in?: InputMaybe<Array<Scalars["String"]>>
	operation_not_starts_with?: InputMaybe<Scalars["String"]>
	operation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operation_starts_with?: InputMaybe<Scalars["String"]>
	operation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	target?: InputMaybe<Scalars["String"]>
	target_contains?: InputMaybe<Scalars["String"]>
	target_contains_nocase?: InputMaybe<Scalars["String"]>
	target_ends_with?: InputMaybe<Scalars["String"]>
	target_ends_with_nocase?: InputMaybe<Scalars["String"]>
	target_gt?: InputMaybe<Scalars["String"]>
	target_gte?: InputMaybe<Scalars["String"]>
	target_in?: InputMaybe<Array<Scalars["String"]>>
	target_lt?: InputMaybe<Scalars["String"]>
	target_lte?: InputMaybe<Scalars["String"]>
	target_not?: InputMaybe<Scalars["String"]>
	target_not_contains?: InputMaybe<Scalars["String"]>
	target_not_contains_nocase?: InputMaybe<Scalars["String"]>
	target_not_ends_with?: InputMaybe<Scalars["String"]>
	target_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	target_not_in?: InputMaybe<Array<Scalars["String"]>>
	target_not_starts_with?: InputMaybe<Scalars["String"]>
	target_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	target_starts_with?: InputMaybe<Scalars["String"]>
	target_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value?: InputMaybe<Scalars["BigDecimal"]>
	value_gt?: InputMaybe<Scalars["BigDecimal"]>
	value_gte?: InputMaybe<Scalars["BigDecimal"]>
	value_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
	value_lt?: InputMaybe<Scalars["BigDecimal"]>
	value_lte?: InputMaybe<Scalars["BigDecimal"]>
	value_not?: InputMaybe<Scalars["BigDecimal"]>
	value_not_in?: InputMaybe<Array<Scalars["BigDecimal"]>>
}

export enum TimelockCall_OrderBy {
	Data = "data",
	Executed = "executed",
	Id = "id",
	Index = "index",
	Operation = "operation",
	Scheduled = "scheduled",
	Target = "target",
	Value = "value",
}

export type TimelockMinDelayChange = Event & {
	__typename?: "TimelockMinDelayChange"
	contract: Timelock
	delay: Scalars["BigInt"]
	emitter: Account
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type TimelockMinDelayChange_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delay?: InputMaybe<Scalars["BigInt"]>
	delay_gt?: InputMaybe<Scalars["BigInt"]>
	delay_gte?: InputMaybe<Scalars["BigInt"]>
	delay_in?: InputMaybe<Array<Scalars["BigInt"]>>
	delay_lt?: InputMaybe<Scalars["BigInt"]>
	delay_lte?: InputMaybe<Scalars["BigInt"]>
	delay_not?: InputMaybe<Scalars["BigInt"]>
	delay_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum TimelockMinDelayChange_OrderBy {
	Contract = "contract",
	Delay = "delay",
	Emitter = "emitter",
	Id = "id",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type TimelockOperation = {
	__typename?: "TimelockOperation"
	calls: Array<TimelockCall>
	cancelled: Array<TimelockOperationCancelled>
	contract: Timelock
	delay: Scalars["BigInt"]
	executed: Array<TimelockOperationExecuted>
	id: Scalars["ID"]
	predecessor?: Maybe<TimelockOperation>
	scheduled: Array<TimelockOperationScheduled>
	status: TimelockStatus
	timestamp: Scalars["BigInt"]
}

export type TimelockOperationCallsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockCall_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockCall_Filter>
}

export type TimelockOperationCancelledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationCancelled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationCancelled_Filter>
}

export type TimelockOperationExecutedArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationExecuted_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationExecuted_Filter>
}

export type TimelockOperationScheduledArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<TimelockOperationScheduled_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<TimelockOperationScheduled_Filter>
}

export type TimelockOperationCancelled = Event & {
	__typename?: "TimelockOperationCancelled"
	contract: Timelock
	emitter: Account
	id: Scalars["ID"]
	operation: TimelockOperation
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type TimelockOperationCancelled_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	operation?: InputMaybe<Scalars["String"]>
	operation_contains?: InputMaybe<Scalars["String"]>
	operation_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_ends_with?: InputMaybe<Scalars["String"]>
	operation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_gt?: InputMaybe<Scalars["String"]>
	operation_gte?: InputMaybe<Scalars["String"]>
	operation_in?: InputMaybe<Array<Scalars["String"]>>
	operation_lt?: InputMaybe<Scalars["String"]>
	operation_lte?: InputMaybe<Scalars["String"]>
	operation_not?: InputMaybe<Scalars["String"]>
	operation_not_contains?: InputMaybe<Scalars["String"]>
	operation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_not_ends_with?: InputMaybe<Scalars["String"]>
	operation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_not_in?: InputMaybe<Array<Scalars["String"]>>
	operation_not_starts_with?: InputMaybe<Scalars["String"]>
	operation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operation_starts_with?: InputMaybe<Scalars["String"]>
	operation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum TimelockOperationCancelled_OrderBy {
	Contract = "contract",
	Emitter = "emitter",
	Id = "id",
	Operation = "operation",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type TimelockOperationExecuted = Event & {
	__typename?: "TimelockOperationExecuted"
	call: TimelockCall
	contract: Timelock
	emitter: Account
	id: Scalars["ID"]
	operation: TimelockOperation
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type TimelockOperationExecuted_Filter = {
	call?: InputMaybe<Scalars["String"]>
	call_contains?: InputMaybe<Scalars["String"]>
	call_contains_nocase?: InputMaybe<Scalars["String"]>
	call_ends_with?: InputMaybe<Scalars["String"]>
	call_ends_with_nocase?: InputMaybe<Scalars["String"]>
	call_gt?: InputMaybe<Scalars["String"]>
	call_gte?: InputMaybe<Scalars["String"]>
	call_in?: InputMaybe<Array<Scalars["String"]>>
	call_lt?: InputMaybe<Scalars["String"]>
	call_lte?: InputMaybe<Scalars["String"]>
	call_not?: InputMaybe<Scalars["String"]>
	call_not_contains?: InputMaybe<Scalars["String"]>
	call_not_contains_nocase?: InputMaybe<Scalars["String"]>
	call_not_ends_with?: InputMaybe<Scalars["String"]>
	call_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	call_not_in?: InputMaybe<Array<Scalars["String"]>>
	call_not_starts_with?: InputMaybe<Scalars["String"]>
	call_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	call_starts_with?: InputMaybe<Scalars["String"]>
	call_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	operation?: InputMaybe<Scalars["String"]>
	operation_contains?: InputMaybe<Scalars["String"]>
	operation_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_ends_with?: InputMaybe<Scalars["String"]>
	operation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_gt?: InputMaybe<Scalars["String"]>
	operation_gte?: InputMaybe<Scalars["String"]>
	operation_in?: InputMaybe<Array<Scalars["String"]>>
	operation_lt?: InputMaybe<Scalars["String"]>
	operation_lte?: InputMaybe<Scalars["String"]>
	operation_not?: InputMaybe<Scalars["String"]>
	operation_not_contains?: InputMaybe<Scalars["String"]>
	operation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_not_ends_with?: InputMaybe<Scalars["String"]>
	operation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_not_in?: InputMaybe<Array<Scalars["String"]>>
	operation_not_starts_with?: InputMaybe<Scalars["String"]>
	operation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operation_starts_with?: InputMaybe<Scalars["String"]>
	operation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum TimelockOperationExecuted_OrderBy {
	Call = "call",
	Contract = "contract",
	Emitter = "emitter",
	Id = "id",
	Operation = "operation",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type TimelockOperationScheduled = Event & {
	__typename?: "TimelockOperationScheduled"
	call: TimelockCall
	contract: Timelock
	emitter: Account
	id: Scalars["ID"]
	operation: TimelockOperation
	timestamp: Scalars["BigInt"]
	transaction: Transaction
}

export type TimelockOperationScheduled_Filter = {
	call?: InputMaybe<Scalars["String"]>
	call_contains?: InputMaybe<Scalars["String"]>
	call_contains_nocase?: InputMaybe<Scalars["String"]>
	call_ends_with?: InputMaybe<Scalars["String"]>
	call_ends_with_nocase?: InputMaybe<Scalars["String"]>
	call_gt?: InputMaybe<Scalars["String"]>
	call_gte?: InputMaybe<Scalars["String"]>
	call_in?: InputMaybe<Array<Scalars["String"]>>
	call_lt?: InputMaybe<Scalars["String"]>
	call_lte?: InputMaybe<Scalars["String"]>
	call_not?: InputMaybe<Scalars["String"]>
	call_not_contains?: InputMaybe<Scalars["String"]>
	call_not_contains_nocase?: InputMaybe<Scalars["String"]>
	call_not_ends_with?: InputMaybe<Scalars["String"]>
	call_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	call_not_in?: InputMaybe<Array<Scalars["String"]>>
	call_not_starts_with?: InputMaybe<Scalars["String"]>
	call_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	call_starts_with?: InputMaybe<Scalars["String"]>
	call_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	operation?: InputMaybe<Scalars["String"]>
	operation_contains?: InputMaybe<Scalars["String"]>
	operation_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_ends_with?: InputMaybe<Scalars["String"]>
	operation_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_gt?: InputMaybe<Scalars["String"]>
	operation_gte?: InputMaybe<Scalars["String"]>
	operation_in?: InputMaybe<Array<Scalars["String"]>>
	operation_lt?: InputMaybe<Scalars["String"]>
	operation_lte?: InputMaybe<Scalars["String"]>
	operation_not?: InputMaybe<Scalars["String"]>
	operation_not_contains?: InputMaybe<Scalars["String"]>
	operation_not_contains_nocase?: InputMaybe<Scalars["String"]>
	operation_not_ends_with?: InputMaybe<Scalars["String"]>
	operation_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	operation_not_in?: InputMaybe<Array<Scalars["String"]>>
	operation_not_starts_with?: InputMaybe<Scalars["String"]>
	operation_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	operation_starts_with?: InputMaybe<Scalars["String"]>
	operation_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum TimelockOperationScheduled_OrderBy {
	Call = "call",
	Contract = "contract",
	Emitter = "emitter",
	Id = "id",
	Operation = "operation",
	Timestamp = "timestamp",
	Transaction = "transaction",
}

export type TimelockOperation_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delay?: InputMaybe<Scalars["BigInt"]>
	delay_gt?: InputMaybe<Scalars["BigInt"]>
	delay_gte?: InputMaybe<Scalars["BigInt"]>
	delay_in?: InputMaybe<Array<Scalars["BigInt"]>>
	delay_lt?: InputMaybe<Scalars["BigInt"]>
	delay_lte?: InputMaybe<Scalars["BigInt"]>
	delay_not?: InputMaybe<Scalars["BigInt"]>
	delay_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	predecessor?: InputMaybe<Scalars["String"]>
	predecessor_contains?: InputMaybe<Scalars["String"]>
	predecessor_contains_nocase?: InputMaybe<Scalars["String"]>
	predecessor_ends_with?: InputMaybe<Scalars["String"]>
	predecessor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	predecessor_gt?: InputMaybe<Scalars["String"]>
	predecessor_gte?: InputMaybe<Scalars["String"]>
	predecessor_in?: InputMaybe<Array<Scalars["String"]>>
	predecessor_lt?: InputMaybe<Scalars["String"]>
	predecessor_lte?: InputMaybe<Scalars["String"]>
	predecessor_not?: InputMaybe<Scalars["String"]>
	predecessor_not_contains?: InputMaybe<Scalars["String"]>
	predecessor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	predecessor_not_ends_with?: InputMaybe<Scalars["String"]>
	predecessor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	predecessor_not_in?: InputMaybe<Array<Scalars["String"]>>
	predecessor_not_starts_with?: InputMaybe<Scalars["String"]>
	predecessor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	predecessor_starts_with?: InputMaybe<Scalars["String"]>
	predecessor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	status?: InputMaybe<TimelockStatus>
	status_in?: InputMaybe<Array<TimelockStatus>>
	status_not?: InputMaybe<TimelockStatus>
	status_not_in?: InputMaybe<Array<TimelockStatus>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum TimelockOperation_OrderBy {
	Calls = "calls",
	Cancelled = "cancelled",
	Contract = "contract",
	Delay = "delay",
	Executed = "executed",
	Id = "id",
	Predecessor = "predecessor",
	Scheduled = "scheduled",
	Status = "status",
	Timestamp = "timestamp",
}

export enum TimelockStatus {
	Canceled = "CANCELED",
	Executed = "EXECUTED",
	Scheduled = "SCHEDULED",
}

export type Timelock_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Timelock_OrderBy {
	AsAccount = "asAccount",
	Cancelled = "cancelled",
	Executed = "executed",
	Id = "id",
	Mindelaychange = "mindelaychange",
	Operations = "operations",
	Scheduled = "scheduled",
}

export type Trait = {
	__typename?: "Trait"
	id: Scalars["ID"]
	traitCategory: Scalars["ID"]
	value: Scalars["String"]
}

export type TraitCategory = {
	__typename?: "TraitCategory"
	id: Scalars["ID"]
	name: Scalars["String"]
}

export type TraitCategory_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	name?: InputMaybe<Scalars["String"]>
	name_contains?: InputMaybe<Scalars["String"]>
	name_contains_nocase?: InputMaybe<Scalars["String"]>
	name_ends_with?: InputMaybe<Scalars["String"]>
	name_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_gt?: InputMaybe<Scalars["String"]>
	name_gte?: InputMaybe<Scalars["String"]>
	name_in?: InputMaybe<Array<Scalars["String"]>>
	name_lt?: InputMaybe<Scalars["String"]>
	name_lte?: InputMaybe<Scalars["String"]>
	name_not?: InputMaybe<Scalars["String"]>
	name_not_contains?: InputMaybe<Scalars["String"]>
	name_not_contains_nocase?: InputMaybe<Scalars["String"]>
	name_not_ends_with?: InputMaybe<Scalars["String"]>
	name_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	name_not_in?: InputMaybe<Array<Scalars["String"]>>
	name_not_starts_with?: InputMaybe<Scalars["String"]>
	name_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	name_starts_with?: InputMaybe<Scalars["String"]>
	name_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum TraitCategory_OrderBy {
	Id = "id",
	Name = "name",
}

export type Trait_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	traitCategory?: InputMaybe<Scalars["ID"]>
	traitCategory_gt?: InputMaybe<Scalars["ID"]>
	traitCategory_gte?: InputMaybe<Scalars["ID"]>
	traitCategory_in?: InputMaybe<Array<Scalars["ID"]>>
	traitCategory_lt?: InputMaybe<Scalars["ID"]>
	traitCategory_lte?: InputMaybe<Scalars["ID"]>
	traitCategory_not?: InputMaybe<Scalars["ID"]>
	traitCategory_not_in?: InputMaybe<Array<Scalars["ID"]>>
	value?: InputMaybe<Scalars["String"]>
	value_contains?: InputMaybe<Scalars["String"]>
	value_contains_nocase?: InputMaybe<Scalars["String"]>
	value_ends_with?: InputMaybe<Scalars["String"]>
	value_ends_with_nocase?: InputMaybe<Scalars["String"]>
	value_gt?: InputMaybe<Scalars["String"]>
	value_gte?: InputMaybe<Scalars["String"]>
	value_in?: InputMaybe<Array<Scalars["String"]>>
	value_lt?: InputMaybe<Scalars["String"]>
	value_lte?: InputMaybe<Scalars["String"]>
	value_not?: InputMaybe<Scalars["String"]>
	value_not_contains?: InputMaybe<Scalars["String"]>
	value_not_contains_nocase?: InputMaybe<Scalars["String"]>
	value_not_ends_with?: InputMaybe<Scalars["String"]>
	value_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	value_not_in?: InputMaybe<Array<Scalars["String"]>>
	value_not_starts_with?: InputMaybe<Scalars["String"]>
	value_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	value_starts_with?: InputMaybe<Scalars["String"]>
	value_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum Trait_OrderBy {
	Id = "id",
	TraitCategory = "traitCategory",
	Value = "value",
}

export type Transaction = {
	__typename?: "Transaction"
	blockNumber: Scalars["BigInt"]
	events: Array<Event>
	id: Scalars["ID"]
	timestamp: Scalars["BigInt"]
}

export type TransactionEventsArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<Event_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<Event_Filter>
}

export type Transaction_Filter = {
	blockNumber?: InputMaybe<Scalars["BigInt"]>
	blockNumber_gt?: InputMaybe<Scalars["BigInt"]>
	blockNumber_gte?: InputMaybe<Scalars["BigInt"]>
	blockNumber_in?: InputMaybe<Array<Scalars["BigInt"]>>
	blockNumber_lt?: InputMaybe<Scalars["BigInt"]>
	blockNumber_lte?: InputMaybe<Scalars["BigInt"]>
	blockNumber_not?: InputMaybe<Scalars["BigInt"]>
	blockNumber_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum Transaction_OrderBy {
	BlockNumber = "blockNumber",
	Events = "events",
	Id = "id",
	Timestamp = "timestamp",
}

export type Transfer = {
	__typename?: "Transfer"
	from: Scalars["Bytes"]
	id: Scalars["ID"]
	to: Scalars["Bytes"]
	value: Scalars["BigInt"]
}

export type Transfer_Filter = {
	from?: InputMaybe<Scalars["Bytes"]>
	from_contains?: InputMaybe<Scalars["Bytes"]>
	from_in?: InputMaybe<Array<Scalars["Bytes"]>>
	from_not?: InputMaybe<Scalars["Bytes"]>
	from_not_contains?: InputMaybe<Scalars["Bytes"]>
	from_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	to?: InputMaybe<Scalars["Bytes"]>
	to_contains?: InputMaybe<Scalars["Bytes"]>
	to_in?: InputMaybe<Array<Scalars["Bytes"]>>
	to_not?: InputMaybe<Scalars["Bytes"]>
	to_not_contains?: InputMaybe<Scalars["Bytes"]>
	to_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	value?: InputMaybe<Scalars["BigInt"]>
	value_gt?: InputMaybe<Scalars["BigInt"]>
	value_gte?: InputMaybe<Scalars["BigInt"]>
	value_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_lt?: InputMaybe<Scalars["BigInt"]>
	value_lte?: InputMaybe<Scalars["BigInt"]>
	value_not?: InputMaybe<Scalars["BigInt"]>
	value_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum Transfer_OrderBy {
	From = "from",
	Id = "id",
	To = "to",
	Value = "value",
}

export type Unpaused = {
	__typename?: "Unpaused"
	account: Scalars["Bytes"]
	id: Scalars["ID"]
}

export type Unpaused_Filter = {
	account?: InputMaybe<Scalars["Bytes"]>
	account_contains?: InputMaybe<Scalars["Bytes"]>
	account_in?: InputMaybe<Array<Scalars["Bytes"]>>
	account_not?: InputMaybe<Scalars["Bytes"]>
	account_not_contains?: InputMaybe<Scalars["Bytes"]>
	account_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum Unpaused_OrderBy {
	Account = "account",
	Id = "id",
}

export enum VisualTraitTypeId {
	Background = "Background",
	Clothing = "Clothing",
	Ears = "Ears",
	Eyes = "Eyes",
	Head = "Head",
	Mouth = "Mouth",
	Nose = "Nose",
	Skin = "Skin",
}

export type VoteCast = Event & {
	__typename?: "VoteCast"
	emitter: Account
	governor: Governor
	id: Scalars["ID"]
	proposal: Proposal
	receipt: VoteReceipt
	support: ProposalSupport
	timestamp: Scalars["BigInt"]
	transaction: Transaction
	voter: Account
}

export type VoteCast_Filter = {
	emitter?: InputMaybe<Scalars["String"]>
	emitter_contains?: InputMaybe<Scalars["String"]>
	emitter_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_ends_with?: InputMaybe<Scalars["String"]>
	emitter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_gt?: InputMaybe<Scalars["String"]>
	emitter_gte?: InputMaybe<Scalars["String"]>
	emitter_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_lt?: InputMaybe<Scalars["String"]>
	emitter_lte?: InputMaybe<Scalars["String"]>
	emitter_not?: InputMaybe<Scalars["String"]>
	emitter_not_contains?: InputMaybe<Scalars["String"]>
	emitter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with?: InputMaybe<Scalars["String"]>
	emitter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_not_in?: InputMaybe<Array<Scalars["String"]>>
	emitter_not_starts_with?: InputMaybe<Scalars["String"]>
	emitter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	emitter_starts_with?: InputMaybe<Scalars["String"]>
	emitter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor?: InputMaybe<Scalars["String"]>
	governor_contains?: InputMaybe<Scalars["String"]>
	governor_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_ends_with?: InputMaybe<Scalars["String"]>
	governor_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_gt?: InputMaybe<Scalars["String"]>
	governor_gte?: InputMaybe<Scalars["String"]>
	governor_in?: InputMaybe<Array<Scalars["String"]>>
	governor_lt?: InputMaybe<Scalars["String"]>
	governor_lte?: InputMaybe<Scalars["String"]>
	governor_not?: InputMaybe<Scalars["String"]>
	governor_not_contains?: InputMaybe<Scalars["String"]>
	governor_not_contains_nocase?: InputMaybe<Scalars["String"]>
	governor_not_ends_with?: InputMaybe<Scalars["String"]>
	governor_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	governor_not_in?: InputMaybe<Array<Scalars["String"]>>
	governor_not_starts_with?: InputMaybe<Scalars["String"]>
	governor_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	governor_starts_with?: InputMaybe<Scalars["String"]>
	governor_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	receipt?: InputMaybe<Scalars["String"]>
	receipt_contains?: InputMaybe<Scalars["String"]>
	receipt_contains_nocase?: InputMaybe<Scalars["String"]>
	receipt_ends_with?: InputMaybe<Scalars["String"]>
	receipt_ends_with_nocase?: InputMaybe<Scalars["String"]>
	receipt_gt?: InputMaybe<Scalars["String"]>
	receipt_gte?: InputMaybe<Scalars["String"]>
	receipt_in?: InputMaybe<Array<Scalars["String"]>>
	receipt_lt?: InputMaybe<Scalars["String"]>
	receipt_lte?: InputMaybe<Scalars["String"]>
	receipt_not?: InputMaybe<Scalars["String"]>
	receipt_not_contains?: InputMaybe<Scalars["String"]>
	receipt_not_contains_nocase?: InputMaybe<Scalars["String"]>
	receipt_not_ends_with?: InputMaybe<Scalars["String"]>
	receipt_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	receipt_not_in?: InputMaybe<Array<Scalars["String"]>>
	receipt_not_starts_with?: InputMaybe<Scalars["String"]>
	receipt_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	receipt_starts_with?: InputMaybe<Scalars["String"]>
	receipt_starts_with_nocase?: InputMaybe<Scalars["String"]>
	support?: InputMaybe<Scalars["String"]>
	support_contains?: InputMaybe<Scalars["String"]>
	support_contains_nocase?: InputMaybe<Scalars["String"]>
	support_ends_with?: InputMaybe<Scalars["String"]>
	support_ends_with_nocase?: InputMaybe<Scalars["String"]>
	support_gt?: InputMaybe<Scalars["String"]>
	support_gte?: InputMaybe<Scalars["String"]>
	support_in?: InputMaybe<Array<Scalars["String"]>>
	support_lt?: InputMaybe<Scalars["String"]>
	support_lte?: InputMaybe<Scalars["String"]>
	support_not?: InputMaybe<Scalars["String"]>
	support_not_contains?: InputMaybe<Scalars["String"]>
	support_not_contains_nocase?: InputMaybe<Scalars["String"]>
	support_not_ends_with?: InputMaybe<Scalars["String"]>
	support_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	support_not_in?: InputMaybe<Array<Scalars["String"]>>
	support_not_starts_with?: InputMaybe<Scalars["String"]>
	support_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	support_starts_with?: InputMaybe<Scalars["String"]>
	support_starts_with_nocase?: InputMaybe<Scalars["String"]>
	timestamp?: InputMaybe<Scalars["BigInt"]>
	timestamp_gt?: InputMaybe<Scalars["BigInt"]>
	timestamp_gte?: InputMaybe<Scalars["BigInt"]>
	timestamp_in?: InputMaybe<Array<Scalars["BigInt"]>>
	timestamp_lt?: InputMaybe<Scalars["BigInt"]>
	timestamp_lte?: InputMaybe<Scalars["BigInt"]>
	timestamp_not?: InputMaybe<Scalars["BigInt"]>
	timestamp_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	transaction?: InputMaybe<Scalars["String"]>
	transaction_contains?: InputMaybe<Scalars["String"]>
	transaction_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_ends_with?: InputMaybe<Scalars["String"]>
	transaction_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_gt?: InputMaybe<Scalars["String"]>
	transaction_gte?: InputMaybe<Scalars["String"]>
	transaction_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_lt?: InputMaybe<Scalars["String"]>
	transaction_lte?: InputMaybe<Scalars["String"]>
	transaction_not?: InputMaybe<Scalars["String"]>
	transaction_not_contains?: InputMaybe<Scalars["String"]>
	transaction_not_contains_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with?: InputMaybe<Scalars["String"]>
	transaction_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_not_in?: InputMaybe<Array<Scalars["String"]>>
	transaction_not_starts_with?: InputMaybe<Scalars["String"]>
	transaction_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	transaction_starts_with?: InputMaybe<Scalars["String"]>
	transaction_starts_with_nocase?: InputMaybe<Scalars["String"]>
	voter?: InputMaybe<Scalars["String"]>
	voter_contains?: InputMaybe<Scalars["String"]>
	voter_contains_nocase?: InputMaybe<Scalars["String"]>
	voter_ends_with?: InputMaybe<Scalars["String"]>
	voter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	voter_gt?: InputMaybe<Scalars["String"]>
	voter_gte?: InputMaybe<Scalars["String"]>
	voter_in?: InputMaybe<Array<Scalars["String"]>>
	voter_lt?: InputMaybe<Scalars["String"]>
	voter_lte?: InputMaybe<Scalars["String"]>
	voter_not?: InputMaybe<Scalars["String"]>
	voter_not_contains?: InputMaybe<Scalars["String"]>
	voter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	voter_not_ends_with?: InputMaybe<Scalars["String"]>
	voter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	voter_not_in?: InputMaybe<Array<Scalars["String"]>>
	voter_not_starts_with?: InputMaybe<Scalars["String"]>
	voter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	voter_starts_with?: InputMaybe<Scalars["String"]>
	voter_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum VoteCast_OrderBy {
	Emitter = "emitter",
	Governor = "governor",
	Id = "id",
	Proposal = "proposal",
	Receipt = "receipt",
	Support = "support",
	Timestamp = "timestamp",
	Transaction = "transaction",
	Voter = "voter",
}

export type VoteDelegation = {
	__typename?: "VoteDelegation"
	contract: VotingContract
	delegateChangedEvent: Array<DelegateChanged>
	delegatee: Account
	delegator: Account
	id: Scalars["ID"]
}

export type VoteDelegationDelegateChangedEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateChanged_Filter>
}

export type VoteDelegation_Filter = {
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegatee?: InputMaybe<Scalars["String"]>
	delegatee_contains?: InputMaybe<Scalars["String"]>
	delegatee_contains_nocase?: InputMaybe<Scalars["String"]>
	delegatee_ends_with?: InputMaybe<Scalars["String"]>
	delegatee_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegatee_gt?: InputMaybe<Scalars["String"]>
	delegatee_gte?: InputMaybe<Scalars["String"]>
	delegatee_in?: InputMaybe<Array<Scalars["String"]>>
	delegatee_lt?: InputMaybe<Scalars["String"]>
	delegatee_lte?: InputMaybe<Scalars["String"]>
	delegatee_not?: InputMaybe<Scalars["String"]>
	delegatee_not_contains?: InputMaybe<Scalars["String"]>
	delegatee_not_contains_nocase?: InputMaybe<Scalars["String"]>
	delegatee_not_ends_with?: InputMaybe<Scalars["String"]>
	delegatee_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegatee_not_in?: InputMaybe<Array<Scalars["String"]>>
	delegatee_not_starts_with?: InputMaybe<Scalars["String"]>
	delegatee_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegatee_starts_with?: InputMaybe<Scalars["String"]>
	delegatee_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegator?: InputMaybe<Scalars["String"]>
	delegator_contains?: InputMaybe<Scalars["String"]>
	delegator_contains_nocase?: InputMaybe<Scalars["String"]>
	delegator_ends_with?: InputMaybe<Scalars["String"]>
	delegator_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegator_gt?: InputMaybe<Scalars["String"]>
	delegator_gte?: InputMaybe<Scalars["String"]>
	delegator_in?: InputMaybe<Array<Scalars["String"]>>
	delegator_lt?: InputMaybe<Scalars["String"]>
	delegator_lte?: InputMaybe<Scalars["String"]>
	delegator_not?: InputMaybe<Scalars["String"]>
	delegator_not_contains?: InputMaybe<Scalars["String"]>
	delegator_not_contains_nocase?: InputMaybe<Scalars["String"]>
	delegator_not_ends_with?: InputMaybe<Scalars["String"]>
	delegator_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	delegator_not_in?: InputMaybe<Array<Scalars["String"]>>
	delegator_not_starts_with?: InputMaybe<Scalars["String"]>
	delegator_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	delegator_starts_with?: InputMaybe<Scalars["String"]>
	delegator_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum VoteDelegation_OrderBy {
	Contract = "contract",
	DelegateChangedEvent = "delegateChangedEvent",
	Delegatee = "delegatee",
	Delegator = "delegator",
	Id = "id",
}

export type VoteReceipt = {
	__typename?: "VoteReceipt"
	id: Scalars["ID"]
	proposal: Proposal
	reason: Scalars["String"]
	support: ProposalSupport
	voter: Account
	weight: Scalars["BigInt"]
}

export type VoteReceipt_Filter = {
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	proposal?: InputMaybe<Scalars["String"]>
	proposal_contains?: InputMaybe<Scalars["String"]>
	proposal_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_ends_with?: InputMaybe<Scalars["String"]>
	proposal_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_gt?: InputMaybe<Scalars["String"]>
	proposal_gte?: InputMaybe<Scalars["String"]>
	proposal_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_lt?: InputMaybe<Scalars["String"]>
	proposal_lte?: InputMaybe<Scalars["String"]>
	proposal_not?: InputMaybe<Scalars["String"]>
	proposal_not_contains?: InputMaybe<Scalars["String"]>
	proposal_not_contains_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with?: InputMaybe<Scalars["String"]>
	proposal_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_not_in?: InputMaybe<Array<Scalars["String"]>>
	proposal_not_starts_with?: InputMaybe<Scalars["String"]>
	proposal_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	proposal_starts_with?: InputMaybe<Scalars["String"]>
	proposal_starts_with_nocase?: InputMaybe<Scalars["String"]>
	reason?: InputMaybe<Scalars["String"]>
	reason_contains?: InputMaybe<Scalars["String"]>
	reason_contains_nocase?: InputMaybe<Scalars["String"]>
	reason_ends_with?: InputMaybe<Scalars["String"]>
	reason_ends_with_nocase?: InputMaybe<Scalars["String"]>
	reason_gt?: InputMaybe<Scalars["String"]>
	reason_gte?: InputMaybe<Scalars["String"]>
	reason_in?: InputMaybe<Array<Scalars["String"]>>
	reason_lt?: InputMaybe<Scalars["String"]>
	reason_lte?: InputMaybe<Scalars["String"]>
	reason_not?: InputMaybe<Scalars["String"]>
	reason_not_contains?: InputMaybe<Scalars["String"]>
	reason_not_contains_nocase?: InputMaybe<Scalars["String"]>
	reason_not_ends_with?: InputMaybe<Scalars["String"]>
	reason_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	reason_not_in?: InputMaybe<Array<Scalars["String"]>>
	reason_not_starts_with?: InputMaybe<Scalars["String"]>
	reason_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	reason_starts_with?: InputMaybe<Scalars["String"]>
	reason_starts_with_nocase?: InputMaybe<Scalars["String"]>
	support?: InputMaybe<Scalars["String"]>
	support_contains?: InputMaybe<Scalars["String"]>
	support_contains_nocase?: InputMaybe<Scalars["String"]>
	support_ends_with?: InputMaybe<Scalars["String"]>
	support_ends_with_nocase?: InputMaybe<Scalars["String"]>
	support_gt?: InputMaybe<Scalars["String"]>
	support_gte?: InputMaybe<Scalars["String"]>
	support_in?: InputMaybe<Array<Scalars["String"]>>
	support_lt?: InputMaybe<Scalars["String"]>
	support_lte?: InputMaybe<Scalars["String"]>
	support_not?: InputMaybe<Scalars["String"]>
	support_not_contains?: InputMaybe<Scalars["String"]>
	support_not_contains_nocase?: InputMaybe<Scalars["String"]>
	support_not_ends_with?: InputMaybe<Scalars["String"]>
	support_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	support_not_in?: InputMaybe<Array<Scalars["String"]>>
	support_not_starts_with?: InputMaybe<Scalars["String"]>
	support_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	support_starts_with?: InputMaybe<Scalars["String"]>
	support_starts_with_nocase?: InputMaybe<Scalars["String"]>
	voter?: InputMaybe<Scalars["String"]>
	voter_contains?: InputMaybe<Scalars["String"]>
	voter_contains_nocase?: InputMaybe<Scalars["String"]>
	voter_ends_with?: InputMaybe<Scalars["String"]>
	voter_ends_with_nocase?: InputMaybe<Scalars["String"]>
	voter_gt?: InputMaybe<Scalars["String"]>
	voter_gte?: InputMaybe<Scalars["String"]>
	voter_in?: InputMaybe<Array<Scalars["String"]>>
	voter_lt?: InputMaybe<Scalars["String"]>
	voter_lte?: InputMaybe<Scalars["String"]>
	voter_not?: InputMaybe<Scalars["String"]>
	voter_not_contains?: InputMaybe<Scalars["String"]>
	voter_not_contains_nocase?: InputMaybe<Scalars["String"]>
	voter_not_ends_with?: InputMaybe<Scalars["String"]>
	voter_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	voter_not_in?: InputMaybe<Array<Scalars["String"]>>
	voter_not_starts_with?: InputMaybe<Scalars["String"]>
	voter_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	voter_starts_with?: InputMaybe<Scalars["String"]>
	voter_starts_with_nocase?: InputMaybe<Scalars["String"]>
	weight?: InputMaybe<Scalars["BigInt"]>
	weight_gt?: InputMaybe<Scalars["BigInt"]>
	weight_gte?: InputMaybe<Scalars["BigInt"]>
	weight_in?: InputMaybe<Array<Scalars["BigInt"]>>
	weight_lt?: InputMaybe<Scalars["BigInt"]>
	weight_lte?: InputMaybe<Scalars["BigInt"]>
	weight_not?: InputMaybe<Scalars["BigInt"]>
	weight_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum VoteReceipt_OrderBy {
	Id = "id",
	Proposal = "proposal",
	Reason = "reason",
	Support = "support",
	Voter = "voter",
	Weight = "weight",
}

export type VoteWeight = {
	__typename?: "VoteWeight"
	account?: Maybe<Account>
	contract: VotingContract
	delegateVotesChangedEvent: Array<DelegateVotesChanged>
	id: Scalars["ID"]
	value: Scalars["BigInt"]
}

export type VoteWeightDelegateVotesChangedEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateVotesChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateVotesChanged_Filter>
}

export type VoteWeight_Filter = {
	account?: InputMaybe<Scalars["String"]>
	account_contains?: InputMaybe<Scalars["String"]>
	account_contains_nocase?: InputMaybe<Scalars["String"]>
	account_ends_with?: InputMaybe<Scalars["String"]>
	account_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_gt?: InputMaybe<Scalars["String"]>
	account_gte?: InputMaybe<Scalars["String"]>
	account_in?: InputMaybe<Array<Scalars["String"]>>
	account_lt?: InputMaybe<Scalars["String"]>
	account_lte?: InputMaybe<Scalars["String"]>
	account_not?: InputMaybe<Scalars["String"]>
	account_not_contains?: InputMaybe<Scalars["String"]>
	account_not_contains_nocase?: InputMaybe<Scalars["String"]>
	account_not_ends_with?: InputMaybe<Scalars["String"]>
	account_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	account_not_in?: InputMaybe<Array<Scalars["String"]>>
	account_not_starts_with?: InputMaybe<Scalars["String"]>
	account_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	account_starts_with?: InputMaybe<Scalars["String"]>
	account_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract?: InputMaybe<Scalars["String"]>
	contract_contains?: InputMaybe<Scalars["String"]>
	contract_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_ends_with?: InputMaybe<Scalars["String"]>
	contract_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_gt?: InputMaybe<Scalars["String"]>
	contract_gte?: InputMaybe<Scalars["String"]>
	contract_in?: InputMaybe<Array<Scalars["String"]>>
	contract_lt?: InputMaybe<Scalars["String"]>
	contract_lte?: InputMaybe<Scalars["String"]>
	contract_not?: InputMaybe<Scalars["String"]>
	contract_not_contains?: InputMaybe<Scalars["String"]>
	contract_not_contains_nocase?: InputMaybe<Scalars["String"]>
	contract_not_ends_with?: InputMaybe<Scalars["String"]>
	contract_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	contract_not_in?: InputMaybe<Array<Scalars["String"]>>
	contract_not_starts_with?: InputMaybe<Scalars["String"]>
	contract_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	contract_starts_with?: InputMaybe<Scalars["String"]>
	contract_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	value?: InputMaybe<Scalars["BigInt"]>
	value_gt?: InputMaybe<Scalars["BigInt"]>
	value_gte?: InputMaybe<Scalars["BigInt"]>
	value_in?: InputMaybe<Array<Scalars["BigInt"]>>
	value_lt?: InputMaybe<Scalars["BigInt"]>
	value_lte?: InputMaybe<Scalars["BigInt"]>
	value_not?: InputMaybe<Scalars["BigInt"]>
	value_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
}

export enum VoteWeight_OrderBy {
	Account = "account",
	Contract = "contract",
	DelegateVotesChangedEvent = "delegateVotesChangedEvent",
	Id = "id",
	Value = "value",
}

export type VotingContract = {
	__typename?: "VotingContract"
	asAccount: Account
	delegateChangedEvent: Array<DelegateChanged>
	delegateVotesChangedEvent: Array<DelegateVotesChanged>
	delegation: Array<VoteDelegation>
	id: Scalars["ID"]
	totalWeight: VoteWeight
	weight: Array<VoteWeight>
}

export type VotingContractDelegateChangedEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateChanged_Filter>
}

export type VotingContractDelegateVotesChangedEventArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<DelegateVotesChanged_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<DelegateVotesChanged_Filter>
}

export type VotingContractDelegationArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteDelegation_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteDelegation_Filter>
}

export type VotingContractWeightArgs = {
	first?: InputMaybe<Scalars["Int"]>
	orderBy?: InputMaybe<VoteWeight_OrderBy>
	orderDirection?: InputMaybe<OrderDirection>
	skip?: InputMaybe<Scalars["Int"]>
	where?: InputMaybe<VoteWeight_Filter>
}

export type VotingContract_Filter = {
	asAccount?: InputMaybe<Scalars["String"]>
	asAccount_contains?: InputMaybe<Scalars["String"]>
	asAccount_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_gt?: InputMaybe<Scalars["String"]>
	asAccount_gte?: InputMaybe<Scalars["String"]>
	asAccount_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_lt?: InputMaybe<Scalars["String"]>
	asAccount_lte?: InputMaybe<Scalars["String"]>
	asAccount_not?: InputMaybe<Scalars["String"]>
	asAccount_not_contains?: InputMaybe<Scalars["String"]>
	asAccount_not_contains_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with?: InputMaybe<Scalars["String"]>
	asAccount_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_not_in?: InputMaybe<Array<Scalars["String"]>>
	asAccount_not_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	asAccount_starts_with?: InputMaybe<Scalars["String"]>
	asAccount_starts_with_nocase?: InputMaybe<Scalars["String"]>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
	totalWeight?: InputMaybe<Scalars["String"]>
	totalWeight_contains?: InputMaybe<Scalars["String"]>
	totalWeight_contains_nocase?: InputMaybe<Scalars["String"]>
	totalWeight_ends_with?: InputMaybe<Scalars["String"]>
	totalWeight_ends_with_nocase?: InputMaybe<Scalars["String"]>
	totalWeight_gt?: InputMaybe<Scalars["String"]>
	totalWeight_gte?: InputMaybe<Scalars["String"]>
	totalWeight_in?: InputMaybe<Array<Scalars["String"]>>
	totalWeight_lt?: InputMaybe<Scalars["String"]>
	totalWeight_lte?: InputMaybe<Scalars["String"]>
	totalWeight_not?: InputMaybe<Scalars["String"]>
	totalWeight_not_contains?: InputMaybe<Scalars["String"]>
	totalWeight_not_contains_nocase?: InputMaybe<Scalars["String"]>
	totalWeight_not_ends_with?: InputMaybe<Scalars["String"]>
	totalWeight_not_ends_with_nocase?: InputMaybe<Scalars["String"]>
	totalWeight_not_in?: InputMaybe<Array<Scalars["String"]>>
	totalWeight_not_starts_with?: InputMaybe<Scalars["String"]>
	totalWeight_not_starts_with_nocase?: InputMaybe<Scalars["String"]>
	totalWeight_starts_with?: InputMaybe<Scalars["String"]>
	totalWeight_starts_with_nocase?: InputMaybe<Scalars["String"]>
}

export enum VotingContract_OrderBy {
	AsAccount = "asAccount",
	DelegateChangedEvent = "delegateChangedEvent",
	DelegateVotesChangedEvent = "delegateVotesChangedEvent",
	Delegation = "delegation",
	Id = "id",
	TotalWeight = "totalWeight",
	Weight = "weight",
}

export type WithdrawFarmer = {
	__typename?: "WithdrawFarmer"
	blocksStaked: Scalars["BigInt"]
	depositor: Scalars["Bytes"]
	farmerId: Scalars["BigInt"]
	id: Scalars["ID"]
}

export type WithdrawFarmer_Filter = {
	blocksStaked?: InputMaybe<Scalars["BigInt"]>
	blocksStaked_gt?: InputMaybe<Scalars["BigInt"]>
	blocksStaked_gte?: InputMaybe<Scalars["BigInt"]>
	blocksStaked_in?: InputMaybe<Array<Scalars["BigInt"]>>
	blocksStaked_lt?: InputMaybe<Scalars["BigInt"]>
	blocksStaked_lte?: InputMaybe<Scalars["BigInt"]>
	blocksStaked_not?: InputMaybe<Scalars["BigInt"]>
	blocksStaked_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	depositor?: InputMaybe<Scalars["Bytes"]>
	depositor_contains?: InputMaybe<Scalars["Bytes"]>
	depositor_in?: InputMaybe<Array<Scalars["Bytes"]>>
	depositor_not?: InputMaybe<Scalars["Bytes"]>
	depositor_not_contains?: InputMaybe<Scalars["Bytes"]>
	depositor_not_in?: InputMaybe<Array<Scalars["Bytes"]>>
	farmerId?: InputMaybe<Scalars["BigInt"]>
	farmerId_gt?: InputMaybe<Scalars["BigInt"]>
	farmerId_gte?: InputMaybe<Scalars["BigInt"]>
	farmerId_in?: InputMaybe<Array<Scalars["BigInt"]>>
	farmerId_lt?: InputMaybe<Scalars["BigInt"]>
	farmerId_lte?: InputMaybe<Scalars["BigInt"]>
	farmerId_not?: InputMaybe<Scalars["BigInt"]>
	farmerId_not_in?: InputMaybe<Array<Scalars["BigInt"]>>
	id?: InputMaybe<Scalars["ID"]>
	id_gt?: InputMaybe<Scalars["ID"]>
	id_gte?: InputMaybe<Scalars["ID"]>
	id_in?: InputMaybe<Array<Scalars["ID"]>>
	id_lt?: InputMaybe<Scalars["ID"]>
	id_lte?: InputMaybe<Scalars["ID"]>
	id_not?: InputMaybe<Scalars["ID"]>
	id_not_in?: InputMaybe<Array<Scalars["ID"]>>
}

export enum WithdrawFarmer_OrderBy {
	BlocksStaked = "blocksStaked",
	Depositor = "depositor",
	FarmerId = "farmerId",
	Id = "id",
}

export type _Block_ = {
	__typename?: "_Block_"
	/** The hash of the block */
	hash?: Maybe<Scalars["Bytes"]>
	/** The block number */
	number: Scalars["Int"]
}

/** The type for the top-level _meta field */
export type _Meta_ = {
	__typename?: "_Meta_"
	/**
	 * Information about a specific subgraph block. The hash of the block
	 * will be null if the _meta field has a block constraint that asks for
	 * a block number. It will be filled if the _meta field has no block constraint
	 * and therefore asks for the latest  block
	 *
	 */
	block: _Block_
	/** The deployment ID */
	deployment: Scalars["String"]
	/** If `true`, the subgraph encountered indexing errors at some past block */
	hasIndexingErrors: Scalars["Boolean"]
}

export enum _SubgraphErrorPolicy_ {
	/** Data will be returned even if the subgraph has indexing errors */
	Allow = "allow",
	/** If the subgraph has indexing errors, data will be omitted. The default. */
	Deny = "deny",
}

export type Erc1155OperatorApprovalsQueryVariables = Exact<{
	owners: Array<Scalars["String"]> | Scalars["String"]
	operators?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>
}>

export type Erc1155OperatorApprovalsQuery = {
	__typename?: "Query"
	erc1155Operators: Array<{
		__typename?: "ERC1155Operator"
		id: string
		approved: boolean
		operator: { __typename?: "Account"; id: string }
		owner: { __typename?: "Account"; id: string }
		contract: { __typename?: "ERC1155Contract"; id: string }
	}>
}

export type Erc1155TokensQueryVariables = Exact<{
	where?: InputMaybe<Erc1155Balance_Filter>
}>

export type Erc1155TokensQuery = {
	__typename?: "Query"
	erc1155Balances: Array<{
		__typename?: "ERC1155Balance"
		id: string
		token: { __typename?: "ERC1155Token"; identifier: any }
	}>
}

export type FarmersQueryVariables = Exact<{
	identifiers: Array<Scalars["BigInt"]> | Scalars["BigInt"]
}>

export type FarmersQuery = {
	__typename?: "Query"
	erc1155Tokens: Array<{
		__typename?: "ERC1155Token"
		id: string
		identifier: any
		uri?: string | null
	}>
}

export type MyPotatoesQueryVariables = Exact<{
	where?: InputMaybe<Erc20Balance_Filter>
	first?: InputMaybe<Scalars["Int"]>
	orderDirection?: InputMaybe<OrderDirection>
}>

export type MyPotatoesQuery = {
	__typename?: "Query"
	erc20Balances: Array<{
		__typename?: "ERC20Balance"
		value: any
		valueExact: any
		account?: { __typename?: "Account"; id: string } | null
	}>
}

export type PotatoRichListQueryVariables = Exact<{
	first?: InputMaybe<Scalars["Int"]>
}>

export type PotatoRichListQuery = {
	__typename?: "Query"
	erc20Balances: Array<{
		__typename?: "ERC20Balance"
		id: string
		value: any
		account?: { __typename?: "Account"; id: string } | null
	}>
}

export const Erc1155OperatorApprovalsDocument = gql`
	query erc1155OperatorApprovals($owners: [String!]!, $operators: [String!]) {
		erc1155Operators(
			where: {
				approved: true
				owner_in: $owners
				operator_in: $operators
			}
		) {
			id
			approved
			operator {
				id
			}
			owner {
				id
			}
			contract {
				id
			}
		}
	}
`

/**
 * __useErc1155OperatorApprovalsQuery__
 *
 * To run a query within a React component, call `useErc1155OperatorApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErc1155OperatorApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErc1155OperatorApprovalsQuery({
 *   variables: {
 *      owners: // value for 'owners'
 *      operators: // value for 'operators'
 *   },
 * });
 */
export function useErc1155OperatorApprovalsQuery(
	baseOptions: Apollo.QueryHookOptions<
		Erc1155OperatorApprovalsQuery,
		Erc1155OperatorApprovalsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		Erc1155OperatorApprovalsQuery,
		Erc1155OperatorApprovalsQueryVariables
	>(Erc1155OperatorApprovalsDocument, options)
}
export function useErc1155OperatorApprovalsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Erc1155OperatorApprovalsQuery,
		Erc1155OperatorApprovalsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		Erc1155OperatorApprovalsQuery,
		Erc1155OperatorApprovalsQueryVariables
	>(Erc1155OperatorApprovalsDocument, options)
}
export type Erc1155OperatorApprovalsQueryHookResult = ReturnType<
	typeof useErc1155OperatorApprovalsQuery
>
export type Erc1155OperatorApprovalsLazyQueryHookResult = ReturnType<
	typeof useErc1155OperatorApprovalsLazyQuery
>
export type Erc1155OperatorApprovalsQueryResult = Apollo.QueryResult<
	Erc1155OperatorApprovalsQuery,
	Erc1155OperatorApprovalsQueryVariables
>
export const Erc1155TokensDocument = gql`
	query erc1155Tokens($where: ERC1155Balance_filter) {
		erc1155Balances(where: $where) {
			id
			token {
				identifier
			}
		}
	}
`

/**
 * __useErc1155TokensQuery__
 *
 * To run a query within a React component, call `useErc1155TokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useErc1155TokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErc1155TokensQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useErc1155TokensQuery(
	baseOptions?: Apollo.QueryHookOptions<
		Erc1155TokensQuery,
		Erc1155TokensQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<Erc1155TokensQuery, Erc1155TokensQueryVariables>(
		Erc1155TokensDocument,
		options,
	)
}
export function useErc1155TokensLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		Erc1155TokensQuery,
		Erc1155TokensQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<Erc1155TokensQuery, Erc1155TokensQueryVariables>(
		Erc1155TokensDocument,
		options,
	)
}
export type Erc1155TokensQueryHookResult = ReturnType<
	typeof useErc1155TokensQuery
>
export type Erc1155TokensLazyQueryHookResult = ReturnType<
	typeof useErc1155TokensLazyQuery
>
export type Erc1155TokensQueryResult = Apollo.QueryResult<
	Erc1155TokensQuery,
	Erc1155TokensQueryVariables
>
export const FarmersDocument = gql`
	query farmers($identifiers: [BigInt!]!) {
		erc1155Tokens(
			where: {
				identifier_in: $identifiers
				contract: "0x872cdfc7a1c4a2808d6c848b763f69d0abf98738"
			}
		) {
			id
			identifier
			uri
		}
	}
`

/**
 * __useFarmersQuery__
 *
 * To run a query within a React component, call `useFarmersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFarmersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmersQuery({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useFarmersQuery(
	baseOptions: Apollo.QueryHookOptions<FarmersQuery, FarmersQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<FarmersQuery, FarmersQueryVariables>(
		FarmersDocument,
		options,
	)
}
export function useFarmersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FarmersQuery,
		FarmersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<FarmersQuery, FarmersQueryVariables>(
		FarmersDocument,
		options,
	)
}
export type FarmersQueryHookResult = ReturnType<typeof useFarmersQuery>
export type FarmersLazyQueryHookResult = ReturnType<typeof useFarmersLazyQuery>
export type FarmersQueryResult = Apollo.QueryResult<
	FarmersQuery,
	FarmersQueryVariables
>
export const MyPotatoesDocument = gql`
	query myPotatoes(
		$where: ERC20Balance_filter
		$first: Int
		$orderDirection: OrderDirection
	) {
		erc20Balances(
			where: $where
			first: $first
			orderDirection: $orderDirection
		) {
			value
			valueExact
			account {
				id
			}
		}
	}
`

/**
 * __useMyPotatoesQuery__
 *
 * To run a query within a React component, call `useMyPotatoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPotatoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPotatoesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useMyPotatoesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MyPotatoesQuery,
		MyPotatoesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<MyPotatoesQuery, MyPotatoesQueryVariables>(
		MyPotatoesDocument,
		options,
	)
}
export function useMyPotatoesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MyPotatoesQuery,
		MyPotatoesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<MyPotatoesQuery, MyPotatoesQueryVariables>(
		MyPotatoesDocument,
		options,
	)
}
export type MyPotatoesQueryHookResult = ReturnType<typeof useMyPotatoesQuery>
export type MyPotatoesLazyQueryHookResult = ReturnType<
	typeof useMyPotatoesLazyQuery
>
export type MyPotatoesQueryResult = Apollo.QueryResult<
	MyPotatoesQuery,
	MyPotatoesQueryVariables
>
export const PotatoRichListDocument = gql`
	query potatoRichList($first: Int) {
		erc20Balances(
			orderBy: value
			orderDirection: desc
			first: $first
			where: { contract: "0x05f6b48bc567c8dd39d2078c9af3ff0a954af6ff" }
		) {
			id
			value
			account {
				id
			}
		}
	}
`

/**
 * __usePotatoRichListQuery__
 *
 * To run a query within a React component, call `usePotatoRichListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotatoRichListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotatoRichListQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePotatoRichListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		PotatoRichListQuery,
		PotatoRichListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<PotatoRichListQuery, PotatoRichListQueryVariables>(
		PotatoRichListDocument,
		options,
	)
}
export function usePotatoRichListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PotatoRichListQuery,
		PotatoRichListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		PotatoRichListQuery,
		PotatoRichListQueryVariables
	>(PotatoRichListDocument, options)
}
export type PotatoRichListQueryHookResult = ReturnType<
	typeof usePotatoRichListQuery
>
export type PotatoRichListLazyQueryHookResult = ReturnType<
	typeof usePotatoRichListLazyQuery
>
export type PotatoRichListQueryResult = Apollo.QueryResult<
	PotatoRichListQuery,
	PotatoRichListQueryVariables
>
